(function() {
  "use strict";
  try {
    if (typeof document != "undefined") {
      var elementStyle = document.createElement("style");
      elementStyle.appendChild(document.createTextNode(`.tui-theme-white .button-primary[data-v-76556122] {
  --shadow-color: rgba(213, 224, 242, 0.6);
}
.tui-theme-black .button-primary[data-v-76556122] {
  --shadow-color: rgba(28, 102, 229, 0.2);
}
.tui-button[data-v-76556122] {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: 400;
  line-height: 22px;
  color: var(--font-color-7);
  text-align: center;
  white-space: nowrap;
  cursor: pointer;
  background-color: var(--active-color-1);
  border: 1px solid var(--active-color-1);
  outline: none;
  transition: background-color 0.2s ease-in-out;
}
.tui-button[data-v-76556122]:hover {
  background: #144fb6;
  border: 1px solid #144fb6;
  outline: none;
}
.tui-button-plain.tui-button-primary[data-v-76556122] {
  color: #0961f7;
  background: #ecf5ff;
  border-color: #b3d8ff;
}
.tui-button-plain.tui-button-primary[data-v-76556122]:hover {
  color: #fff;
  background: #409eff;
  border-color: #409eff;
}
.tui-button-plain.tui-button-info[data-v-76556122] {
  color: #909399;
  background: #f4f4f5;
  border-color: #d3d4d6;
}
.tui-button-plain.tui-button-info[data-v-76556122]:hover {
  color: #fff;
  background: #909399;
  border-color: #909399;
}
.tui-button-plain.tui-button-danger[data-v-76556122] {
  font-weight: 500;
  color: #f56c6c;
  background: #fef0f0;
  border-color: #fbc4c4;
}
.tui-button-plain.tui-button-danger[data-v-76556122]:hover {
  color: #fff;
  background: #f56c6c;
  border-color: #f56c6c;
}
.tui-button-primary[data-v-76556122] {
  font-size: 14px;
  font-weight: 500;
  line-height: 22px;
  color: var(--active-color-2);
  background-color: transparent;
  border: 1px solid var(--active-color-2);
}
.tui-button-primary[data-v-76556122]:hover {
  background-color: var(--shadow-color);
}
.tui-button-large[data-v-76556122] {
  padding: 19px 48px;
  font-size: 20px;
}
.tui-button-default[data-v-76556122] {
  padding: 5px 30px;
  font-size: 14px;
}
.tui-button-round[data-v-76556122] {
  border-radius: 999999px;
}
.tui-button-disabled[data-v-76556122] {
  pointer-events: none;
  cursor: not-allowed;
  opacity: 0.4;
}
.tui-button-icon[data-v-76556122] {
  display: flex;
  margin-right: 5px;
}
.tui-button-text[data-v-76556122] {
  color: var(--font-color-4);
  background-color: transparent;
  border: 0 solid transparent;
}
.tui-button-text[data-v-76556122]:hover {
  color: var(--font-color-4);
  background-color: transparent;
  border: 0 solid transparent;
}
.tui-button-text[data-v-76556122]::after {
  border: none;
}.svg-icon[data-v-a9f14938] {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}.message-box-overlay[data-v-bae9d3c4] {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.message-box-overlay.overlay[data-v-bae9d3c4] {
  background-color: rgba(15, 16, 20, 0.6);
}
.tui-message-box[data-v-bae9d3c4] {
  position: absolute;
  top: 50%;
  left: 50%;
  display: flex;
  flex-direction: column;
  width: 480px;
  background-color: var(--white-color);
  border-radius: 20px;
  transform: translate(-50%, -50%);
}
.tui-message-box .tui-message-box-header[data-v-bae9d3c4] {
  position: relative;
  display: flex;
  align-items: center;
  height: 64px;
  padding: 0 24px;
  color: var(--title-color);
  box-shadow: 0 7px 10px -5px rgba(230, 236, 245, 0.8);
}
.tui-message-box .tui-message-box-header .tui-dialog-header-title[data-v-bae9d3c4] {
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  color: #0f1014;
}
.tui-message-box .tui-message-box-header .close[data-v-bae9d3c4] {
  position: absolute;
  top: 50%;
  right: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  color: #4f586b;
  cursor: pointer;
  transform: translateY(-50%);
}
.tui-message-box .tui-message-box-body[data-v-bae9d3c4] {
  flex: 1;
  padding: 20px 24px;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
  color: #4f586b;
}
.tui-message-box .tui-message-box-footer[data-v-bae9d3c4] {
  display: flex;
  justify-content: center;
  padding: 20px 30px;
}
.tui-message-box .tui-message-box-footer[data-v-bae9d3c4] > :not(:first-child) {
  margin-left: 16px;
}
.tui-message-box-h5[data-v-bae9d3c4] {
  position: fixed;
  top: 50%;
  left: 50%;
  display: flex;
  flex-direction: column;
  min-width: 80vw;
  max-width: 80vw;
  font-style: normal;
  color: var(--black-color);
  background-color: #fff;
  border-radius: 8px;
  transform: translate(-50%, -50%);
}
.tui-message-box-h5 .tui-message-box-header[data-v-bae9d3c4] {
  box-sizing: border-box;
  display: inline-block;
  padding: 24px 24px 12px;
  padding-top: 14px;
  font-size: 16px;
  font-weight: 500;
  text-align: center;
}
.tui-message-box-h5 .tui-message-box-header .close[data-v-bae9d3c4] {
  display: none;
}
.tui-message-box-h5 .tui-message-box-body[data-v-bae9d3c4] {
  padding: 0 24px 20px;
  font-size: 14px;
  font-weight: 400;
  color: var(--font-color-4);
  text-align: center;
}
.tui-message-box-h5 .tui-message-box-footer[data-v-bae9d3c4] {
  display: flex;
  justify-content: space-around;
  width: 100%;
  border-top: 1px solid #d5e0f2;
}
.tui-message-box-h5 .tui-message-box-footer .button-container[data-v-bae9d3c4] {
  display: flex;
  flex: 1;
  justify-content: center;
  padding: 11px 0;
}
.tui-message-box-h5 .tui-message-box-footer .button-container[data-v-bae9d3c4]:not(:first-child) {
  border-left: 1px solid #d5e0f2;
}
.tui-message-box-h5 .tui-message-box-footer .button[data-v-bae9d3c4] {
  font-size: 16px;
  font-weight: 500;
}
.tui-message-box-h5 .tui-message-box-footer .confirm-button[data-v-bae9d3c4] {
  color: var(--active-color-1);
  text-align: center;
  background-color: #fff;
  border: none;
}.message-enter-from[data-v-769d2e00] {
  opacity: 0;
  transform: translate3d(0, -75px, 0);
}
.message-enter-active[data-v-769d2e00] {
  transition: all 0.3s;
}
.message-enter-to[data-v-769d2e00] {
  opacity: 1;
  transform: none;
}
.t-message[data-v-769d2e00] {
  position: fixed;
  top: 6%;
  left: 50%;
  z-index: 9999;
  padding: 10px;
  color: #999;
  white-space: nowrap;
  background: #f5f5f5;
  border-radius: 8px;
  transform: translateX(-50%);
}
.t-message .t-message-text[data-v-769d2e00] {
  font-size: 0.875rem;
  vertical-align: middle;
}
.t-message .t-message-icon[data-v-769d2e00] {
  display: inline-block;
  width: 20px;
  height: 20px;
  margin-right: 4px;
  vertical-align: middle;
  background-size: cover;
}
.tui-theme-white .t-message.t-message-error[data-v-769d2e00] {
  color: #E04343;
  background-color: #FFEBEE;
}
.tui-theme-black .t-message.t-message-error[data-v-769d2e00] {
  color: #F46262;
  background-color: #421414;
}
.tui-theme-white .t-message.t-message-success[data-v-769d2e00] {
  color: #00B89C;
  background-color: #EBFFFA;
}
.tui-theme-black .t-message.t-message-success[data-v-769d2e00] {
  color: #1CEACB;
  background-color: #19423C;
}
.tui-theme-white .t-message.t-message-warning[data-v-769d2e00] {
  color: #E59753;
  background-color: #FFF4EB;
}
.tui-theme-black .t-message.t-message-warning[data-v-769d2e00] {
  color: #FFAD66;
  background-color: #3F2712;
}
.tui-theme-white .t-message.t-message-info[data-v-769d2e00] {
  color: #494F6A;
  background-color: #EBF2FF;
}
.tui-theme-black .t-message.t-message-info[data-v-769d2e00] {
  color: #DCE7FA;
  background-color: #4A506B;
}.popup-container[data-v-c7ee8fe3] {
  position: static;
  flex: 1;
  width: 100vw;
  height: 100%;
  background: var(--room-detail-background);
}
.popup-container .popup-main-header[data-v-c7ee8fe3] {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 60px;
}
.popup-container .popup-main-header .icon-container[data-v-c7ee8fe3] {
  position: absolute;
  top: 0;
  left: 0;
  box-sizing: content-box;
  width: 10px;
  height: 18px;
  padding: 20px 25px;
  background-size: cover;
}
.popup-container .popup-main-header .sidebar-title[data-v-c7ee8fe3] {
  font-family: "PingFang SC";
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 22px;
  color: var(--input-font-color);
  text-align: center;
}
.popup-container .popup-main-header .close-icon[data-v-c7ee8fe3] {
  width: 10px;
  height: 18px;
  background-size: cover;
}
.popup-container .popup-main-content[data-v-c7ee8fe3] {
  width: 100%;
  height: calc(100% - 130px);
  overflow: hidden;
}
.popup-container .popup-main-footer[data-v-c7ee8fe3] {
  position: sticky;
  bottom: 0;
  width: 100%;
  height: auto;
  padding-top: 10px;
}.avatar-container[data-v-460d4fdf] {
  position: relative;
  width: 100%;
  height: 100%;
}
.avatar-container .avatar[data-v-460d4fdf] {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 50%;
}.end-control-container .end-button[data-v-80000a1b] {
  display: flex;
  font-size: 12px;
  font-weight: 400;
  line-height: 21px;
  color: #ff2e2e;
  text-align: center;
  letter-spacing: 0;
  cursor: pointer;
}
.end-control-container .end-button .end-button-title[data-v-80000a1b] {
  margin-left: 3px;
  white-space: nowrap;
}
.dialog-middle-content[data-v-80000a1b] {
  display: flex;
  flex-direction: column;
  width: 100%;
}
.end-main-content[data-v-80000a1b] {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  box-sizing: border-box;
  width: 100vw;
  height: auto;
  background-color: var(--log-out-mobile);
  backdrop-filter: blur(10px);
}
.end-main-content .end-dialog-leave[data-v-80000a1b],
.end-main-content .end-dialog-dismiss[data-v-80000a1b] {
  position: fixed;
  right: 0;
  bottom: 10vh;
  left: 0;
  z-index: 9;
  width: 90%;
  margin: auto;
  border-radius: 14px;
}
.end-main-content .end-dialog-leave .manage-transfer[data-v-80000a1b],
.end-main-content .end-dialog-dismiss .manage-transfer[data-v-80000a1b] {
  position: absolute;
  top: 0;
}
.end-main-content .end-dialog-leave .end-dialog-header[data-v-80000a1b],
.end-main-content .end-dialog-dismiss .end-dialog-header[data-v-80000a1b] {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 56px;
  margin: 0 auto;
  font-family: "PingFang SC";
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 17px;
  color: #6a6c74;
  text-align: center;
  background: #cacacb;
  border-bottom: 0.5px solid #4f4e4e;
  border-top-left-radius: 14px;
  border-top-right-radius: 14px;
}
.end-main-content .end-dialog-leave .end-dialog-header .end-dialog-text[data-v-80000a1b],
.end-main-content .end-dialog-dismiss .end-dialog-header .end-dialog-text[data-v-80000a1b] {
  width: 230px;
}
.end-main-content .end-dialog-leave .end-button-dismiss[data-v-80000a1b],
.end-main-content .end-dialog-leave .end-button-leave[data-v-80000a1b],
.end-main-content .end-dialog-leave .end-button-cancel[data-v-80000a1b],
.end-main-content .end-dialog-leave .end-button-leave-single[data-v-80000a1b],
.end-main-content .end-dialog-dismiss .end-button-dismiss[data-v-80000a1b],
.end-main-content .end-dialog-dismiss .end-button-leave[data-v-80000a1b],
.end-main-content .end-dialog-dismiss .end-button-cancel[data-v-80000a1b],
.end-main-content .end-dialog-dismiss .end-button-leave-single[data-v-80000a1b] {
  width: 100%;
  padding: 20px 0;
  font-family: "PingFang SC";
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  color: #ff2e2e;
  text-align: center;
  background: #cacacb;
  border-style: none;
}
.end-main-content .end-dialog-leave .end-button-leave[data-v-80000a1b],
.end-main-content .end-dialog-dismiss .end-button-leave[data-v-80000a1b] {
  color: #007aff;
  border-top: 0.5px solid #8f8e8e;
  border-bottom-right-radius: 14px;
  border-bottom-left-radius: 14px;
}
.end-main-content .end-dialog-leave .end-button-leave-single[data-v-80000a1b],
.end-main-content .end-dialog-dismiss .end-button-leave-single[data-v-80000a1b] {
  position: absolute;
  bottom: 1vh;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 14px;
}
.end-main-content .end-dialog-leave .end-button-cancel[data-v-80000a1b],
.end-main-content .end-dialog-dismiss .end-button-cancel[data-v-80000a1b] {
  position: absolute;
  bottom: -9vh;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  color: #007aff;
  background-color: #fff;
  border-radius: 14px;
}
.end-main-content .end-dialog-dismiss[data-v-80000a1b] {
  bottom: 12vh;
}
.end-main-content .end-dialog-dismiss .end-button-cancel[data-v-80000a1b] {
  bottom: -9vh;
}
.transfer-container[data-v-80000a1b] {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 102;
  height: 100vh;
}
.transfer-container .transfer-list-container[data-v-80000a1b] {
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
}
.transfer-container .transfer-header[data-v-80000a1b] {
  display: flex;
  justify-content: center;
  padding: 0 16px;
}
.transfer-container .transfer-header .search-container[data-v-80000a1b] {
  display: flex;
  flex: 1;
  align-items: center;
  height: 34px;
  padding: 0 16px;
  color: #676c80;
  caret-color: var(--caret-color);
  background-color: var(--transfer-input-color-h5);
  border-radius: 8px;
}
.transfer-container .transfer-header .search-container .searching-input[data-v-80000a1b] {
  width: 100%;
  background: none;
  border: none;
  outline: none;
}
.transfer-container .transfer-header .search-container .searching-input[data-v-80000a1b] ::placeholder {
  font-size: 16px;
  line-height: 18px;
  color: #676c80;
}
.transfer-container .transfer-header .search-container .searching-input[data-v-80000a1b]:focus-visible {
  outline: none;
}
.transfer-container .transfer-body[data-v-80000a1b] {
  display: flex;
  flex: 1;
  flex-direction: column;
  min-height: 0;
  margin-top: 20px;
  overflow-y: scroll;
}
.transfer-container .transfer-body .transfer-list-content[data-v-80000a1b] {
  padding-bottom: 5px;
}
.transfer-container .transfer-body .transfer-list-content .transfer-item-container[data-v-80000a1b] {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  height: 69px;
  padding: 0 32px;
}
.transfer-container .transfer-body .transfer-list-content .member-basic-info[data-v-80000a1b] {
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  padding: 24px 20px 0 24px;
}
.transfer-container .transfer-body .transfer-list-content .member-basic-info .avatar-url[data-v-80000a1b] {
  width: 40px !important;
  height: 40px !important;
  border-radius: 50%;
}
.transfer-container .transfer-body .transfer-list-content .member-basic-info .user-name[data-v-80000a1b] {
  display: flex;
  max-width: 70% !important;
  margin-left: 9px;
  overflow: hidden;
  font-family: "PingFang SC";
  font-size: 16px !important;
  font-style: normal;
  font-weight: 500;
  line-height: 22px;
  color: var(--input-font-color);
  text-overflow: ellipsis;
  letter-spacing: -0.24px;
  white-space: nowrap;
}
.transfer-container .transfer-body .transfer-list-content .member-basic-info .correct[data-v-80000a1b] {
  position: absolute;
  right: 5vw;
  width: 24px;
  height: 16px;
  background-size: cover;
}
.transfer-container .transfer-body .member-has-no-data[data-v-80000a1b] {
  position: fixed;
  top: 30%;
  left: 30%;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40vw;
  height: 5vh;
  color: var(--input-font-color);
  background-color: var(--message-list-color);
  border-radius: 4px;
}
.transfer-leave[data-v-80000a1b] {
  position: fixed;
  bottom: 2vh;
  left: 7vw;
  display: flex;
  align-items: center;
  justify-content: center;
}
.transfer-leave .transfer-button[data-v-80000a1b] {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 86vw;
  height: 5vh;
  font-family: "PingFang SC";
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 22px;
  color: #fff;
  text-align: center;
  background: linear-gradient(315deg, #006eff 0%, #0c59f2 98.81%);
  border-style: none;
  border-radius: 8px;
}.select-container[data-v-449c26d8] {
  position: relative;
  height: 100%;
}
.select-container .select-content[data-v-449c26d8] {
  position: relative;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  height: 42px;
  padding: 0 16px;
  color: var(--font-color-3);
  cursor: pointer;
  background-color: var(--background-color-7);
  border: 1px solid var(--border-color);
  border-radius: 8px;
}
.select-container .select-content.disabled[data-v-449c26d8] {
  color: #8f9ab2;
  cursor: not-allowed;
  background-color: rgba(255, 255, 255, 0.5);
}
.select-container .select-content .select-text[data-v-449c26d8] {
  flex: 1;
  width: 0;
  overflow: hidden;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 22px;
  white-space: nowrap;
}
.select-container .select-content .arrow-icon[data-v-449c26d8] {
  margin-left: 10px;
  transition: transform 0.2s;
  transform: rotate(0deg);
}
.select-container .select-content .arrow-icon.reverse[data-v-449c26d8] {
  transform: rotate(-180deg);
}
.select-container .select-dropdown-container[data-v-449c26d8] {
  position: absolute;
  min-width: 100%;
  max-height: 254px;
  padding: 7px 0;
  overflow: auto;
  background-color: var(--background-color-7);
  border: 1px solid var(--border-color);
  border-radius: 8px;
}
.select-container .select-dropdown-container.down[data-v-449c26d8] {
  top: calc(100% + 6px);
  left: 0;
  transform-origin: 50% 0;
}
.select-container .select-dropdown-container.up[data-v-449c26d8] {
  bottom: calc(100% + 6px);
  left: 0;
  transform-origin: 50% 100%;
}
.select-fade-enter-active[data-v-449c26d8],
.select-fade-leave-to[data-v-449c26d8] {
  opacity: 0;
  transition: all 0.2s ease;
  transform: scaleY(0);
}
.select-fade-enter-to[data-v-449c26d8],
.select-fade-leave-from[data-v-449c26d8] {
  opacity: 1;
  transition: all 0.2s ease;
  transform: scaleY(1);
}.mask[data-v-8197131a] {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}
.container[data-v-8197131a] {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 1001;
  width: 100%;
  min-height: 120px;
  padding: 20px 12px 36px;
  background-color: #fff;
  border-radius: 18px 18px 0 0;
}
.container .container-close[data-v-8197131a] {
  display: flex;
  justify-content: center;
  padding-bottom: 12px;
  text-align: center;
}
.container .container-header[data-v-8197131a] {
  margin-bottom: 12px;
  font-size: 18px;
  font-weight: 500;
  color: #4f586b;
}.custom-select[data-v-79ae4708] {
  position: relative;
  display: flex;
  gap: 10px;
  align-items: center;
  width: 100%;
}
.custom-select .label[data-v-79ae4708] {
  display: inline-block;
  max-width: 80%;
  overflow: hidden;
  text-overflow: ellipsis;
  text-wrap: nowrap;
  white-space: nowrap;
}
.custom-option-container[data-v-79ae4708] {
  display: flex;
  flex-direction: column;
  align-items: center;
  max-height: 38vh;
  overflow: auto;
}.option-container[data-v-6aef666e] {
  padding: 6px 15px;
  overflow: hidden;
  color: #000;
  white-space: nowrap;
  cursor: pointer;
}
.option-container.active[data-v-6aef666e] {
  color: var(--active-color-2);
}
.option-container[data-v-6aef666e]:hover {
  background-color: var(--hover-background-color);
}
.option-container .option-content[data-v-6aef666e] {
  font-size: 14px;
  font-weight: 500;
  line-height: 22px;
}
.tui-theme-white .option-container[data-v-6aef666e] {
  --hover-background-color: rgba(213, 224, 242, 0.5);
}
.tui-theme-black .option-container[data-v-6aef666e] {
  --hover-background-color: rgba(213, 224, 242, 0.5);
}.custom-option[data-v-95b1b633] {
  display: inline-block;
  width: 100%;
  text-align: center;
}
.custom-option.active[data-v-95b1b633] {
  font-weight: 700;
  color: #409eff;
  background-color: #f5f7fa;
}.overlay-container[data-v-5cb03c0e] {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(15, 16, 20, 0.6);
}
.overlay-container .dialog-container[data-v-5cb03c0e] {
  position: fixed;
  top: 50%;
  left: 50%;
  display: flex;
  flex-direction: column;
  min-width: 80vw;
  font-style: normal;
  color: var(--black-color);
  background-color: #fff;
  border-radius: 8px;
  transform: translate(-50%, -50%);
}
.overlay-container .dialog-container .dialog-title[data-v-5cb03c0e] {
  box-sizing: border-box;
  display: inline-block;
  padding: 24px 24px 12px;
  padding-top: 14px;
  font-size: 16px;
  font-weight: 500;
  text-align: center;
}
.overlay-container .dialog-container .dialog-content[data-v-5cb03c0e] {
  padding: 0 24px 20px;
  font-size: 14px;
  font-weight: 400;
  color: var(--font-color-4);
  text-align: center;
}
.overlay-container .dialog-container .dialog-content-notitle[data-v-5cb03c0e] {
  padding: 40px;
  font-size: 14px;
  text-align: center;
}
.overlay-container .dialog-container .dialog-footer[data-v-5cb03c0e] {
  display: flex;
  border-top: 1px solid #d5e0f2;
}
.overlay-container .dialog-container .dialog-footer .confirm-button[data-v-5cb03c0e],
.overlay-container .dialog-container .dialog-footer .cancel-button[data-v-5cb03c0e] {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50%;
  padding: 14px;
  font-size: 16px;
  font-weight: 400;
  line-height: normal;
  color: var(--font-color-4);
  text-align: center;
}
.overlay-container .dialog-container .dialog-footer .confirm-button[data-v-5cb03c0e] {
  color: var(--active-color-1);
  border-left: 1px solid #d5e0f2;
}.overlay-container[data-v-8368f60e] {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}
.overlay-container.overlay[data-v-8368f60e] {
  background-color: rgba(15, 16, 20, 0.6);
}
.tui-dialog-container[data-v-8368f60e] {
  --tui-dialog-width: 480px;
  position: absolute;
  top: 50%;
  left: 50%;
  display: flex;
  flex-direction: column;
  width: var(--tui-dialog-width, 50%);
  background-color: #fff;
  border-radius: 20px;
  box-shadow: 0 3px 1px #e9f0fb;
  transform: translate(-50%, -50%);
}
.tui-dialog-container .tui-dialog-header[data-v-8368f60e] {
  position: relative;
  display: flex;
  align-items: center;
  height: 64px;
  padding: 0 24px;
  box-shadow: 0 1px 0 rgba(230, 236, 245, 0.8);
}
.tui-dialog-container .tui-dialog-header .tui-dialog-header-title[data-v-8368f60e] {
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  color: #0f1014;
}
.tui-dialog-container .tui-dialog-header .close[data-v-8368f60e] {
  position: absolute;
  top: 50%;
  right: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  color: #4f586b;
  cursor: pointer;
  transform: translateY(-50%);
}
.tui-dialog-container .tui-dialog-content[data-v-8368f60e] {
  flex: 1;
  padding: 20px 24px;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
  color: #4f586b;
}
.tui-dialog-container .tui-dialog-footer[data-v-8368f60e] {
  display: flex;
  justify-content: flex-end;
  padding: 20px 30px;
}.end-control-container .end-button[data-v-83d0f01a] {
  padding: 9px 20px;
  font-size: 14px;
  color: var(--red-color-2);
  border: 1.5px solid var(--red-color-2);
  border-radius: 20px;
}
.end-control-container .end-button[data-v-83d0f01a]:hover {
  color: var(--font-color-7);
  background: var(--red-color-2);
  border: 1px solid var(--red-color-2);
}
.button[data-v-83d0f01a] {
  margin-left: 20px;
}
.camera-icon[data-v-b685411f] {
  display: flex;
  background-size: cover;
}
.mirror-icon[data-v-c70cf590] {
  display: flex;
}.audio-route-icon[data-v-d81a1810] {
  display: flex;
  background-size: cover;
}.timing[data-v-108b13c2] {
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  text-align: center;
}.conference-container[data-v-6044a40a] {
  display: flex;
  justify-content: center;
  overflow: hidden;
}
.title-container[data-v-6044a40a] {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}
.title-container .title-text[data-v-6044a40a] {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}
.title-container .arrow-icon[data-v-6044a40a] {
  display: flex;
  align-items: center;
  margin-left: 5px;
  background-size: cover;
  transform: rotateX(180deg);
}
.title-container .arrow-down-icon[data-v-6044a40a] {
  transform: rotateX(0);
}
.text[data-v-6044a40a] {
  max-width: 76%;
  overflow: hidden;
  font-size: 14px;
  font-weight: 500;
  line-height: normal;
  color: var(--input-font-color);
  text-overflow: ellipsis;
  white-space: nowrap;
}
.master-header[data-v-6044a40a] {
  max-width: 300px;
  padding: 20px 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.text-right[data-v-6044a40a] {
  padding-left: 30px;
}
.text-type[data-v-6044a40a] {
  padding-left: 12px;
}
.room-info-middle[data-v-6044a40a] {
  padding-left: 25px;
  color: var(--popup-title-color-h5);
}
.room-info-container[data-v-6044a40a] {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  box-sizing: border-box;
  width: 100vw;
  height: auto;
  background-color: var(--log-out-mobile);
}
.room-info-container .room-info-container-main[data-v-6044a40a] {
  position: fixed;
  bottom: 0;
  display: flex;
  flex-direction: column;
  gap: 5px;
  width: 100%;
  padding-bottom: 4vh;
  background: var(--popup-background-color-h5);
  border-radius: 15px 15px 0 0;
  animation-name: popup-6044a40a;
  animation-duration: 200ms;
}
@keyframes popup-6044a40a {
from {
    transform: scaleY(0);
    transform-origin: bottom;
}
to {
    transform: scaleY(1);
    transform-origin: bottom;
}
}
.room-info-container .room-info-container-main .room-info-conference-title[data-v-6044a40a] {
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0 0 0 25px;
  font-family: "PingFang SC";
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  color: var(--popup-title-color-h5);
}
.room-info-container .room-info-container-main .room-info-content[data-v-6044a40a] {
  display: flex;
  align-items: stretch;
  padding: 0 25px;
  font-size: 14px;
  font-weight: 400;
  line-height: normal;
  color: var(--popup-title-color-h5);
  letter-spacing: -0.24px;
}
.room-info-container .room-info-container-main .room-info-content .room-info-title[data-v-6044a40a] {
  flex-basis: 30%;
  color: var(--title-font-color);
}
.room-info-container .room-info-container-main .room-info-content .room-info-item[data-v-6044a40a] {
  flex-basis: 50%;
  max-width: 300px;
  overflow: hidden;
  color: var(--item-font-color);
  text-overflow: ellipsis;
  white-space: nowrap;
}
.room-info-container .room-info-container-main .room-info-content .copy-container[data-v-6044a40a] {
  display: flex;
  margin-left: auto;
  color: var(--active-color-2);
  cursor: pointer;
}
.room-info-container .room-info-container-main .room-info-content .copy-container .copy[data-v-6044a40a] {
  width: 20px;
  height: 20px;
}
.room-info-container .room-info-container-main .room-info-bottom[data-v-6044a40a] {
  padding-top: 2vh;
  font-family: "PingFang SC";
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 17px;
  color: var(--popup-title-color-h5);
  text-align: center;
}
.cancel[data-v-6044a40a] {
  flex: 1;
  padding-right: 30px;
  font-size: 16px;
  font-weight: 400;
  text-align: end;
  white-space: nowrap;
}.tui-theme-white .roomInfo-container[data-v-566ab233] {
  --title-font-color: var(--font-color-1);
  --item-font-color: var(--font-color-6);
  --filter-color: drop-shadow(0px 0px 4px rgba(32, 77, 141, 0.03))
    drop-shadow(0px 4px 10px rgba(32, 77, 141, 0.06))
    drop-shadow(0px 1px 14px rgba(32, 77, 141, 0.05));
}
.tui-theme-black .roomInfo-container[data-v-566ab233] {
  --title-font-color: #8f9ab2;
  --item-font-color: var(--font-color-1);
  --filter-color: drop-shadow(0px 8px 40px rgba(23, 25, 31, 0.6))
    drop-shadow(0px 4px 12px rgba(23, 25, 31, 0.4));
}
.conference-container[data-v-566ab233] {
  position: relative;
  min-width: 140px;
}
.title-container[data-v-566ab233] {
  display: flex;
  align-items: center;
  padding: 20px 0;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  cursor: pointer;
}
.arrow-icon[data-v-566ab233] {
  display: flex;
  align-items: center;
  width: 16px;
  height: 16px;
  margin-left: 5px;
  background-size: cover;
  transform: rotateX(180deg);
}
.arrow-down-icon[data-v-566ab233] {
  transform: rotateX(0);
}
.room-timing[data-v-566ab233] {
  padding-left: 12px;
}
.roomInfo-container[data-v-566ab233] {
  position: absolute;
  top: calc(100% - 12px);
  left: 50%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 20px;
  background-color: var(--background-color-2);
  filter: var(--filter-color);
  border-radius: 16px;
  transform: translateX(-50%);
}
.roomInfo-container .roomInfo-content[data-v-566ab233] {
  display: flex;
  align-items: stretch;
  min-width: 300px;
  font-size: 14px;
  font-weight: 400;
  line-height: normal;
  letter-spacing: -0.24px;
}
.roomInfo-container .roomInfo-content .roomInfo-title[data-v-566ab233] {
  flex-basis: 30%;
  color: var(--title-font-color);
}
.roomInfo-container .roomInfo-content .roomInfo-item[data-v-566ab233] {
  flex-basis: 50%;
  max-width: 300px;
  overflow: hidden;
  color: var(--item-font-color);
  text-overflow: ellipsis;
  white-space: nowrap;
}
.roomInfo-container .roomInfo-content .copy-container[data-v-566ab233] {
  display: flex;
  margin-left: auto;
  color: var(--active-color-2);
  cursor: pointer;
}
.roomInfo-container .roomInfo-content .copy-container .copy[data-v-566ab233] {
  width: 20px;
  height: 20px;
}.tui-theme-black .icon-button-container[data-v-ca48c0e3] {
  --icon-button-hover: rgba(46, 50, 61, 0.7);
}
.tui-theme-white .icon-button-container[data-v-ca48c0e3] {
  --icon-button-hover: rgba(79, 88, 107, 0.05);
}
.icon-button-container[data-v-ca48c0e3] {
  position: relative;
  display: flex;
  align-items: center;
  color: var(--font-color-1);
  cursor: pointer;
}
.icon-button-container .icon-content.disabled[data-v-ca48c0e3] {
  cursor: not-allowed;
  opacity: 0.4;
}
.icon-button-container .icon-content[data-v-ca48c0e3]:hover {
  background: var(--icon-button-hover);
}
.icon-button-container .icon-content-horizontal[data-v-ca48c0e3] {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  height: 32px;
  padding: 0 5px;
  border-radius: 6px;
}
.icon-button-container .icon-content-horizontal .title[data-v-ca48c0e3] {
  margin-left: 4px;
  font-size: 14px;
  font-weight: 500;
  line-height: 26px;
}
.icon-button-container .icon-content-vertical[data-v-ca48c0e3] {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-width: 56px;
  height: 56px;
  padding: 5px;
  border-radius: 6px;
}
.icon-button-container .icon-content-vertical .title[data-v-ca48c0e3] {
  margin-top: 4px;
  font-size: 12px;
  font-weight: 400;
  line-height: 20px;
}
.icon-button-container .icon-arrow[data-v-ca48c0e3] {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 12px;
  height: 56px;
  border-radius: 6px;
}
.icon-button-container .icon-arrow[data-v-ca48c0e3]:hover {
  background: var(--icon-button-hover);
}
.unsupport-icon[data-v-ca48c0e3] {
  position: absolute;
  top: 13px;
  left: 26px;
}
@media screen and (width <= 600px) {
.icon-box[data-v-ca48c0e3] {
    width: 72px;
}
.icon-box.hover-effect[data-v-ca48c0e3]:hover::before {
    width: 72px;
}
.icon-box.hover-effect[data-v-ca48c0e3]:hover::after {
    width: 72px;
}
}
.header[data-v-a8bd4f52] {
  height: 100%;
}
.header-container[data-v-a8bd4f52] {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
  padding: 0 12px;
}
.icon-box[data-v-a8bd4f52] {
  display: flex;
  gap: 10px;
  align-items: center;
}
.room-info[data-v-a8bd4f52] {
  overflow: auto;
}
.tui-theme-black .layout-container[data-v-b0951530] {
  --background-color: var(--background-color-2);
  --box-shadow: 0px 0px 40px rgba(23, 25, 31, 0.6),
    0px 0px 12px rgba(23, 25, 31, 0.4);
  --block-background-color: var(--background-color-3);
}
.tui-theme-white .layout-container[data-v-b0951530] {
  --background-color: var(--background-color-1);
  --box-shadow: 0px 3px 8px #e9f0fb;
  --block-background-color: #e4eaf7;
}
.layout-container[data-v-b0951530] {
  position: relative;
}
.layout-container .layout-list[data-v-b0951530] {
  position: absolute;
  top: calc(100% + 12px);
  left: 0;
  display: flex;
  padding: 16px 16px 6px;
  background-color: var(--background-color);
  border-radius: 8px;
  box-shadow: var(--box-shadow);
}
.layout-container .layout-list .layout-item[data-v-b0951530] {
  position: relative;
  cursor: pointer;
}
.layout-container .layout-list .layout-item[data-v-b0951530]:not(:first-child) {
  margin-left: 12px;
}
.layout-container .layout-list .layout-item .layout-block-container[data-v-b0951530] {
  width: 130px;
  height: 88px;
  padding: 4px;
  border: 2px solid transparent;
  border-radius: 6px;
}
.layout-container .layout-list .layout-item:hover .layout-block-container[data-v-b0951530], .layout-container .layout-list .layout-item.checked .layout-block-container[data-v-b0951530] {
  border: 2px solid var(--active-color-1);
}
.layout-container .layout-list .layout-item .layout-title[data-v-b0951530] {
  display: inline-block;
  width: 100%;
  margin-top: 2px;
  font-size: 12px;
  font-weight: 400;
  line-height: 24px;
  color: var(--font-color-1);
  text-align: center;
}
.layout-container .layout-list .layout-item.checked .layout-title[data-v-b0951530] {
  font-weight: 500;
  color: var(--active-color-1);
}
.layout-container .layout-list .layout1 .layout-block-container[data-v-b0951530] {
  display: flex;
  flex-wrap: wrap;
  place-content: space-between space-between;
}
.layout-container .layout-list .layout1 .layout-block-container .layout-block[data-v-b0951530] {
  width: 38px;
  height: 24px;
  background-color: var(--block-background-color);
}
.layout-container .layout-list .layout1 .layout-block-container .layout-block[data-v-b0951530]:nth-child(1) {
  border-top-left-radius: 4px;
}
.layout-container .layout-list .layout1 .layout-block-container .layout-block[data-v-b0951530]:nth-child(3) {
  border-top-right-radius: 4px;
}
.layout-container .layout-list .layout1 .layout-block-container .layout-block[data-v-b0951530]:nth-child(7) {
  border-bottom-left-radius: 4px;
}
.layout-container .layout-list .layout1 .layout-block-container .layout-block[data-v-b0951530]:nth-child(9) {
  border-bottom-right-radius: 4px;
}
.layout-container .layout-list .layout2 .layout-block-container[data-v-b0951530] {
  display: flex;
  justify-content: space-between;
}
.layout-container .layout-list .layout2 .layout-block-container .left-container[data-v-b0951530] {
  width: 78px;
  height: 100%;
  background-color: var(--block-background-color);
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}
.layout-container .layout-list .layout2 .layout-block-container .right-container[data-v-b0951530] {
  display: flex;
  flex-wrap: wrap;
  place-content: space-between space-between;
  width: 38px;
  height: 100%;
}
.layout-container .layout-list .layout2 .layout-block-container .right-container > div[data-v-b0951530] {
  width: 38px;
  height: 24px;
  background-color: var(--block-background-color);
}
.layout-container .layout-list .layout2 .layout-block-container .right-container > div[data-v-b0951530]:nth-child(1) {
  border-top-right-radius: 4px;
}
.layout-container .layout-list .layout2 .layout-block-container .right-container > div[data-v-b0951530]:nth-child(3) {
  border-bottom-right-radius: 4px;
}
.layout-container .layout-list .layout3 .layout-block-container[data-v-b0951530] {
  display: flex;
  flex-wrap: wrap;
  align-content: space-between;
}
.layout-container .layout-list .layout3 .layout-block-container .top-container[data-v-b0951530] {
  display: flex;
  flex-wrap: wrap;
  place-content: space-between space-between;
  width: 100%;
  height: 24px;
}
.layout-container .layout-list .layout3 .layout-block-container .top-container > div[data-v-b0951530] {
  width: 38px;
  height: 24px;
  background-color: var(--block-background-color);
}
.layout-container .layout-list .layout3 .layout-block-container .top-container > div[data-v-b0951530]:nth-child(1) {
  border-top-left-radius: 4px;
}
.layout-container .layout-list .layout3 .layout-block-container .top-container > div[data-v-b0951530]:nth-child(3) {
  border-top-right-radius: 4px;
}
.layout-container .layout-list .layout3 .layout-block-container .bottom-container[data-v-b0951530] {
  width: 118px;
  height: 50px;
  background-color: var(--block-background-color);
  border-bottom-right-radius: 4px;
  border-bottom-left-radius: 4px;
}.tui-theme-white .network-info-board[data-v-a8b1e3f3] {
  --title-font-color: var(--font-color-1);
  --item-font-color: var(--font-color-6);
  --filter-color: drop-shadow(0px 0px 4px rgba(32, 77, 141, 0.03))
    drop-shadow(0px 4px 10px rgba(32, 77, 141, 0.06))
    drop-shadow(0px 1px 14px rgba(32, 77, 141, 0.05));
}
.tui-theme-black .network-info-board[data-v-a8b1e3f3] {
  --title-font-color: #8f9ab2;
  --item-font-color: var(--font-color-1);
  --filter-color: drop-shadow(0px 8px 40px rgba(23, 25, 31, 0.6))
    drop-shadow(0px 4px 12px rgba(23, 25, 31, 0.4));
}
.network-info-container[data-v-a8b1e3f3] {
  position: relative;
}
.network-info-container .network-info-board[data-v-a8b1e3f3] {
  position: absolute;
  top: 40px;
  width: 161px;
  height: 130px;
  padding: 24px;
  background-color: var(--background-color-2);
  filter: var(--filter-color);
  border-radius: 10px;
}
.network-info-container .network-info-board .network-state[data-v-a8b1e3f3] {
  margin-bottom: 18px;
}
.network-info-container .network-info-board .network-detail-item[data-v-a8b1e3f3] {
  display: flex;
  justify-content: space-between;
  margin-bottom: 30px;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: var(--title-font-color);
}
.network-info-container .network-info-board .network-detail-item .title-latency[data-v-a8b1e3f3] {
  font-weight: 500;
  line-height: 22px;
}
.network-info-container .network-info-board .network-detail-item .network-detail-packet[data-v-a8b1e3f3] {
  display: flex;
  flex-direction: column;
  font-weight: 500;
  color: var(--item-font-color);
}
.network-info-container .network-info-board .network-detail-item .network-detail-packet .network-detail-packet-item[data-v-a8b1e3f3] {
  display: flex;
}
.network-info-container .network-info-board .network-detail-item .network-detail-packet .network-detail-packet-item .arrow-down[data-v-a8b1e3f3] {
  transform: rotate(180deg);
}
.network-info-container .title-type-success[data-v-a8b1e3f3] {
  color: #27c39f;
}
.network-info-container .title-type-warning[data-v-a8b1e3f3] {
  color: #f39843;
}
.network-info-container .title-type-danger[data-v-a8b1e3f3] {
  color: #ed414d;
}
.network-info-container .title-type-info[data-v-a8b1e3f3] {
  color: #4f586b;
}.header-container[data-v-acaf17b5] {
  position: relative;
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  padding-right: 24px;
  padding-left: 9px;
}
.header-container .left-container[data-v-acaf17b5] {
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  height: 100%;
  padding-left: 24px;
}
.header-container .left-container .header-item[data-v-acaf17b5]:not(:first-child) {
  margin-left: 1rem;
}
.header-container .center-container[data-v-acaf17b5] {
  position: absolute;
  left: 50%;
  display: flex;
  align-items: center;
  height: 100%;
  transform: translateX(-50%);
}
.header-container .right-container[data-v-acaf17b5] {
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  align-items: center;
  float: right;
  height: 100%;
  padding-right: 24px;
}
.header-container .right-container .header-item[data-v-acaf17b5]:not(:last-child) {
  margin-right: 1rem;
}
.header-container .right-container .end-control-container[data-v-acaf17b5] {
  display: none;
}.select[data-v-5897c560] {
  width: 100%;
  font-size: 14px;
}.audio-setting-tab[data-v-4e811209] {
  width: 100%;
  font-size: 14px;
  border-radius: 4px;
}
.audio-setting-tab .item-setting[data-v-4e811209] {
  width: 100%;
}
.audio-setting-tab .item-setting[data-v-4e811209]:not(:last-child) {
  margin-bottom: 20px;
}
.audio-setting-tab .flex[data-v-4e811209] {
  display: flex;
  width: 100%;
}
.audio-setting-tab .select[data-v-4e811209] {
  flex: 1;
}
.audio-setting-tab .button[data-v-4e811209] {
  width: 74px;
  padding: 5px 23px;
  margin-left: 10px;
}
.audio-setting-tab .title[data-v-4e811209] {
  display: inline-block;
  width: 100%;
  margin-bottom: 8px;
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  color: #4f586b;
}
.audio-setting-tab .mic-bar-container[data-v-4e811209] {
  display: flex;
  justify-content: space-between;
}
.audio-setting-tab .mic-bar-container .mic-bar[data-v-4e811209] {
  width: 3px;
  height: 6px;
  background-color: var(--background-color-4);
}
.audio-setting-tab .mic-bar-container .mic-bar.active[data-v-4e811209] {
  background-color: var(--green-color);
}
.audio-setting-tab .audio-level-container[data-v-4e811209] {
  display: flex;
  width: 100%;
  height: 20px;
}
.audio-setting-tab .audio-level-container .slider[data-v-4e811209] {
  height: 20px;
  margin-left: 10px;
}.audio-icon-container[data-v-6e9fcb9f] {
  position: relative;
  width: 24px;
  height: 24px;
}
.audio-icon-container.small[data-v-6e9fcb9f] {
  transform: scale(0.8);
}
.audio-icon-container .audio-level-container[data-v-6e9fcb9f] {
  position: absolute;
  top: 2px;
  left: 7px;
  display: flex;
  flex-flow: column-reverse wrap;
  justify-content: space-between;
  width: 10px;
  height: 14px;
  overflow: hidden;
  border-radius: 4px;
}
.audio-icon-container .audio-level-container .audio-level[data-v-6e9fcb9f] {
  width: 100%;
  background-color: var(--green-color);
  transition: height 0.2s;
}
.audio-icon-container .audio-icon[data-v-6e9fcb9f] {
  position: absolute;
  top: 0;
  left: 0;
}.audio-control-container[data-v-e19b59f4] {
  position: relative;
}
.audio-control-container .audio-tab[data-v-e19b59f4] {
  position: absolute;
  bottom: calc(100% + 12px);
  left: -5px;
  width: 305px;
  padding: 20px 20px 24px;
  background: var(--background-color-1);
  border-radius: 8px;
  box-shadow: 0 2px 4px -3px rgba(32, 77, 141, 0.03), 0 6px 10px 1px rgba(32, 77, 141, 0.06), 0 3px 14px 2px rgba(32, 77, 141, 0.05);
}
.audio-control-container .audio-tab[data-v-e19b59f4]::before {
  position: absolute;
  bottom: -10px;
  left: 28px;
  content: "";
  border-top: 5px solid var(--background-color-1);
  border-right: 5px solid transparent;
  border-bottom: 5px solid transparent;
  border-left: 5px solid transparent;
}.cancel-button[data-v-1eff5ae4] {
  margin-left: 20px;
}.select[data-v-c656fc9a] {
  width: 100%;
  font-size: 14px;
}.switch-container[data-v-efa68e90],
.switch-container-active[data-v-efa68e90] {
  position: relative;
  display: inline-block;
  width: 40px;
  height: 20px;
  cursor: pointer;
  background-color: var(--active-color-1);
  border-radius: 20px;
  transition: background-color 0.3s;
}
.switch-container .switch-core[data-v-efa68e90],
.switch-container-active .switch-core[data-v-efa68e90] {
  position: absolute;
  top: 2px;
  left: 2px;
  width: 40%;
  height: 80%;
  background-color: #fff;
  border-radius: 50%;
  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.2);
  transition: transform 0.3s !important;
  transform: translateX(20px);
}
.switch-container-active[data-v-efa68e90] {
  background-color: var(--background-color-6);
}
.switch-container-active .switch-core[data-v-efa68e90] {
  transform: translateX(0);
}.video-tab[data-v-2322ab50] {
  font-size: 14px;
  border-radius: 8px;
}
.video-tab .item-setting[data-v-2322ab50]:not(:last-child) {
  margin-bottom: 20px;
}
.video-tab .title[data-v-2322ab50] {
  display: inline-block;
  width: 100%;
  margin-bottom: 8px;
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  color: var(--font-color-4);
}
.video-tab .video-preview-container[data-v-2322ab50] {
  position: relative;
  width: 100%;
  height: 0;
  padding-top: 56.25%;
  overflow: hidden;
  background-color: #000;
  border-radius: 8px;
}
.video-tab .video-preview-container .video-preview[data-v-2322ab50] {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.video-tab .mirror-container[data-v-2322ab50] {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: 2px;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
  color: var(--font-color-4);
}
.video-tab .item[data-v-2322ab50] {
  width: 100%;
  height: 20px;
  color: var(--font-color-3);
  cursor: pointer;
}.video-control-container[data-v-64a65f13] {
  position: relative;
}
.video-control-container .video-tab[data-v-64a65f13] {
  position: absolute;
  bottom: calc(100% + 12px);
  left: -5px;
  width: 305px;
  padding: 20px 20px 24px;
  background: var(--background-color-1);
  border-radius: 8px;
  box-shadow: 0 2px 4px -3px rgba(32, 77, 141, 0.03), 0 6px 10px 1px rgba(32, 77, 141, 0.06), 0 3px 14px 2px rgba(32, 77, 141, 0.05);
}
.video-control-container .video-tab[data-v-64a65f13]::before {
  position: absolute;
  bottom: -10px;
  left: 30px;
  content: "";
  border-top: 5px solid var(--background-color-1);
  border-right: 5px solid transparent;
  border-bottom: 5px solid transparent;
  border-left: 5px solid transparent;
}.cancel-button[data-v-234c7519] {
  margin-left: 20px;
}.tui-badge[data-v-b1ab6870] {
  position: relative;
  display: inline-block;
}
.tui-badge .tui-badge-count[data-v-b1ab6870] {
  position: absolute;
  top: 0;
  right: 15px;
  display: inline-block;
  padding: 1px 6px;
  font-size: 12px;
  font-weight: bold;
  color: var(--white-color);
  border-radius: 10px;
  transform: translateY(-50%) translateX(100%);
}
.tui-badge-primary .tui-badge-count[data-v-b1ab6870] {
  background-color: var(--active-color-1);
}
.tui-badge-danger .tui-badge-count[data-v-b1ab6870] {
  background-color: var(--red-color-2);
}
.tui-badge-isDot .tui-badge-count[data-v-b1ab6870] {
  top: 0;
  width: 8px;
  height: 8px;
  padding: 0;
  border-radius: 50%;
}.tui-notification .tui-notification-container-mobile[data-v-6fb58b79] {
  position: fixed;
  top: 8%;
  display: flex;
  width: 95%;
  height: 44px;
  margin: 0 10px;
  text-align: center;
  background-color: #fff;
  border-radius: 10px;
}
.tui-notification .tui-notification-container-mobile .tui-notification-mobile-icon[data-v-6fb58b79] {
  padding: 0 10px;
  margin-left: 4px;
  color: #000;
}
.tui-notification .tui-notification-container-mobile .tui-notification-mobile-content[data-v-6fb58b79] {
  margin: 0 auto 0 4px;
  font-size: 15px;
  font-weight: 400;
  line-height: 44px;
  color: #181820;
}
.tui-notification .tui-notification-container-mobile .tui-notification-mobile-check[data-v-6fb58b79] {
  padding: 0 12px;
  margin: 6px 10px 6px 0;
  line-height: 34px;
  color: #fff;
  background-color: #1c66e5;
  border-radius: 10px;
}
.tui-notification .tui-notification-container[data-v-6fb58b79] {
  position: fixed;
  top: 7%;
  right: 1%;
  display: flex;
  flex-direction: column;
  width: 400px;
  background-color: var(--white-color);
  filter: drop-shadow(0 0 1px rgba(5, 5, 5, 0.1)) drop-shadow(0 3px 8px rgba(233, 240, 251, 0.5));
  border-radius: 20px;
}
.tui-notification .tui-notification-container .tui-notification-header[data-v-6fb58b79] {
  position: relative;
  display: flex;
  align-items: center;
  height: 64px;
  padding: 0 24px;
  font-weight: 500;
  color: var(--title-color);
}
.tui-notification .tui-notification-container .tui-notification-header .tui-notification-title[data-v-6fb58b79] {
  max-width: 300px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.tui-notification .tui-notification-container .tui-notification-header .close[data-v-6fb58b79] {
  position: absolute;
  top: 50%;
  right: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  color: #4f586b;
  cursor: pointer;
  transform: translateY(-50%);
}
.tui-notification .tui-notification-footer[data-v-6fb58b79] {
  display: flex;
  justify-content: flex-end;
  padding: 20px 30px;
}
.tui-notification .tui-notification-footer .button[data-v-6fb58b79] {
  margin-left: 12px;
}.apply-control-container[data-v-ee314078] {
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
}
.apply-control-container .apply-list-mobile[data-v-ee314078] {
  padding: 0 16px;
  margin-top: 4px;
  overflow: scroll;
}
.apply-control-container .apply-list-mobile[data-v-ee314078]::-webkit-scrollbar {
  display: none;
}
.apply-control-container .apply-list-mobile .apply-item[data-v-ee314078] {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 48px;
  padding-bottom: 8px;
  margin-top: 20px;
}
.apply-control-container .apply-list-mobile .apply-item .user-info[data-v-ee314078] {
  display: flex;
  align-items: center;
  width: calc(100% - 176px);
  height: 100%;
}
.apply-control-container .apply-list-mobile .apply-item .user-info .avatar-url[data-v-ee314078] {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}
.apply-control-container .apply-list-mobile .apply-item .user-info .stage-info[data-v-ee314078] {
  display: flex;
  flex-direction: column;
  margin-left: 12px;
}
.apply-control-container .apply-list-mobile .apply-item .user-info .stage-info .user-name[data-v-ee314078] {
  max-width: 180px;
  overflow: hidden;
  font-size: 16px;
  font-weight: 500;
  color: var(--font-color-1);
  text-overflow: ellipsis;
  white-space: nowrap;
}
.apply-control-container .apply-list-mobile .apply-item .user-info .stage-info .apply-tip[data-v-ee314078] {
  font-size: 14px;
  font-weight: 400;
  color: var(--font-color-8);
}
.apply-control-container .apply-list-mobile .apply-item .control-container[data-v-ee314078] {
  display: flex;
}
.apply-control-container .apply-list-mobile .apply-item .control-container .agree-button[data-v-ee314078],
.apply-control-container .apply-list-mobile .apply-item .control-container .reject-button[data-v-ee314078] {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 28px;
  font-weight: 400;
  color: var(--font-color-1);
  background-color: var(--background-color-3);
  border-radius: 6px;
}
.apply-control-container .apply-list-mobile .apply-item .control-container .agree-button[data-v-ee314078] {
  margin-left: 8px;
  color: var(--white-color);
  background-color: var(--active-color-1);
}
.apply-control-container .apply-list-mobile .apply-item[data-v-ee314078]::after {
  position: absolute;
  bottom: 0;
  left: 14%;
  width: 85%;
  height: 1px;
  content: "";
  background-color: var(--stroke-color-2);
}
.apply-control-container .apply-control-nobody[data-v-ee314078] {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 290px;
}
.apply-control-container .apply-list-footer[data-v-ee314078] {
  position: absolute;
  bottom: 0;
  display: flex;
  justify-content: space-around;
  width: 100%;
}
.apply-control-container .apply-list-footer .action-button[data-v-ee314078] {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 167px;
  height: 40px;
  color: var(--font-color-1);
  cursor: pointer;
  background-color: var(--background-color-3);
  border-radius: 8px;
}
.apply-control-container .apply-list-footer .action-button.agree[data-v-ee314078] {
  margin-left: 10px;
  color: var(--white-color);
  background-color: var(--active-color-1);
}
.apply-control-container .apply-list-footer .action-button.disabled[data-v-ee314078] {
  pointer-events: none;
  cursor: not-allowed;
  opacity: 0.4;
}.apply-control-container[data-v-63ddd3de] {
  position: relative;
}
.cancel-button[data-v-63ddd3de] {
  margin-left: 10px;
  color: #4f586b;
  background-color: #f0f3fa;
  border: 1px solid #f0f3fa;
}
.cancel-button[data-v-63ddd3de]:hover {
  background-color: #f0f3fa;
  border: 1px solid #f0f3fa;
}
.apply-list[data-v-63ddd3de] {
  height: 290px;
  margin-top: 4px;
  overflow: scroll;
}
.apply-list[data-v-63ddd3de]::-webkit-scrollbar {
  display: none;
}
.apply-list .apply-list-title[data-v-63ddd3de] {
  display: flex;
  justify-content: space-between;
  padding-bottom: 10px;
  border-bottom: 1px solid #f0f3fa;
}
.apply-list .apply-list-title .apply-list-name[data-v-63ddd3de],
.apply-list .apply-list-title .apply-list-operate[data-v-63ddd3de] {
  width: calc(100% - 310px);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 22px;
  color: #4f586b;
}
.apply-list .apply-item[data-v-63ddd3de] {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 48px;
  margin-top: 8px;
  border-bottom: 1px solid #f0f3fa;
}
.apply-list .apply-item .user-info[data-v-63ddd3de] {
  display: flex;
  align-items: center;
  width: calc(100% - 176px);
  height: 100%;
}
.apply-list .apply-item .user-info .avatar-url[data-v-63ddd3de] {
  width: 32px;
  height: 32px;
  border-radius: 50%;
}
.apply-list .apply-item .user-info .user-name[data-v-63ddd3de] {
  max-width: 180px;
  margin-left: 12px;
  overflow: hidden;
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  color: #4f586b;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.apply-list .apply-item .control-container[data-v-63ddd3de] {
  display: flex;
  justify-content: space-between;
}
.apply-list .apply-item .control-container .agree[data-v-63ddd3de],
.apply-list .apply-item .control-container .reject[data-v-63ddd3de] {
  padding: 2px 12px;
}
.apply-list .apply-item .control-container .reject[data-v-63ddd3de] {
  margin-left: 8px;
  color: #4f586b;
  background-color: #f0f3fa;
  border: 1px solid #f0f3fa;
}
.apply-nobody[data-v-63ddd3de] {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 290px;
}
.apply-nobody .apply-text[data-v-63ddd3de] {
  margin-top: 10px;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
  color: #8f9ab2;
}.apply-control-container[data-v-a4cd0475] {
  position: relative;
}
.apply-control-container .attention[data-v-a4cd0475] {
  position: absolute;
  bottom: 70px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: var(--active-color-1);
  border-radius: 8px;
  box-shadow: 0 4px 16px 0 rgba(47, 48, 164, 0.1);
}
.apply-control-container .attention[data-v-a4cd0475]::after {
  position: absolute;
  top: 100%;
  left: 10%;
  display: block;
  content: "";
  border: 5px solid transparent;
  border-top-color: var(--active-color-1);
  transform: translateX(-50%);
}
.apply-control-container .member-attention[data-v-a4cd0475] {
  padding: 12px;
}
.apply-control-container .member-attention .info[data-v-a4cd0475],
.apply-control-container .member-attention .mobile-info[data-v-a4cd0475] {
  height: 20px;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  color: #fff;
  white-space: nowrap;
}
.apply-control-container .member-attention .mobile-info[data-v-a4cd0475] {
  min-width: 50vw;
}
.apply-control-container .member-attention .close[data-v-a4cd0475] {
  padding-left: 12px;
  color: #fff;
  cursor: pointer;
}
.agree[data-v-a4cd0475],
.cancel[data-v-a4cd0475] {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50%;
  padding: 14px;
  font-size: 16px;
  font-weight: 500;
  color: var(--active-color-1);
}
.cancel[data-v-a4cd0475] {
  color: var(--font-color-4);
}
.cancel-button[data-v-a4cd0475] {
  margin-left: 20px;
}.tui-input[data-v-bf51168a] {
  position: relative;
  display: inline-block;
  width: 100%;
  height: 100%;
}
input[data-v-bf51168a] {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  padding: 10px 0 10px 16px;
  font-size: 14px;
  color: var(--font-color-3);
  background-color: var(--background-color-7);
  border: 1px solid var(--border-color);
  border-radius: 8px;
}
input[data-v-bf51168a]:focus {
  border-color: var(--active-color-1);
  outline: 0;
}
input[data-v-bf51168a]:disabled {
  background-color: var(--background-color-9);
}
.tui-input.no-border input[data-v-bf51168a] {
  padding: 0;
  background-color: transparent;
  border: none;
}
.suffix-icon[data-v-bf51168a] {
  position: absolute;
  top: 50%;
  right: 12px;
  display: flex;
  align-items: center;
  transform: translateY(-50%);
}
.results[data-v-bf51168a] {
  position: absolute;
  z-index: 2;
  width: 100%;
  max-height: 254px;
  padding: 7px 0;
  overflow: auto;
  background-color: var(--background-color-7);
  border: 1px solid var(--border-color);
  border-radius: 4px;
}
.results-item[data-v-bf51168a] {
  display: flex;
  align-items: center;
  padding: 6px 15px;
  white-space: nowrap;
  cursor: pointer;
}
.results-item[data-v-bf51168a]:hover {
  color: var(--active-color-2);
  background-color: var(--hover-background-color-1);
}.tui-input[data-v-398b4e50] {
  position: relative;
  display: inline-block;
  width: 100%;
  height: 100%;
}
input[data-v-398b4e50] {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  padding: 10px 0 10px 16px;
  font-size: 14px;
  color: var(--font-color-3);
  background-color: var(--background-color-7);
  border: 1px solid var(--border-color);
  border-radius: 8px;
}
input[data-v-398b4e50]:focus {
  border-color: var(--active-color-1);
  outline: 0;
}
input[data-v-398b4e50]:disabled {
  background-color: var(--background-color-9);
}
.tui-input.no-border input[data-v-398b4e50] {
  padding: 0;
  background-color: transparent;
  border: none;
}
.suffix-icon[data-v-398b4e50] {
  position: absolute;
  top: 50%;
  right: 12px;
  display: flex;
  align-items: center;
  transform: translateY(-50%);
}
.results[data-v-398b4e50] {
  position: fixed;
  z-index: 2;
  width: 100%;
  max-width: 12rem;
  max-height: 254px;
  padding: 7px 0;
  overflow: auto;
  background-color: var(--background-color-7);
  border: 1px solid var(--border-color);
  border-radius: 4px;
}
.results-item[data-v-398b4e50] {
  display: flex;
  align-items: center;
  padding: 6px 15px;
  white-space: nowrap;
  cursor: pointer;
}
.results-item[data-v-398b4e50]:hover {
  color: var(--active-color-2);
  background-color: var(--hover-background-color-1);
}.tui-checkbox[data-v-57e9d7b2] {
  position: relative;
  display: flex;
  align-items: center;
  cursor: pointer;
}
.tui-checkbox .tui-checkbox-slot-container[data-v-57e9d7b2] {
  flex: 1;
  overflow: auto;
}
input[data-v-57e9d7b2] {
  color: var(--title-color);
  cursor: pointer;
  border: 1px solid var(--stroke-color);
  border-radius: 4px;
}
input[data-v-57e9d7b2]:focus {
  border-color: var(--active-color-1);
  outline: 0;
}
input[data-v-57e9d7b2]:disabled {
  cursor: not-allowed;
  background-color: var(--background-color-9);
}.panel-container.h5[data-v-de9803a2] {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1001;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background-color: #f8f9fb;
}
.panel-container.h5 .container-header[data-v-de9803a2] {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5%;
  font-size: 16px;
  font-weight: 500;
  color: #2b2e38;
  text-align: center;
  background-color: #fff;
}
.panel-container.h5 .container-header .container-header-back[data-v-de9803a2] {
  flex: 1;
  justify-content: flex-start;
  text-align: left;
}
.panel-container.h5 .container-header .container-header-title[data-v-de9803a2] {
  flex: 2;
  text-align: center;
}
.panel-container.h5 .container-header .container-header-edit[data-v-de9803a2] {
  flex: 1;
  color: #1c66e5;
  text-align: right;
}
.panel-container.h5 .container-content[data-v-de9803a2] {
  flex: 1;
  height: 100%;
  margin: 16px;
  overflow-y: auto;
}.contacts-container[data-v-5539e560] {
  display: flex;
  max-height: 400px;
}
.contacts-container .contact[data-v-5539e560],
.contacts-container .chosen[data-v-5539e560] {
  height: 400px;
}
.contacts-container .contact-list[data-v-5539e560],
.contacts-container .chosen-list[data-v-5539e560] {
  box-sizing: border-box;
  height: 80%;
  max-height: calc(100% - 68px);
  margin: 10px 0;
  overflow: auto;
}
.contacts-container .contact-list-item[data-v-5539e560],
.contacts-container .chosen-list-item[data-v-5539e560] {
  display: flex;
  align-items: center;
  height: 34px;
  line-height: 34px;
  cursor: pointer;
}
.contacts-container .contact-list-item-checkbox[data-v-5539e560],
.contacts-container .chosen-list-item-checkbox[data-v-5539e560] {
  display: flex;
  width: 100%;
  height: 100%;
}
.contacts-container .contact-list-item-checkbox-container[data-v-5539e560],
.contacts-container .chosen-list-item-checkbox-container[data-v-5539e560] {
  display: flex;
  align-items: center;
}
.contacts-container .contact-list-item-avatar[data-v-5539e560],
.contacts-container .chosen-list-item-avatar[data-v-5539e560] {
  width: 20px;
  min-width: 20px;
  height: 20px;
  min-height: 20px;
  margin-right: 6px;
  margin-left: 8px;
}
.contacts-container .contact-list-item-name[data-v-5539e560],
.contacts-container .chosen-list-item-name[data-v-5539e560] {
  box-sizing: border-box;
  max-width: 70%;
  margin: initial;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.contacts-container .contact-list-item-remove[data-v-5539e560],
.contacts-container .chosen-list-item-remove[data-v-5539e560] {
  width: 10px;
  min-width: 10px;
  margin-right: 10px;
  margin-left: auto;
  color: #6b758a;
  cursor: pointer;
}
.contacts-container .contact-list-item[data-v-5539e560]:hover,
.contacts-container .chosen-list-item[data-v-5539e560]:hover {
  background-color: #ecf5ff;
}
.contacts-container .contact[data-v-5539e560] {
  width: 50%;
  padding-right: 1rem;
  border-right: 1px solid #e5e5e5;
}
.contacts-container .contact .contact-search-input.focus .search-icon[data-v-5539e560] {
  color: var(--active-color-1);
}
.contacts-container .contact .contact-list[data-v-5539e560] {
  height: 80%;
}
.contacts-container .contact .contact-list .no-result[data-v-5539e560] {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  font-size: 12px;
  text-align: center;
}
.contacts-container .chosen[data-v-5539e560] {
  width: 50%;
  padding-left: 1rem;
  overflow: hidden;
}
.contacts-container .chosen .chosen-title[data-v-5539e560] {
  font-size: 14px;
  font-weight: 600;
}
.contacts-container .chosen .chosen-footer[data-v-5539e560] {
  display: flex;
  gap: 10px;
  justify-content: center;
}
.contacts-container .chosen .chosen-footer .chosen-footer-button[data-v-5539e560] {
  width: 76px;
  height: 26px;
}
.contact-list-item.contact-list-item-disabled[data-v-5539e560] {
  pointer-events: none;
  cursor: not-allowed;
}
.chosen-list-item.chosen-list-item-disabled[data-v-5539e560] {
  pointer-events: none;
  cursor: not-allowed;
}
.contacts-container.h5[data-v-5539e560] {
  flex-direction: column;
  height: 100%;
  max-height: none;
}
.contacts-container.h5 .contact[data-v-5539e560] {
  width: 100%;
  height: 100%;
  padding-right: 0;
  overflow: auto;
  border-right: none;
}
.contacts-container.h5 .contact .contact-list[data-v-5539e560] {
  height: 100%;
}
.contacts-container.h5 .contact .contact-list-item[data-v-5539e560] {
  height: 46px;
  line-height: 46px;
  border-bottom: 1px solid rgba(221, 226, 235, 0.3);
}
.contact-footer[data-v-5539e560] {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px 20px;
  text-align: right;
}
.contact-footer .chosen-member[data-v-5539e560] {
  font-size: 14px;
  font-weight: 400;
  color: #22262e;
}
.contact-footer .form-attendees[data-v-5539e560]:hover {
  overflow: auto;
}
.contact-footer button[data-v-5539e560] {
  padding: 6px 30px;
}span[data-v-e20a6afc] {
  align-self: center;
  margin: 0 5px;
  font-size: 14px;
  font-weight: 400;
  line-height: 17px;
}
.invite-container-main .invite-title-main[data-v-e20a6afc] {
  display: flex;
  justify-content: center;
  padding: 20px;
}
.invite-container-main .invite-item-container[data-v-e20a6afc] {
  padding: 10px;
}
.invite-container-main .invite-item[data-v-e20a6afc] {
  display: flex;
  align-items: center;
  padding: 5px 0;
}
.invite-container-main .icon[data-v-e20a6afc] {
  display: flex;
  align-items: center;
  width: 20px;
  height: 20px;
  margin: 0 5px;
}
.invite-content-main[data-v-e20a6afc] {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 90%;
  height: 13%;
  padding: 0 0 0 25px;
  margin-bottom: 10px;
}
.invite-content-main .invite-title[data-v-e20a6afc] {
  width: 23%;
  font-family: "PingFang SC";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  color: var(--popup-title-color-h5);
  white-space: nowrap;
}
.invite-content-main .invite-content[data-v-e20a6afc] {
  width: 64%;
  overflow: hidden;
  font-size: 14px;
  color: var(--popup-content-color-h5);
  text-overflow: ellipsis;
  white-space: nowrap;
}
.invite-content-main .copy[data-v-e20a6afc] {
  width: 20px;
  height: 20px;
  margin-left: 30px;
  color: var(--active-color-1);
}
.invite-content-bottom[data-v-e20a6afc] {
  display: flex;
  justify-content: center;
}
.invite-bottom[data-v-e20a6afc] {
  display: block;
  width: 80%;
  padding: 5px 0;
  font-family: "PingFang SC";
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 17px;
  color: var(--mute-button-color-h5);
  text-align: center;
  background-color: var(--manage-member-button-h5);
  border-radius: 10px;
}.invite-container[data-v-83dd4016] {
  position: absolute;
  right: -25px;
  bottom: 72px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100px;
  padding: 5px 10px;
  background-color: var(--background-color-2);
  border-radius: 15px;
  box-shadow: 0 -8px 30px var(--footer-shadow-color);
}
.invite-container .invite-item[data-v-83dd4016] {
  display: flex;
  align-items: center;
  margin-top: 5px;
  cursor: pointer;
}
.invite-container .invite-item .icon[data-v-83dd4016] {
  width: 16px;
  height: 16px;
}
.invite-container .invite-item .invite-title[data-v-83dd4016] {
  padding-left: 5px;
  font-family: "PingFang SC";
  font-size: 12px;
  font-weight: 400;
  line-height: 20px;
  text-align: left;
}
.invite-member[data-v-83dd4016] {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 10px;
}
.invite-member .invite-member-container[data-v-83dd4016] {
  display: flex;
  align-items: stretch;
  min-width: 400px;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: #4f586b;
}
.invite-member .invite-member-container .invite-member-title[data-v-83dd4016] {
  flex-basis: 18%;
}
.invite-member .invite-member-container .invite-member-content[data-v-83dd4016] {
  max-width: 360px;
  overflow: hidden;
  font-weight: 500;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.invite-member .invite-member-container .copy[data-v-83dd4016] {
  width: 20px;
  height: 20px;
  margin-left: 8px;
  color: var(--active-color-1);
  cursor: pointer;
}
.tui-theme-black .invite-container[data-v-83dd4016] {
  --hover-bg-color: rgba(79, 88, 107, 0.2);
}
.tui-theme-white .invite-container[data-v-83dd4016] {
  --hover-bg-color: rgba(213, 224, 242, 0.3);
}.invite-control-container[data-v-5b059127] {
  position: relative;
}span[data-v-a59c234f] {
  padding-right: 5px;
  font-size: 12px;
  font-weight: 500;
  line-height: 17px;
}
.contact-container-main[data-v-a59c234f] {
  position: fixed;
  bottom: 0;
  display: flex;
  flex-direction: column;
  width: 100%;
  padding-bottom: 4vh;
  background: var(--popup-background-color-h5);
  border-radius: 15px 15px 0 0;
  animation-name: popup-a59c234f;
  animation-duration: 200ms;
}
@keyframes popup-a59c234f {
from {
    transform: scaleY(0);
    transform-origin: bottom;
}
to {
    transform: scaleY(1);
    transform-origin: bottom;
}
}
.contact-container-main .contact-title-main[data-v-a59c234f] {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 30px 0 20px 25px;
  font-family: "PingFang SC";
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  color: var(--popup-title-color-h5);
}
.contact-container-main .contact-content-main[data-v-a59c234f] {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 90%;
  height: 15%;
  padding: 0 0 0 25px;
  margin-bottom: 10px;
}
.contact-container-main .contact-title[data-v-a59c234f],
.contact-container-main .contact-content[data-v-a59c234f] {
  width: 28%;
  font-family: "PingFang SC";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  color: var(--popup-title-color-h5);
  white-space: nowrap;
}
.contact-container-main .contact-content[data-v-a59c234f] {
  width: 62%;
  overflow: hidden;
  font-size: 14px;
  color: var(--popup-content-color-h5);
  text-overflow: ellipsis;
  white-space: nowrap;
}
.contact-container-main .contact-bottom[data-v-a59c234f] {
  width: 90%;
  padding-left: 40px;
  font-family: "PingFang SC";
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 17px;
  color: var(--popup-title-color-h5);
  text-align: center;
}
.contact-container-main .copy[data-v-a59c234f] {
  width: 20px;
  height: 20px;
  margin-left: 30px;
  color: var(--active-color-1);
}
.cancel[data-v-a59c234f] {
  flex: 1;
  padding-right: 30px;
  font-size: 16px;
  font-weight: 400;
  text-align: end;
}.more-container[data-v-936a14d1] {
  padding: 20px;
}
.more-container .more-title[data-v-936a14d1] {
  display: flex;
}
.more-container .more-title .email-icon[data-v-936a14d1] {
  color: #7c85a6;
}
.more-container .more-title .more-notice[data-v-936a14d1] {
  width: 100%;
  height: 22px;
  padding-left: 8px;
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  color: var(--font-color-5);
}
.more-container .more-item[data-v-936a14d1] {
  position: relative;
  display: flex;
  flex-direction: column;
}
.more-container .more-item[data-v-936a14d1]:not(:first-child) {
  margin-top: 20px;
}
.more-container .more-item:not(:first-child) .item-title[data-v-936a14d1] {
  width: 100%;
  padding-bottom: 8px;
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  color: var(--font-color-5);
}
.more-container .more-item:not(:first-child) .join-button[data-v-936a14d1] {
  height: 42px;
  font-weight: 600;
}
.more-container .more-item:not(:first-child) .more-content[data-v-936a14d1] {
  position: relative;
  box-sizing: border-box;
  display: inline-block;
  flex: 1;
  height: 42px;
  padding: 10px 30px 10px 16px;
  overflow: hidden;
  font-size: 14px;
  font-weight: 500;
  line-height: 22px;
  color: var(--font-color-6);
  text-overflow: ellipsis;
  white-space: nowrap;
  background-color: var(--background-color-7);
  border: 1px solid var(--border-color);
  border-radius: 8px;
  outline: none;
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
}
.more-container .more-item:not(:first-child) .copy-icon[data-v-936a14d1] {
  position: absolute;
  top: 36px;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  cursor: pointer;
}.contact-container[data-v-03044841] {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  z-index: 11;
  box-sizing: border-box;
  width: 100vw;
  height: auto;
  background-color: var(--log-out-mobile);
}.show-more-content[data-v-5f1fea0d] {
  position: absolute;
  bottom: 15px;
  left: 5%;
  width: 90%;
  height: 17vh;
  padding: 10px;
  background: var(--log-out-cancel);
  border-radius: 13px;
  animation-name: popup-5f1fea0d;
  animation-duration: 200ms;
}
@keyframes popup-5f1fea0d {
from {
    bottom: 0;
}
to {
    bottom: 15px;
}
}
.control-compent[data-v-5f1fea0d] {
  display: flex;
}
.close[data-v-5f1fea0d] {
  position: relative;
  top: 10%;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  color: var(--mute-button-color-h5);
  text-align: center;
  background: var(--close-cancel-h5);
  border: 1px solid var(--close-cancel-h5);
  border-radius: 8px;
}
.footer-container[data-v-7d30c16b] {
  position: absolute;
  bottom: 0;
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 0.7rem;
  background-color: var(--background-color-2);
  box-shadow: 0 -8px 30px var(--footer-shadow-color);
}
.screen-share-control-container[data-v-cbca772a] {
  position: relative;
}
.stop-share-region[data-v-cbca772a] {
  position: absolute;
  top: -58px;
  left: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 131px;
  height: 48px;
  font-size: 14px;
  color: var(--color-font);
  cursor: pointer;
  background: var(--stop-share-region-bg-color);
  border-radius: 4px;
  transform: translateX(-50%);
}
.stop-share-icon[data-v-cbca772a] {
  width: 24px;
  height: 24px;
  margin-right: 10px;
}
.button[data-v-cbca772a] {
  margin-left: 12px;
}.stream-preview[data-v-75745e06] {
  position: relative;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 310px;
  overflow: hidden;
  background-color: #000;
  border-radius: 8px;
}
.setting[data-v-75745e06] {
  display: flex;
  gap: 16px;
  align-items: center;
  padding: 1rem;
  margin-top: 10px;
  border: 1px solid #e4e8ee;
  border-radius: 8px;
}
.setting-item[data-v-75745e06] {
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-size: 12px;
  color: #4f586b;
  text-align: center;
  cursor: pointer;
  border: 1px solid transparent;
  border-radius: 8px;
}
.setting-item-icon[data-v-75745e06] {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 54px;
  height: 54px;
  overflow: hidden;
  background-color: #f0f3fa;
  border-radius: 8px;
}
.setting-item.active[data-v-75745e06] {
  color: #fff;
  background-color: #1c66e5;
  border: 1px solid #1c66e5;
}
.spinner[data-v-75745e06] {
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 3;
  width: 40px;
  height: 40px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #1c66e5;
  border-radius: 50%;
  transform: translate(-50%, -50%);
  animation: spin-75745e06 1s linear infinite;
}
.mask[data-v-75745e06] {
  position: absolute;
  z-index: 2;
  width: 100%;
  height: 100%;
  background-color: #000;
}
@keyframes spin-75745e06 {
0% {
    transform: translate(-50%, -50%) rotate(0deg);
}
100% {
    transform: translate(-50%, -50%) rotate(360deg);
}
}
.footer[data-v-75745e06] {
  display: flex;
  gap: 1rem;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  margin-top: 10px;
  border-radius: 8px;
}
.footer .button[data-v-75745e06] {
  width: 84px;
  height: 32px;
}.tool-box[data-v-5bc7c4c4] {
  position: absolute;
  bottom: 72px;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 5px 0;
  background-color: var(--background-color-2);
  border-radius: 15px;
  box-shadow: 0 -8px 30px var(--footer-shadow-color);
}
.tool-box .tool-box-item[data-v-5bc7c4c4] {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  padding: 7px 10px;
  font-size: 12px;
  white-space: nowrap;
  cursor: pointer;
}
.tool-box .tool-box-item .icon[data-v-5bc7c4c4] {
  margin-right: 8px;
}
.tool-box .tool-box-item[data-v-5bc7c4c4]:hover {
  background: var(--tool-box-hover);
}
.tui-theme-black .tool-box[data-v-5bc7c4c4] {
  --tool-box-hover: rgba(46, 50, 61, 0.7);
}
.tui-theme-white .tool-box[data-v-5bc7c4c4] {
  --tool-box-hover: rgba(79, 88, 107, 0.05);
}.slider[data-v-ad442c24] {
  position: relative;
  width: 160px;
  height: 3px;
  background-color: #ddd;
  cursor: pointer;
}
.slider-track[data-v-ad442c24] {
  position: absolute;
  height: 100%;
  background-color: var(--active-color-1);
}
.slider-thumb[data-v-ad442c24] {
  position: absolute;
  top: 2px;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  transform: translate(-50%, -50%);
  transition: box-shadow 0.2s;
  cursor: pointer;
}
.slider-thumb-active[data-v-ad442c24] {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.4);
}
.slider-thumb-disabled[data-v-ad442c24] {
  background-color: #ccc;
  cursor: not-allowed;
}.test-preview[data-v-5a40ade5] {
  position: relative;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 310px;
  overflow: hidden;
  background-color: var(--black-color);
  border-radius: 8px;
}
.setting[data-v-5a40ade5] {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 10px;
  border: 1px solid var(--border-color-2);
  border-radius: 8px;
}
.setting-header[data-v-5a40ade5] {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 44px;
  color: var(--active-color-1);
  background-color: var(--background-color-13);
  border-bottom: 1px solid var(--border-color-2);
}
.setting-container[data-v-5a40ade5] {
  display: flex;
  width: 100%;
  padding: 20px;
}
.setting-item[data-v-5a40ade5] {
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-right: 20px;
  font-size: 12px;
  color: var(--font-color-4);
  text-align: center;
  cursor: pointer;
  border: 1px solid transparent;
  border-radius: 8px;
}
.setting-item-icon[data-v-5a40ade5] {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 54px;
  height: 54px;
  overflow: hidden;
  background-color: #f0f3fa;
  border-radius: 8px;
}
.setting-item.active[data-v-5a40ade5] {
  color: #fff;
  background-color: var(--active-color-1);
  border: 1px solid var(--active-color-1);
}
.reset[data-v-5a40ade5],
.compare[data-v-5a40ade5],
.degree[data-v-5a40ade5] {
  position: absolute;
  bottom: 8px;
  z-index: 4;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 30px;
  padding: 4px 12px;
  color: #fff;
  cursor: pointer;
  background-color: rgba(0, 0, 0, 0.4);
  border-radius: 6px;
}
.reset .text[data-v-5a40ade5],
.compare .text[data-v-5a40ade5],
.degree .text[data-v-5a40ade5] {
  margin-left: 4px;
}
.degree[data-v-5a40ade5] {
  left: 50%;
  cursor: default;
  transform: translateX(-50%);
}
.degree .slider[data-v-5a40ade5] {
  margin-left: 12px;
}
.degree .text-value[data-v-5a40ade5] {
  width: 20px;
  margin-left: 10px;
}
.reset[data-v-5a40ade5] {
  left: 8px;
}
.compare[data-v-5a40ade5] {
  right: 8px;
}
.spinner[data-v-5a40ade5] {
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 3;
  width: 40px;
  height: 40px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid var(--active-color-1);
  border-radius: 50%;
  transform: translate(-50%, -50%);
  animation: spin-5a40ade5 1s linear infinite;
}
.mask[data-v-5a40ade5] {
  position: absolute;
  z-index: 2;
  width: 100%;
  height: 100%;
  background-color: var(--black-color);
}
@keyframes spin-5a40ade5 {
0% {
    transform: translate(-50%, -50%) rotate(0deg);
}
100% {
    transform: translate(-50%, -50%) rotate(360deg);
}
}
.footer[data-v-5a40ade5] {
  display: flex;
  gap: 1rem;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  margin-top: 10px;
  border-radius: 8px;
}
.footer .button[data-v-5a40ade5] {
  width: 84px;
  height: 32px;
}
.footer .mirror-container[data-v-5a40ade5] {
  position: absolute;
  left: 24px;
  display: flex;
}
.footer .mirror-container .mirror-text[data-v-5a40ade5] {
  margin-left: 4px;
}
.cancel[data-v-5a40ade5] {
  margin-left: 12px;
}.footer-container[data-v-26cae62f] {
  position: absolute;
  bottom: 0;
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 0.7rem 0;
  padding-right: 24px;
  padding-left: 9px;
  background-color: var(--background-color-2);
  box-shadow: 0 -8px 30px var(--footer-shadow-color);
}
.footer-container .left-container[data-v-26cae62f] {
  display: flex;
  align-items: center;
  height: 100%;
}
.footer-container .left-container .left-container-item[data-v-26cae62f]:not(:first-child) {
  margin-left: 1rem;
}
.footer-container .center-container[data-v-26cae62f] {
  position: relative;
  display: flex;
  align-items: center;
  height: 100%;
  margin: 0 auto;
}
.footer-container .center-container .center-container-item[data-v-26cae62f]:not(:first-child) {
  margin-left: 16px;
}
.footer-container .right-container[data-v-26cae62f] {
  display: flex;
  align-items: center;
  height: 100%;
}.text-img[data-v-98238edd] {
  width: 20px;
  height: 20px;
  vertical-align: middle;
}
.text-box[data-v-98238edd] {
  line-height: 20px;
  vertical-align: middle;
}.tui-theme-white .message-body[data-v-71a45eaf] {
  --user-chat-color: rgba(213, 224, 242, 0.4);
  --user-font-color: var(--black-color);
  --host-font-color: var(--white-color);
}
.tui-theme-black .message-body[data-v-71a45eaf] {
  --user-chat-color: rgba(213, 224, 242, 0.1);
  --user-font-color: var(--background-color-4);
  --host-font-color: var(--background-color-4);
}
.message-list-container[data-v-71a45eaf] {
  flex: 1;
  height: 100%;
  overflow: auto;
}
.message-list-container .message-list[data-v-71a45eaf] {
  height: 100%;
  overflow: hidden auto;
}
.message-list-container .message-list[data-v-71a45eaf]::-webkit-scrollbar {
  display: none;
}
.message-list-container .message-top[data-v-71a45eaf] {
  display: flex;
  justify-content: center;
}
.message-list-container .message-item[data-v-71a45eaf] {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 8px;
  word-break: break-all;
}
.message-list-container .message-item[data-v-71a45eaf]:last-of-type {
  margin-bottom: 0;
}
.message-list-container .message-item.is-me[data-v-71a45eaf] {
  align-items: end;
}
.message-list-container .message-item.is-me .message-body[data-v-71a45eaf] {
  min-width: 24px;
  padding: 10px;
  color: var(--host-font-color);
  background-color: var(--active-color-1);
  border-radius: 8px;
}
.message-list-container .message-item .message-header[data-v-71a45eaf] {
  max-width: 180px;
  margin-bottom: 4px;
  overflow: hidden;
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  color: var(--font-color-8);
  text-overflow: ellipsis;
  white-space: nowrap;
}
.message-list-container .message-item .message-body[data-v-71a45eaf] {
  display: inline-block;
  padding: 10px;
  font-size: 14px;
  font-weight: 400;
  color: var(--user-font-color);
  background-color: var(--user-chat-color);
  border-radius: 8px;
}
.message-list-container-h5[data-v-71a45eaf] {
  width: 100%;
  height: 100%;
  padding: 10px 23px 10px 32px;
  background-color: var(--message-list-color-h5);
}
.message-list-container-h5 .message-list[data-v-71a45eaf] {
  height: 100%;
  overflow: hidden auto;
}
.message-list-container-h5 .message-list[data-v-71a45eaf]::-webkit-scrollbar {
  display: none;
}
.message-list-container-h5 .message-top[data-v-71a45eaf] {
  display: flex;
  justify-content: center;
}
.message-list-container-h5 .message-list[data-v-71a45eaf] {
  overflow-y: scroll;
}
.message-list-container-h5 .message-list .message-item[data-v-71a45eaf] {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 20px;
  word-break: break-all;
}
.message-list-container-h5 .message-list .message-item[data-v-71a45eaf]:last-of-type {
  margin-bottom: 0;
}
.message-list-container-h5 .message-list .message-item.is-me[data-v-71a45eaf] {
  align-items: end;
}
.message-list-container-h5 .message-list .message-item.is-me .message-body[data-v-71a45eaf] {
  display: inline-block;
  min-width: 24px;
  padding: 7px;
  font-size: 14px;
  font-weight: 400;
  color: #fff;
  background-color: #4791ff;
  border-radius: 8px;
}
.message-list-container-h5 .message-list .message-item .message-header[data-v-71a45eaf] {
  max-width: 180px;
  margin-bottom: 10px;
  overflow: hidden;
  font-size: 10px;
  font-style: normal;
  font-weight: 500;
  line-height: 14px;
  color: #ff7200;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.message-list-container-h5 .message-list .message-item .message-body[data-v-71a45eaf] {
  display: inline-block;
  padding: 7px;
  font-size: 14px;
  font-weight: 400;
  color: #fff;
  background-color: var(--message-body-h5);
  border-radius: 8px;
}.tui-theme-white .emoji-list[data-v-dbb2fbd2] {
  --emoji-box-shadow: 0px 2px 4px -3px rgba(32, 77, 141, 0.03),
    0px 6px 10px 1px rgba(32, 77, 141, 0.06),
    0px 3px 14px 2px rgba(32, 77, 141, 0.05);
}
.tui-theme-black .emoji-list[data-v-dbb2fbd2] {
  --emoji-box-shadow: 0px 8px 40px 0px rgba(23, 25, 31, 0.6),
    0px 4px 12px 0px rgba(23, 25, 31, 0.8);
}
.emoji-tool .emoji-icon[data-v-dbb2fbd2] {
  cursor: pointer;
}
.emoji-tool .emoji-list[data-v-dbb2fbd2],
.emoji-tool .emoji-list-h5[data-v-dbb2fbd2] {
  position: absolute;
  bottom: 160px;
  left: 0;
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  width: 100%;
  height: 204px;
  padding: 10px;
  overflow-y: auto;
  background-color: var(--background-color-8);
  border-radius: 8px;
  box-shadow: var(--emoji-box-shadow);
}
.emoji-tool .emoji-list[data-v-dbb2fbd2]::-webkit-scrollbar,
.emoji-tool .emoji-list-h5[data-v-dbb2fbd2]::-webkit-scrollbar {
  display: none;
}
.emoji-tool .emoji-list .emoji-item[data-v-dbb2fbd2]:hover,
.emoji-tool .emoji-list-h5 .emoji-item[data-v-dbb2fbd2]:hover {
  cursor: pointer;
}
.emoji-tool .emoji-list img[data-v-dbb2fbd2],
.emoji-tool .emoji-list-h5 img[data-v-dbb2fbd2] {
  width: 23px;
  height: 23px;
}
.emoji-tool .emoji-list-h5[data-v-dbb2fbd2] {
  position: fixed;
  bottom: 77px;
  left: 30px;
  width: 298px;
  height: 148px;
}.chat-editor[data-v-993047e8] {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100vw;
  padding-bottom: 5px;
}
.chat-editor .input-content[data-v-993047e8] {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 90%;
  height: 34px;
  font-family: "PingFang SC";
  font-size: 16px;
  font-style: normal;
  font-weight: 450;
  line-height: 4vh;
  color: #676c80;
  caret-color: var(--caret-color);
  resize: none;
  background: var(--chat-editor-input-color-h5);
  border: none;
  border-radius: 8px;
}
.chat-editor .input-content .chat-emoji[data-v-993047e8] {
  display: flex;
  align-items: center;
  justify-content: center;
}
.chat-editor .input-content .content-bottom-input[data-v-993047e8] {
  box-sizing: border-box;
  width: 84%;
  height: 34px;
  padding-left: 10px;
  font-family: "PingFang SC";
  font-size: 16px;
  font-style: normal;
  font-weight: 450;
  line-height: 4vh;
  color: #676c80;
  caret-color: var(--caret-color);
  resize: none;
  background: var(--chat-editor-input-color-h5);
  border: none;
  border-radius: 8px;
}
.chat-editor .input-content .content-bottom-input[data-v-993047e8] ::placeholder {
  font-family: "PingFang SC";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  color: #676c80;
}
.chat-editor .input-content .content-bottom-input[data-v-993047e8]:focus-visible {
  outline: none;
}
.chat-editor.disable .chat-emoji[data-v-993047e8] {
  pointer-events: none;
}.tui-theme-white textarea[data-v-be1f9416] {
  --input-border-color: var(--background-color-10);
  --chat-editor-color: var(--background-color-8);
}
.tui-theme-black textarea[data-v-be1f9416] {
  --input-border-color: rgba(213, 224, 242, 0.2);
  --chat-editor-color: var(--background-color-2);
}
.chat-editor[data-v-be1f9416] {
  position: relative;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 150px;
  padding: 12px 16px;
  margin-top: 20px;
  border: 1px solid var(--input-border-color);
  border-radius: 8px;
}
.chat-editor .chat-emoji[data-v-be1f9416] {
  display: flex;
}
.chat-editor .content-bottom-input[data-v-be1f9416] {
  box-sizing: border-box;
  height: 100%;
  padding: 0;
  margin-top: 8px;
  font-family: "PingFang SC";
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  color: var(--textarea-color);
  caret-color: var(--caret-color);
  resize: none;
  background: var(--chat-editor-color);
  border: none;
}
.chat-editor .content-bottom-input[data-v-be1f9416]:focus-visible {
  outline: none;
}
.chat-editor .content-bottom-input[data-v-be1f9416]::placeholder {
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  color: rgba(143, 154, 178, 0.7);
}
.chat-editor .content-bottom-input[data-v-be1f9416]::-webkit-scrollbar {
  display: none;
}
.chat-editor.disable[data-v-be1f9416] {
  background-color: var(--disable-color);
}
.chat-editor.disable .chat-emoji[data-v-be1f9416] {
  color: #8f9ab2;
  pointer-events: none;
}
.chat-editor.disable .content-bottom-input[data-v-be1f9416]:disabled {
  background-color: var(--disable-color);
}.chat-container-h5[data-v-92bd5d6b] {
  height: 100%;
}.chat-container[data-v-9a301e47] {
  width: 100%;
  height: 100%;
}
.chat-container-chat-scene[data-v-9a301e47] {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 20px;
}.member-invite-container[data-v-1d45fc0f] {
  display: flex;
  justify-content: end;
  width: 100%;
}
.member-invite-container .member-invite-reject[data-v-1d45fc0f] {
  display: flex;
  align-self: center;
  padding-right: 10px;
  font-size: 14px;
  font-weight: 400;
  color: var(--font-color-1);
}
.member-invite-container .member-invite-calling[data-v-1d45fc0f] {
  display: flex;
  align-items: center;
  padding-right: 10px;
  font-size: 14px;
  font-weight: 400;
  color: var(--font-color-1);
}
.member-invite-container .button[data-v-1d45fc0f] {
  width: 68px;
}.tui-theme-black .member-av-state[data-v-3e8cd65d] {
  --icon-color: #a3aec7;
}
.tui-theme-white .member-av-state[data-v-3e8cd65d] {
  --icon-color: #b2bbd1;
}
.member-info[data-v-3e8cd65d],
.member-info-mobile[data-v-3e8cd65d] {
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: 100%;
}
.member-info .member-basic-info[data-v-3e8cd65d],
.member-info .member-basic-info-admin[data-v-3e8cd65d],
.member-info-mobile .member-basic-info[data-v-3e8cd65d],
.member-info-mobile .member-basic-info-admin[data-v-3e8cd65d] {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.member-info .member-basic-info .avatar-url[data-v-3e8cd65d],
.member-info .member-basic-info-admin .avatar-url[data-v-3e8cd65d],
.member-info-mobile .member-basic-info .avatar-url[data-v-3e8cd65d],
.member-info-mobile .member-basic-info-admin .avatar-url[data-v-3e8cd65d] {
  display: flex;
  align-items: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
}
.member-info .member-basic-info .user-name[data-v-3e8cd65d],
.member-info .member-basic-info-admin .user-name[data-v-3e8cd65d],
.member-info-mobile .member-basic-info .user-name[data-v-3e8cd65d],
.member-info-mobile .member-basic-info-admin .user-name[data-v-3e8cd65d] {
  max-width: 100px;
  margin-left: 12px;
  overflow: hidden;
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  color: var(--font-color-1);
  text-overflow: ellipsis;
  white-space: nowrap;
}
.member-info .member-basic-info .role-info[data-v-3e8cd65d],
.member-info .member-basic-info-admin .role-info[data-v-3e8cd65d],
.member-info-mobile .member-basic-info .role-info[data-v-3e8cd65d],
.member-info-mobile .member-basic-info-admin .role-info[data-v-3e8cd65d] {
  display: flex;
}
.member-info .member-basic-info .role-info .master-icon[data-v-3e8cd65d],
.member-info .member-basic-info .role-info .admin-icon[data-v-3e8cd65d],
.member-info .member-basic-info-admin .role-info .master-icon[data-v-3e8cd65d],
.member-info .member-basic-info-admin .role-info .admin-icon[data-v-3e8cd65d],
.member-info-mobile .member-basic-info .role-info .master-icon[data-v-3e8cd65d],
.member-info-mobile .member-basic-info .role-info .admin-icon[data-v-3e8cd65d],
.member-info-mobile .member-basic-info-admin .role-info .master-icon[data-v-3e8cd65d],
.member-info-mobile .member-basic-info-admin .role-info .admin-icon[data-v-3e8cd65d] {
  display: flex;
  margin-left: 8px;
  color: var(--active-color-2);
}
.member-info .member-basic-info .role-info .admin-icon[data-v-3e8cd65d],
.member-info .member-basic-info-admin .role-info .admin-icon[data-v-3e8cd65d],
.member-info-mobile .member-basic-info .role-info .admin-icon[data-v-3e8cd65d],
.member-info-mobile .member-basic-info-admin .role-info .admin-icon[data-v-3e8cd65d] {
  color: var(--orange-color);
}
.member-info .member-basic-info .role-info .user-extra-info[data-v-3e8cd65d],
.member-info .member-basic-info .role-info .user-extra-info-admin[data-v-3e8cd65d],
.member-info .member-basic-info-admin .role-info .user-extra-info[data-v-3e8cd65d],
.member-info .member-basic-info-admin .role-info .user-extra-info-admin[data-v-3e8cd65d],
.member-info-mobile .member-basic-info .role-info .user-extra-info[data-v-3e8cd65d],
.member-info-mobile .member-basic-info .role-info .user-extra-info-admin[data-v-3e8cd65d],
.member-info-mobile .member-basic-info-admin .role-info .user-extra-info[data-v-3e8cd65d],
.member-info-mobile .member-basic-info-admin .role-info .user-extra-info-admin[data-v-3e8cd65d] {
  padding: 2px;
  padding: 0 6px;
  margin-left: 4px;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: var(--active-color-2);
}
.member-info .member-basic-info .role-info .user-extra-info-admin[data-v-3e8cd65d],
.member-info .member-basic-info-admin .role-info .user-extra-info-admin[data-v-3e8cd65d],
.member-info-mobile .member-basic-info .role-info .user-extra-info-admin[data-v-3e8cd65d],
.member-info-mobile .member-basic-info-admin .role-info .user-extra-info-admin[data-v-3e8cd65d] {
  color: var(--orange-color);
  transition: none;
}
.member-info .member-basic-info-admin .user-name[data-v-3e8cd65d],
.member-info-mobile .member-basic-info-admin .user-name[data-v-3e8cd65d] {
  max-width: 40px;
}
.member-info .member-invite[data-v-3e8cd65d],
.member-info-mobile .member-invite[data-v-3e8cd65d] {
  display: flex;
  align-items: center;
  height: 100%;
}
.member-info .member-av-state[data-v-3e8cd65d],
.member-info-mobile .member-av-state[data-v-3e8cd65d] {
  display: flex;
  align-items: center;
  height: 100%;
  color: var(--icon-color);
}
.member-info .member-av-state .state-icon[data-v-3e8cd65d],
.member-info-mobile .member-av-state .state-icon[data-v-3e8cd65d] {
  margin-left: 16px;
}
.member-info .member-av-state .disable-icon[data-v-3e8cd65d],
.member-info-mobile .member-av-state .disable-icon[data-v-3e8cd65d] {
  opacity: 0.4;
}
.member-info-mobile[data-v-3e8cd65d] {
  align-items: center;
  width: 80vw;
}.member-control-container[data-v-7c60aafc] {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 2;
  display: flex;
  flex-direction: column !important;
  width: 100%;
  padding: 22px 16px;
  background: var(--member-control-background-color-h5);
  border-radius: 15px 15px 0 0;
  animation-name: popup-7c60aafc;
  animation-duration: 200ms;
}
@keyframes popup-7c60aafc {
from {
    transform: scaleY(0);
    transform-origin: bottom;
}
to {
    transform: scaleY(1);
    transform-origin: bottom;
}
}
.member-control-container .member-title[data-v-7c60aafc] {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  margin-bottom: 10px;
}
.member-control-container .member-title .avatar-url[data-v-7c60aafc] {
  width: 30px;
  height: 30px;
  border-radius: 50%;
}
.member-control-container .member-title .member-title-content[data-v-7c60aafc] {
  margin-left: 10px;
  font-size: 16px;
  font-weight: 500;
  line-height: 22px;
  color: var(--member-title-content-h5);
}
.member-control-container .user-operate-item[data-v-7c60aafc] {
  display: flex;
  align-items: center;
  width: 100%;
  padding-top: 10px;
}
.member-control-container .user-operate-item .control-title[data-v-7c60aafc] {
  margin-left: 10px;
}
.agree-button[data-v-7c60aafc],
.cancel-button[data-v-7c60aafc] {
  display: flex;
  align-items: center;
  width: 50%;
  padding: 12px;
}
.agree-button[data-v-7c60aafc] {
  color: var(--active-color-1);
}
.tab-cancel[data-v-7c60aafc] {
  flex: 1;
  padding-right: 30px;
  text-align: end;
}
.input-content-container[data-v-7c60aafc] {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  z-index: 9999;
  box-sizing: border-box;
  width: 100vw;
  height: auto;
  background-color: var(--log-out-mobile);
}
.input-content-container .input-content[data-v-7c60aafc] {
  position: absolute;
  bottom: 0;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 10px;
  font-family: "PingFang SC";
  font-size: 16px;
  font-style: normal;
  font-weight: 450;
  line-height: 4vh;
  color: #676c80;
  resize: none;
  background: var(--background-color-1);
  border: none;
}
.input-content-container .input[data-v-7c60aafc] {
  width: 100%;
}
.input-content-container .content-bottom-input[data-v-7c60aafc] {
  box-sizing: border-box;
  width: 100%;
  height: 35px;
  padding-left: 12px;
  font-family: "PingFang SC";
  font-size: 16px;
  font-style: normal;
  font-weight: 450;
  line-height: 4vh;
  color: #676c80;
  caret-color: var(--caret-color);
  resize: none;
  background-color: var(--chat-editor-input-color-h5);
  border: none;
  border-radius: 45px;
}.tui-theme-black .user-operate-list[data-v-63576f66] {
  --operation-font-color: var(--font-color-1);
  --operation-box-shadow: 0px 3px 8px rgba(34, 38, 46, 0.3),
    0px 6px 40px rgba(34, 38, 46, 0.3);
}
.tui-theme-white .user-operate-list[data-v-63576f66] {
  --operation-font-color: #6b758a;
  --operation-box-shadow: 0px 3px 8px #e9f0fb, 0px 6px 40px rgba(0, 0, 0, 0.1);
}
.member-control-container[data-v-63576f66] {
  display: flex;
  flex-direction: row;
}
.member-control-container .button[data-v-63576f66] {
  height: 32px;
  padding: 0 10px;
  margin-left: 10px;
}
.member-control-container .button .more-arrow[data-v-63576f66] {
  margin-left: 2px;
}
.member-control-container .button .more-arrow.down[data-v-63576f66] {
  transform: rotate(180deg);
}
.member-control-container .more-container[data-v-63576f66] {
  position: relative;
}
.member-control-container .more-container .user-operate-list[data-v-63576f66] {
  position: absolute;
  z-index: 1;
  min-width: 160px;
  padding: 20px;
  background: var(--background-color-1);
  border-radius: 8px;
  box-shadow: var(--operation-box-shadow);
}
.member-control-container .more-container .user-operate-list[data-v-63576f66]::before {
  position: absolute;
  width: 0;
  content: "";
  border-top: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 10px solid var(--background-color-1);
  border-left: 10px solid transparent;
}
.member-control-container .more-container .user-operate-list[data-v-63576f66]::after {
  position: absolute;
  width: 100%;
  height: 20px;
  content: "";
  background-color: transparent;
}
.member-control-container .more-container .user-operate-list .user-operate-item[data-v-63576f66] {
  display: flex;
  align-items: center;
  height: 20px;
  color: var(--operation-font-color);
  cursor: pointer;
}
.member-control-container .more-container .user-operate-list .user-operate-item .operate-text[data-v-63576f66] {
  margin-left: 10px;
  font-size: 14px;
  white-space: nowrap;
}
.member-control-container .more-container .user-operate-list .user-operate-item[data-v-63576f66]:not(:first-child) {
  margin-top: 20px;
}
.member-control-container .more-container .down[data-v-63576f66] {
  top: calc(100% + 15px);
  right: 0;
}
.member-control-container .more-container .down[data-v-63576f66]::before {
  top: -20px;
  right: 20px;
}
.member-control-container .more-container .down[data-v-63576f66]::after {
  top: -20px;
  left: 0;
}
.member-control-container .more-container .up[data-v-63576f66] {
  right: 0;
  bottom: calc(100% + 15px);
}
.member-control-container .more-container .up[data-v-63576f66]::before {
  right: 20px;
  bottom: -20px;
  transform: rotate(180deg);
}
.member-control-container .more-container .up[data-v-63576f66]::after {
  bottom: -20px;
  left: 0;
}
.dialog-content[data-v-63576f66] {
  display: flex;
  align-items: center;
}
.dialog-content .dialog-input[data-v-63576f66] {
  flex-grow: 1;
}
.cancel[data-v-63576f66] {
  margin-left: 12px;
}.member-item-container[data-v-937b72bb] {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  height: 69px;
  padding: 0 32px;
}
.member-item-container[data-v-937b72bb]:hover {
  background: var(--member-item-container-hover-bg-color);
}.member-item-container[data-v-64ec8ff7] {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  height: 52px;
  padding: 0 20px;
}
.member-item-container[data-v-64ec8ff7]:hover {
  cursor: pointer;
  background: var(--hover-bg-color);
}
.tui-theme-black .member-item-container[data-v-64ec8ff7] {
  --hover-bg-color: rgba(79, 88, 107, 0.2);
}
.tui-theme-white .member-item-container[data-v-64ec8ff7] {
  --hover-bg-color: rgba(213, 224, 242, 0.3);
}.apply-info[data-v-33185ce2] {
  font-size: 14px;
  font-weight: 400;
  color: #fff;
}
.manage-member-container[data-v-33185ce2] {
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
}
.manage-member-container .manage-member-header .apply-on-stage-info[data-v-33185ce2] {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 40px;
  padding: 0 20px 0 26px;
}
.manage-member-container .manage-member-header .apply-on-stage-info .apply-icon[data-v-33185ce2] {
  color: var(--font-color-2);
}
.manage-member-container .manage-member-header .apply-on-stage-info .apply-info[data-v-33185ce2] {
  flex: 1;
  padding-left: 4px;
  font-size: 14px;
  font-weight: 400;
  color: var(--font-color-8);
}
.manage-member-container .manage-member-header .apply-on-stage-info .apply-check[data-v-33185ce2] {
  font-size: 14px;
  font-weight: 400;
  line-height: 32px;
  color: var(--active-color-2);
  text-align: center;
  cursor: pointer;
}
.manage-member-container .manage-member-header .button[data-v-33185ce2] {
  width: 82px;
  height: 32px;
  font-size: 14px;
  font-weight: 400;
  line-height: 32px;
  color: #fff;
  text-align: center;
  cursor: pointer;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid #fff;
  border-radius: 2px;
}
.manage-member-container .apply-count[data-v-33185ce2] {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 36px;
  margin: 16px 20px 0;
  cursor: pointer;
  background-color: var(--background-color-11);
  border-radius: 20px;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
.manage-member-container .apply-count .user-status[data-v-33185ce2] {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 80%;
  padding: 0 5px;
}
.manage-member-container .apply-count .user-status-container[data-v-33185ce2] {
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  height: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  border-radius: 20px;
}
.manage-member-container .apply-count .apply-staged[data-v-33185ce2],
.manage-member-container .apply-count .apply-not-stage[data-v-33185ce2] {
  font-size: 14px;
  font-weight: 400;
  color: var(--font-color-1);
  filter: drop-shadow(0 2px 4px rgba(32, 77, 141, 0.03)) drop-shadow(0 6px 10px rgba(32, 77, 141, 0.06)) drop-shadow(0 3px 14px rgba(32, 77, 141, 0.05));
  border-radius: 20px;
  transform: translateX(4px);
}
.manage-member-container .apply-count .apply-not-stage[data-v-33185ce2] {
  top: 50%;
  left: 50%;
  width: 176px;
  height: 30px;
  transform: translateY(-50%);
}
.manage-member-container .apply-count .apply-count-active[data-v-33185ce2] {
  background-color: var(--background-color-12);
}
.manage-member-container .global-setting[data-v-33185ce2] {
  display: flex;
  justify-content: space-around;
}
.manage-member-container .button-bottom[data-v-33185ce2] {
  width: 80%;
  display: flex;
  justify-content: center;
  padding: 13px 24px;
  font-weight: 400;
  color: var(--mute-button-color-h5);
  background-color: var(--manage-member-button-h5);
  border-radius: 10px;
}
.manage-member-container .member-list-container[data-v-33185ce2] {
  flex: 1;
  min-height: 0;
  overflow-y: scroll;
}
.manage-member-container .member-list-container .member-count[data-v-33185ce2] {
  margin-left: 5px;
}
.manage-member-container .member-list-container[data-v-33185ce2]::-webkit-scrollbar {
  display: none;
}
.manage-member-container .member-list-container .member-list-header[data-v-33185ce2] {
  padding: 0 32px;
  margin-bottom: 8px;
  font-size: 14px;
  font-weight: 500;
  line-height: 24px;
  color: var(--input-font-color);
}
.manage-member-container .member-list-container .member-list-content[data-v-33185ce2] {
  flex: 1;
  overflow-y: scroll;
}
.manage-member-container .manage-member-bottom[data-v-33185ce2] {
  z-index: 1;
  display: flex;
  justify-content: space-around;
  width: 100%;
}
.manage-member-container .manage-member-bottom .manage-member-button[data-v-33185ce2] {
  padding: 13px 24px;
  font-weight: 400;
  color: var(--mute-button-color-h5);
  background-color: var(--manage-member-button-h5);
  border-radius: 10px;
}
.manage-member-container .manage-member-bottom .lift-all[data-v-33185ce2] {
  color: var(--red-color);
}
.manage-member-container .popup-dialog-audio[data-v-33185ce2],
.manage-member-container .popup-dialog-video[data-v-33185ce2] {
  position: absolute;
  bottom: 46vh;
  left: 18vw;
  width: 64vw;
  white-space: nowrap;
  background: var(--popup-mute-background-color-h5);
  border-radius: 8px;
}
.manage-member-container .popup-dialog-audio .popup-dialog-audio-title[data-v-33185ce2],
.manage-member-container .popup-dialog-video .popup-dialog-audio-title[data-v-33185ce2] {
  padding: 20px;
  font-family: "PingFang SC";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
  color: #2b2e38;
  text-align: center;
  white-space: normal;
}
.manage-member-container .popup-dialog-audio .popup-button[data-v-33185ce2],
.manage-member-container .popup-dialog-video .popup-button[data-v-33185ce2] {
  display: flex;
  justify-content: space-evenly;
  padding: 10px;
}
.manage-member-container .popup-dialog-audio .popup-button .popup-button-cancel[data-v-33185ce2],
.manage-member-container .popup-dialog-video .popup-button .popup-button-cancel[data-v-33185ce2] {
  padding: 4px 16px;
  color: #646366;
  background-color: #fff;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
}
.manage-member-container .popup-dialog-audio .popup-button .popup-button-mute[data-v-33185ce2],
.manage-member-container .popup-dialog-video .popup-button .popup-button-mute[data-v-33185ce2] {
  padding: 4px 16px;
  color: #fff;
  background-color: #006eff;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
}
.agree[data-v-33185ce2],
.cancel[data-v-33185ce2] {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50%;
  padding: 14px;
  font-size: 16px;
  font-weight: 500;
  color: var(--active-color-1);
}
.cancel[data-v-33185ce2] {
  color: var(--font-color-4);
}
.more-control-container[data-v-33185ce2] {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  box-sizing: border-box;
  width: 100vw;
  height: auto;
  background-color: var(--log-out-mobile);
}
.more-control-container .more-control-container-main[data-v-33185ce2] {
  position: fixed;
  bottom: 0;
  display: flex;
  flex-direction: column;
  gap: 5px;
  width: 100%;
  padding: 50px 25px;
  padding-bottom: 4vh;
  background: var(--background-color-1);
  border-radius: 15px 15px 0 0;
  animation-name: popup-33185ce2;
  animation-duration: 200ms;
}
@keyframes popup-33185ce2 {
from {
    transform: scaleY(0);
    transform-origin: bottom;
}
to {
    transform: scaleY(1);
    transform-origin: bottom;
}
}
.more-control-container .user-operate-item[data-v-33185ce2] {
  display: flex;
  align-items: center;
  height: 20px;
  color: var(--popup-title-color-h5);
  cursor: pointer;
}
.more-control-container .user-operate-item .operate-text[data-v-33185ce2] {
  margin-left: 8px;
  font-family: "PingFang SC";
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  white-space: nowrap;
}.more-container[data-v-fdaa618a] {
  position: relative;
  display: flex;
}
.more-container .more-arrow[data-v-fdaa618a] {
  margin-left: 2px;
}
.more-container .more-arrow.down[data-v-fdaa618a] {
  transform: rotate(180deg);
}
.more-container .drop-down[data-v-fdaa618a] {
  position: absolute;
  right: 3px;
  bottom: 40px;
  z-index: 1;
  padding: 8px 7px;
  background: var(--background-color-1);
  border-radius: 8px;
  box-shadow: var(--operation-box-shadow);
}
.more-container .drop-down .user-operate-item[data-v-fdaa618a] {
  display: flex;
  align-items: center;
  height: 20px;
  margin: 5px 7px;
  color: var(--operation-font-color);
  cursor: pointer;
}
.more-container .drop-down .user-operate-item .operate-text[data-v-fdaa618a] {
  margin-left: 8px;
  font-family: "PingFang SC";
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  white-space: nowrap;
}
.tui-theme-black .search-container[data-v-fdaa618a] {
  --background-color: rgba(79, 88, 107, 0.3);
  --font-color: #636a7e;
}
.tui-theme-white .search-container[data-v-fdaa618a] {
  --background-color: var(--background-color-3);
  --font-color: var(--font-color-1);
}
.tui-theme-black .more-container[data-v-fdaa618a] {
  --operation-font-color: #6b758a;
  --operation-box-shadow: 0px 3px 8px rgba(34, 38, 46, 0.3),
    0px 6px 40px rgba(34, 38, 46, 0.3);
}
.tui-theme-white .more-container[data-v-fdaa618a] {
  --operation-font-color: #6b758a;
  --operation-box-shadow: 0px 3px 8px #e9f0fb, 0px 6px 40px rgba(0, 0, 0, 0.1);
}
.manage-member-container[data-v-fdaa618a] {
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
}
.manage-member-container .manage-member-header[data-v-fdaa618a] {
  display: flex;
  justify-content: space-around;
  padding: 23px 20px 0;
}
.manage-member-container .manage-member-header .search-container[data-v-fdaa618a] {
  display: flex;
  flex: 1;
  align-items: center;
  height: 32px;
  padding: 0 16px;
  color: var(--font-color-1);
  background-color: var(--background-color);
  border-radius: 16px;
}
.manage-member-container .manage-member-header .search-container .search-input[data-v-fdaa618a] {
  width: 100%;
  margin-left: 8px;
  font-size: 14px;
  color: var(--font-color-1);
  background: none;
  border: none;
  outline: none;
}
.manage-member-container .apply-count[data-v-fdaa618a] {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 36px;
  margin: 16px 20px 0;
  cursor: pointer;
  background-color: var(--background-color-11);
  border-radius: 20px;
}
.manage-member-container .apply-count .user-status[data-v-fdaa618a] {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 80%;
  padding: 0 5px;
}
.manage-member-container .apply-count .user-status-container[data-v-fdaa618a] {
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  height: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  border-radius: 20px;
}
.manage-member-container .apply-count .apply-staged[data-v-fdaa618a],
.manage-member-container .apply-count .apply-not-stage[data-v-fdaa618a] {
  font-size: 14px;
  font-weight: 400;
  color: var(--font-color-1);
  filter: drop-shadow(0 2px 4px rgba(32, 77, 141, 0.03)) drop-shadow(0 6px 10px rgba(32, 77, 141, 0.06)) drop-shadow(0 3px 14px rgba(32, 77, 141, 0.05));
  border-radius: 20px;
  transform: translateX(4px);
}
.manage-member-container .apply-count .apply-not-stage[data-v-fdaa618a] {
  top: 50%;
  left: 50%;
  width: 176px;
  height: 30px;
  transform: translateY(-50%);
}
.manage-member-container .apply-count .apply-count-active[data-v-fdaa618a] {
  background-color: var(--background-color-12);
}
.manage-member-container .apply-on-stage-info[data-v-fdaa618a] {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 60px;
  padding: 0 20px 0 32px;
  background-color: var(--background-color-8);
}
.manage-member-container .apply-on-stage-info .apply-icon[data-v-fdaa618a] {
  color: var(--font-color-2);
}
.manage-member-container .apply-on-stage-info .apply-info[data-v-fdaa618a] {
  flex: 1;
  padding-left: 4px;
  font-size: 14px;
  font-weight: 400;
  color: var(--font-color-8);
}
.manage-member-container .apply-on-stage-info .apply-check[data-v-fdaa618a] {
  font-size: 14px;
  font-weight: 400;
  line-height: 32px;
  color: var(--active-color-2);
  text-align: center;
  cursor: pointer;
}
.manage-member-container .apply-on-stage-info[data-v-fdaa618a]::after {
  position: absolute;
  bottom: 0;
  left: 5%;
  width: 90%;
  height: 1px;
  content: "";
  background-color: var(--stroke-color-2);
}
.manage-member-container .member-list-container[data-v-fdaa618a] {
  flex: 1;
  margin-top: 10px;
  overflow-y: scroll;
}
.manage-member-container .member-list-container[data-v-fdaa618a]::-webkit-scrollbar {
  display: none;
}
.manage-member-container .global-setting[data-v-fdaa618a] {
  display: flex;
  justify-content: space-around;
  margin: 20px 0;
  cursor: pointer;
}
.manage-member-container .button-bottom[data-v-fdaa618a] {
  width: 80%;
}
.cancel-button[data-v-fdaa618a] {
  margin-left: 12px;
}.sidebar-container-mobile[data-v-17af241e] {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 101;
  height: 100%;
}.overlay-container[data-v-58b56f8e] {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2007;
}
.overlay-container.overlay[data-v-58b56f8e] {
  background-color: rgba(15, 16, 20, 0.6);
}
.tui-theme-white .drawer-container[data-v-58b56f8e] {
  --background-color: var(--background-color-1);
  --box-shadow: 0px 2px 4px rgba(32, 77, 141, 0.03),
    0px 6px 10px rgba(32, 77, 141, 0.06), 0px 3px 14px rgba(32, 77, 141, 0.05);
}
.tui-theme-black .drawer-container[data-v-58b56f8e] {
  --background-color: var(--background-color-2);
  --box-shadow: 0px -8px 30px rgba(15, 16, 20, 0.5);
}
.drawer-container[data-v-58b56f8e] {
  position: absolute;
  right: 0;
  display: flex;
  flex-direction: column;
  height: 100%;
  background-color: var(--background-color);
  border-radius: 8px 0 0 8px;
  box-shadow: var(--box-shadow);
}
.drawer-container .drawer-header[data-v-58b56f8e] {
  position: relative;
  display: flex;
  align-items: center;
  height: 64px;
  padding: 0 20px;
  box-shadow: 0 1px 0 var(--stroke-color);
}
.drawer-container .drawer-header .drawer-header-title[data-v-58b56f8e] {
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  color: var(--font-color-1);
}
.drawer-container .drawer-header .close[data-v-58b56f8e] {
  position: absolute;
  top: 50%;
  right: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  color: var(--font-color-1);
  cursor: pointer;
  transform: translateY(-50%);
}
.drawer-container .drawer-content[data-v-58b56f8e] {
  flex: 1;
  overflow: auto;
}.conversation[data-v-e459c8be] {
  height: 100%;
  padding: 20px;
  overflow-y: auto;
}
.conversation-group[data-v-e459c8be] {
  margin-bottom: 20px;
}
.title[data-v-e459c8be] {
  display: flex;
  gap: 10px;
  align-items: center;
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  color: var(--font-color-4);
  text-align: left;
}
.title .speaker[data-v-e459c8be] {
  max-width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.content[data-v-e459c8be] {
  padding: 8px;
  margin-top: 5px;
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  text-align: left;
  background-color: var(--background-color-7);
  border-radius: 8px;
}.swiper[data-v-8b76ba67] {
  position: relative;
  width: 100%;
  height: 100%;
}
.swiper .swiper-item-container[data-v-8b76ba67] {
  display: flex;
  transition: transform 0.3s;
}
.swiper .swiper-dot-container[data-v-8b76ba67] {
  position: absolute;
  bottom: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}
.swiper .swiper-dot-container .swiper-dots[data-v-8b76ba67] {
  width: 8px;
  height: 8px;
  margin: 5px;
  background: #fff;
  border-radius: 20px;
  opacity: 0.6;
}
.swiper .swiper-dot-container .swiper-current-dots[data-v-8b76ba67] {
  width: 8px;
  height: 8px;
  margin: 5px;
  background: #fff;
  border-radius: 20px;
  opacity: 1;
}.swiper-item[data-v-31f92072] {
  flex-shrink: 0;
}.stream-play-container[data-v-d6937b63] {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
}.stream-cover-container[data-v-a782c722] {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 2px solid transparent;
  border-radius: 12px;
  pointer-events: none;
}
.stream-cover-container.border[data-v-a782c722] {
  border: 2px solid #37e858;
}
@keyframes loading-rotate-a782c722 {
0% {
    transform: rotate(0deg);
}
100% {
    transform: rotate(360deg);
}
}
.stream-cover-container .loading-region[data-v-a782c722] {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.stream-cover-container .loading-region .loading[data-v-a782c722] {
  animation: loading-rotate-a782c722 1.5s linear infinite;
}
.stream-cover-container .corner-user-info-container[data-v-a782c722] {
  position: absolute;
  bottom: 8px;
  left: 8px;
  display: flex;
  align-content: center;
  align-items: center;
  min-width: 118px;
  max-width: 100%;
  height: 32px;
  padding: 0 10px 0 0;
  overflow: hidden;
  font-size: 14px;
  color: #fff;
  background: var(--user-info-container-bg-color);
  border-radius: 16px;
}
.stream-cover-container .corner-user-info-container .user-name[data-v-a782c722] {
  margin-left: 8px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.stream-cover-container .corner-user-info-container .user-name.is-pc[data-v-a782c722] {
  max-width: 160px;
}
.stream-cover-container .corner-user-info-container .user-name.is-mobile[data-v-a782c722] {
  max-width: 60px;
  margin-left: 4px;
}
.stream-cover-container .corner-user-info-container .master-icon[data-v-a782c722],
.stream-cover-container .corner-user-info-container .admin-icon[data-v-a782c722] {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  margin-left: 0;
  background-color: var(--active-color-1);
  border-radius: 50%;
}
.stream-cover-container .corner-user-info-container .admin-icon[data-v-a782c722] {
  background-color: var(--orange-color);
}
.stream-cover-container .corner-user-info-container .audio-icon[data-v-a782c722] {
  margin-left: 8px;
}
.stream-cover-container .corner-user-info-container .audio-icon.is-mobile[data-v-a782c722] {
  max-width: 26px;
  max-height: 35px;
  margin-left: 4px;
}
.stream-cover-container .corner-user-info-container .screen-icon[data-v-a782c722] {
  background-size: cover;
  transform: scale(0.8);
}
.stream-cover-container .center-user-info-container[data-v-a782c722] {
  position: absolute;
  top: -2px;
  left: -2px;
  width: calc(100% + 4px);
  height: calc(100% + 4px);
  background-color: var(--background-color-1);
}
.stream-cover-container .center-user-info-container[data-v-a782c722]::before {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  content: "";
  background-color: var(--user-has-no-camera-bg-color);
}
.stream-cover-container .center-user-info-container .avatar-region[data-v-a782c722] {
  position: absolute;
  top: 50%;
  left: 50%;
  width: min(130px, 40%);
  height: 0;
  padding-top: min(130px, 40%);
  transform: translate(-50%, -50%);
}
.stream-cover-container .center-user-info-container .user-info[data-v-a782c722] {
  width: 130px;
  text-align: center;
}
.stream-cover-container .center-user-info-container .user-info .avatar-region[data-v-a782c722] {
  width: 130px;
  height: 130px;
  border-radius: 50%;
}
.stream-cover-container .center-user-info-container .user-info .user-gender-name svg[data-v-a782c722] {
  vertical-align: bottom;
}
.stream-cover-container .center-user-info-container .user-info .user-gender-name .user-name[data-v-a782c722] {
  display: inline-block;
  max-width: 100px;
  margin-left: 6px;
  overflow: hidden;
  font-size: 14px;
  font-weight: 400;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: bottom;
}
.tui-theme-white .stream-cover-container[data-v-a782c722] {
  --user-has-no-camera-bg-color: rgba(228, 232, 238, 0.4);
  --user-info-container-bg-color: rgba(18, 23, 35, 0.8);
}
.tui-theme-black .stream-cover-container[data-v-a782c722] {
  --user-has-no-camera-bg-color: rgba(34, 38, 46, 0.5);
  --user-info-container-bg-color: rgba(34, 38, 46, 0.8);
}.local-screen-container[data-v-a9890977] {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background-color: var(--background-color-1);
}
.local-screen-container[data-v-a9890977]::before {
  width: 100%;
  height: 100%;
  content: "";
  background-color: var(--local-screen-stream-bg-color);
}
.local-screen-container .local-screen-control-container[data-v-a9890977] {
  position: absolute;
  top: 50%;
  left: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: var(--screen-font-color);
  transform: translate(-50%, -50%);
}
.local-screen-container .local-screen-control-container.mini[data-v-a9890977] {
  transform: translate(-50%, -50%) scale(0.7);
}
.local-screen-container .local-screen-control-container .local-screen-info[data-v-a9890977] {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.local-screen-container .local-screen-control-container .local-screen-info .text[data-v-a9890977] {
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  white-space: nowrap;
}
.local-screen-container .local-screen-control-container .stop-button[data-v-a9890977] {
  margin-top: 30px;
  background-color: var(--red-color-3);
  border: 1.5px solid var(--red-color-3);
}
.tui-theme-white .local-screen-container[data-v-a9890977] {
  --local-screen-stream-bg-color: rgba(228, 232, 238, 0.4);
  --screen-font-color: #8f9ab2;
}
.tui-theme-black .local-screen-container[data-v-a9890977] {
  --screen-font-color: #b2bbd1;
  --local-screen-stream-bg-color: rgba(34, 38, 46, 0.5);
}
.dialog-button[data-v-a9890977] {
  margin-right: 12px;
}.stream-region-container[data-v-041784be] {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.stream-region-container .stream-region[data-v-041784be] {
  position: relative;
  overflow: hidden;
  background-color: #000;
  border-radius: 12px;
}.equal-points-layout[data-v-923eab12] {
  display: flex;
  place-content: center center;
  align-items: center;
  width: 100%;
  height: 100%;
}
.equal-points-layout .stream-list[data-v-923eab12] {
  display: flex;
  flex-wrap: wrap;
  place-content: flex-start flex-start;
}
.equal-points-layout .stream-list .stream-list-item[data-v-923eab12] {
  margin: var(--stream-margin);
}
.horizontal-infinity-layout[data-v-923eab12] {
  display: flex;
  justify-content: center;
  width: 100%;
  height: 100%;
}
.horizontal-infinity-layout .stream-list[data-v-923eab12] {
  display: flex;
  max-width: 100%;
  max-height: 100%;
  overflow-x: scroll;
  scrollbar-width: none;
  -ms-overflow-style: none;
}
.horizontal-infinity-layout .stream-list[data-v-923eab12]::-webkit-scrollbar {
  display: none;
}
.horizontal-infinity-layout .stream-list-item[data-v-923eab12]:not(:first-child) {
  margin-left: 14px;
}
.vertical-infinity-layout[data-v-923eab12] {
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
}
.vertical-infinity-layout .stream-list[data-v-923eab12] {
  max-width: 100%;
  max-height: 100%;
  padding: 10px 0;
  overflow-y: scroll;
  scrollbar-width: none;
  -ms-overflow-style: none;
}
.vertical-infinity-layout .stream-list[data-v-923eab12]::-webkit-scrollbar {
  display: none;
}
.vertical-infinity-layout .stream-list-item[data-v-923eab12]:not(:first-child) {
  margin-top: 14px;
}.multi-stream-view[data-v-829bdd47] {
  position: relative;
  display: flex;
  width: 100%;
  height: 100%;
  background-color: var(--stream-container-flatten-bg-color);
}
.page-stream-container[data-v-829bdd47] {
  position: relative;
  flex-shrink: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
}.turn-page-container[data-v-3b2db5bb] {
  position: absolute;
  top: 50%;
  left: 0;
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: 60px;
  transform: translateY(-50%);
}
.turn-page-container .turn-page-arrow-container[data-v-3b2db5bb] {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 60px;
  color: var(--turn-page-arrow-color);
  cursor: pointer;
  background: var(--turn-page-background-color);
  backdrop-filter: blur(2.25px);
  border-radius: 32px;
}
.turn-page-container .turn-page-arrow-container[data-v-3b2db5bb]:hover {
  background: var(--turn-page-hover-background-color);
}
.turn-page-container .left-container[data-v-3b2db5bb] {
  position: absolute;
  left: 34px;
}
.turn-page-container .right-container[data-v-3b2db5bb] {
  position: absolute;
  right: 34px;
}
.turn-page-container .turn-page-right[data-v-3b2db5bb] {
  transform: rotateY(180deg);
}
.tui-theme-black .turn-page-container[data-v-3b2db5bb] {
  --turn-page-background-color: rgba(114, 122, 138, 0.4);
  --turn-page-hover-background-color: rgba(114, 122, 138, 0.7);
  --turn-page-arrow-color: #d5e0f2;
}
.tui-theme-white .turn-page-container[data-v-3b2db5bb] {
  --turn-page-background-color: rgba(114, 122, 138, 0.4);
  --turn-page-hover-background-color: rgba(114, 122, 138, 0.7);
  --turn-page-arrow-color: white;
}.stream-container {
  position: relative;
  display: flex;
  width: 100%;
  height: 100%;
  background-color: var(--stream-container-flatten-bg-color);
}
.page-stream-container {
  position: relative;
  flex-shrink: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.enlarge-stream {
  width: 100%;
  height: 100%;
}
.float-stream {
  position: absolute;
  top: 0;
  right: 0;
}
.float-stream.show-room-tool {
  top: 64px;
}.arrow-stroke-container-left[data-v-e586d337] {
  width: 8px;
  height: 100%;
}
.arrow-stroke-container-left .stroke-content[data-v-e586d337] {
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: transparent;
  transform: perspective(20px) rotateX(0deg) rotateY(-20deg) translateZ(0);
}
.arrow-stroke-container-left .stroke-content .arrow-content[data-v-e586d337] {
  position: absolute;
  top: 50%;
  left: 0;
  width: 5px;
  height: 60px;
  cursor: pointer;
  transform: translateY(-50%);
}
.arrow-stroke-container-left .stroke-content .arrow-content[data-v-e586d337]::before {
  position: absolute;
  top: 0;
  right: -15px;
  box-sizing: border-box;
  width: 20px;
  height: 100%;
  content: "";
  background-color: rgba(15, 16, 20, 0.3);
  border: 1px solid rgba(143, 154, 178, 0.1);
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
}
.arrow-stroke-container-left .stroke-content.has-stroke .arrow-content[data-v-e586d337] {
  position: absolute;
  top: 50%;
  left: 0;
  width: 5px;
  height: 60px;
  cursor: pointer;
  border-top: 1px solid var(--stroke-color);
  border-bottom: 1px solid var(--stroke-color);
  border-left: 1px solid var(--stroke-color);
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  transform: translateY(-50%);
}
.arrow-stroke-container-left .stroke-content.has-stroke .arrow-content[data-v-e586d337]::before {
  position: absolute;
  top: 0;
  right: -15px;
  width: 20px;
  height: 100%;
  content: "";
  background-color: transparent;
  border: 0;
}
.arrow-stroke-container-left .stroke-content.has-stroke[data-v-e586d337]::before {
  position: absolute;
  top: 0;
  right: 0;
  width: 2px;
  height: calc((100% - 60px) / 2);
  content: "";
  border-right: 1px solid var(--stroke-color);
  border-bottom: 1px solid var(--stroke-color);
  border-bottom-right-radius: 4px;
}
.arrow-stroke-container-left .stroke-content.has-stroke[data-v-e586d337]::after {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 2px;
  height: calc((100% - 60px) / 2);
  content: "";
  border-top: 1px solid var(--stroke-color);
  border-right: 1px solid var(--stroke-color);
  border-top-right-radius: 4px;
}
.arrow-stroke-container-left .arrow[data-v-e586d337] {
  position: absolute;
  top: 50%;
  left: 6px;
  color: #d5e0f2;
  cursor: pointer;
  transition: color 0s;
  transform: translateY(-50%);
}
.arrow-stroke-container-left .arrow svg[data-v-e586d337] {
  transition: color 0s;
}
.arrow-stroke-container-bottom[data-v-e586d337] {
  width: 100%;
  height: 8px;
}
.arrow-stroke-container-bottom .stroke-content[data-v-e586d337] {
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: transparent;
  transform: perspective(20px) rotateX(-20deg) rotateY(0deg) translateZ(0);
}
.arrow-stroke-container-bottom .stroke-content .arrow-content[data-v-e586d337] {
  position: absolute;
  bottom: 0;
  left: 50%;
  width: 60px;
  height: 5px;
  cursor: pointer;
  transform: translateX(-50%);
}
.arrow-stroke-container-bottom .stroke-content .arrow-content[data-v-e586d337]::before {
  position: absolute;
  bottom: 0;
  box-sizing: border-box;
  width: 100%;
  height: 20px;
  content: "";
  background-color: rgba(15, 16, 20, 0.3);
  border: 1px solid rgba(143, 154, 178, 0.1);
  border-bottom-right-radius: 10px;
  border-bottom-left-radius: 10px;
}
.arrow-stroke-container-bottom .stroke-content.has-stroke .arrow-content[data-v-e586d337] {
  position: absolute;
  bottom: 0;
  left: 50%;
  width: 60px;
  height: 5px;
  cursor: pointer;
  border-right: 1px solid var(--stroke-color);
  border-bottom: 1px solid var(--stroke-color);
  border-left: 1px solid var(--stroke-color);
  border-bottom-right-radius: 4px;
  border-bottom-left-radius: 4px;
  transform: translateX(-50%);
}
.arrow-stroke-container-bottom .stroke-content.has-stroke .arrow-content .arrow[data-v-e586d337] {
  color: #a4bbdb;
}
.arrow-stroke-container-bottom .stroke-content.has-stroke .arrow-content[data-v-e586d337]::before {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 20px;
  content: "";
  background-color: transparent;
  border: 0;
}
.arrow-stroke-container-bottom .stroke-content.has-stroke[data-v-e586d337]::before {
  position: absolute;
  top: 0;
  left: 0;
  width: calc((100% - 60px) / 2);
  height: 2px;
  content: "";
  border-top: 1px solid var(--stroke-color);
  border-right: 1px solid var(--stroke-color);
  border-top-right-radius: 4px;
}
.arrow-stroke-container-bottom .stroke-content.has-stroke[data-v-e586d337]::after {
  position: absolute;
  top: 0;
  right: 0;
  width: calc((100% - 60px) / 2);
  height: 2px;
  content: "";
  border-top: 1px solid var(--stroke-color);
  border-left: 1px solid var(--stroke-color);
  border-top-left-radius: 4px;
}
.arrow-stroke-container-bottom .arrow[data-v-e586d337] {
  position: absolute;
  bottom: 4px;
  left: 50%;
  color: #d5e0f2;
  cursor: pointer;
  transition: color 0s;
  transform: translateX(-50%);
}
.arrow-stroke-container-bottom .arrow svg[data-v-e586d337] {
  transition: color 0s;
}
.up[data-v-e586d337] {
  transform: rotate(90deg);
}
.left[data-v-e586d337] {
  transform: rotate(0deg);
}
.down[data-v-e586d337] {
  transform: rotate(-90deg);
}
.right[data-v-e586d337] {
  transform: rotate(180deg);
}.stream-container-flatten[data-v-d8393878] {
  width: 100%;
  height: 100%;
  padding: 25px 20px;
  overflow: hidden;
}
.stream-container-flatten .stream-list-container[data-v-d8393878] {
  width: 100%;
  height: 100%;
}
.arrow-stroke-right[data-v-d8393878] {
  position: absolute;
  top: 0;
  right: 280px;
}
.arrow-stroke-left[data-v-d8393878] {
  position: absolute;
  top: 0;
  right: 12px;
}
.arrow-stroke-up[data-v-d8393878] {
  position: absolute;
  top: 175px;
  left: 0;
}
.arrow-stroke-down[data-v-d8393878] {
  position: absolute;
  top: 76px;
  left: 0;
}
.stream-container-top .single-stream[data-v-d8393878]:not(:first-child) {
  margin-left: 14px;
}
.stream-container-right .single-stream[data-v-d8393878]:not(:first-child) {
  margin-top: 14px;
}
.stream-container-top[data-v-d8393878] {
  position: relative;
  display: flex;
  flex-direction: column-reverse;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.stream-container-top .enlarged-stream-container[data-v-d8393878] {
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  min-width: 0;
  min-height: 0;
  padding: 25px 20px;
}
.stream-container-top .stream-list-container[data-v-d8393878] {
  position: relative;
  width: 100%;
  height: 175px;
  padding: 20px 40px;
}
.stream-container-top .stream-list-container.hide-list[data-v-d8393878] {
  position: absolute;
  top: 0;
  left: 0;
  transform: translateY(-166px);
}
.stream-container-right[data-v-d8393878] {
  position: relative;
  display: flex;
  flex-wrap: nowrap;
  place-content: center space-between;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.stream-container-right .enlarged-stream-container[data-v-d8393878] {
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  width: calc(100% - 280px);
  height: 100%;
  padding: 25px 20px;
}
.stream-container-right .stream-list-container[data-v-d8393878] {
  position: relative;
  width: 280px;
  height: 100%;
  padding: 20px;
}
.stream-container-right .stream-list-container.hide-list[data-v-d8393878] {
  position: absolute;
  top: 0;
  right: 0;
  width: 280px;
  transform: translateX(270px);
}
.stream-container-right .stream-list-container[data-v-d8393878]::before {
  position: absolute;
  top: 10px;
  left: 0;
  width: 100%;
  height: 40px;
  content: "";
  opacity: 0.1;
}.content-container[data-v-7bb2184d] {
  width: 100%;
  height: 100%;
  overflow: hidden;
}.overlay-container[data-v-cadaf945] {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2007;
}
.overlay-container.overlay[data-v-cadaf945] {
  background-color: rgba(15, 16, 20, 0.6);
}
.setting-container[data-v-cadaf945] {
  position: absolute;
  top: 50%;
  left: 50%;
  display: flex;
  flex-direction: column;
  width: 610px;
  height: 590px;
  background-color: #fff;
  border-radius: 20px;
  transform: translate(-50%, -50%);
}
.setting-container .setting-header[data-v-cadaf945] {
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  height: 64px;
  border-bottom: 1px solid rgb(235, 240, 247);
  box-shadow: 0 7px 10px -5px rgba(230, 236, 245, 0.8);
}
.setting-container .setting-header .close-icon[data-v-cadaf945] {
  position: absolute;
  top: 50%;
  right: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  color: #4f586b;
  cursor: pointer;
  transform: translateY(-50%);
}
.setting-container .setting-header .setting-title[data-v-cadaf945] {
  display: inline-block;
  padding: 20px 0 20px 24px;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  color: #000;
}
.setting-container .setting-body[data-v-cadaf945] {
  display: flex;
  height: 100%;
}
.setting-container .setting-body .setting-tabs[data-v-cadaf945] {
  width: 170px;
  padding-top: 7px;
  background-color: #f0f3fa;
  border-bottom-left-radius: 10px;
}
.setting-container .setting-body .setting-tabs .tabs-title[data-v-cadaf945] {
  position: relative;
  width: 100%;
  height: 36px;
  padding-left: 32px;
  font-size: 14px;
  font-weight: 400;
  line-height: 36px;
  color: #4f586b;
  cursor: pointer;
}
.setting-container .setting-body .setting-tabs .tabs-title.active[data-v-cadaf945] {
  font-weight: 400;
  color: #fff;
  background-color: #1c66e5;
}
.setting-container .setting-body .divide-line[data-v-cadaf945] {
  width: 1px;
  height: 100%;
  background: var(--divide-line-color-setting);
}
.setting-container .setting-body .setting-content[data-v-cadaf945] {
  flex-grow: 1;
  padding: 16px 30px;
}
.setting-container .setting-body .setting-content .setting-tab[data-v-cadaf945] {
  width: 100%;
}.ai-subtitles[data-v-dd3035b9] {
  position: absolute;
  bottom: 80px;
  left: 50%;
  padding: 10px 12px;
  color: #fff;
  background-color: rgba(79, 88, 107, 0.7);
  border-radius: 8px;
  transform: translateX(-50%);
}.loading-overlay[data-v-88005025] {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: var(--background-color-1);
}
.loading[data-v-88005025] {
  animation: loading-rotate-88005025 1s linear infinite;
}
.loading-text[data-v-88005025] {
  margin-top: 10px;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  color: var(--font-color-1);
}
@keyframes loading-rotate-88005025 {
0% {
    transform: rotate(0deg);
}
100% {
    transform: rotate(360deg);
}
}.svg-icon[data-v-ab8ed39b] {
  cursor: pointer;
}
.button[data-v-ab8ed39b] {
  margin-left: 12px;
}body, html {
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;
}
#roomContainer {
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;
  overflow: hidden;
  touch-action: manipulation;
  user-select: none;
}
#roomContainer *, ::before, ::after {
  box-sizing: border-box;
}
.pre-conference-container *, ::before, ::after {
  box-sizing: border-box;
}
.tui-theme-black {
  --background-color-1: #0F1014;
  --background-color-2: #22262E;
  --background-color-3: #4F586B;
  --background-color-4: #D5E0F2;
  --background-color-5: transparent;
  --background-color-6: #373942;
  --background-color-7: #2E323D;
  --background-color-8: #22262E;
  --background-color-9: #2E323D;
  --background-color-10: #2B2F38;
  --background-color-11: #2B303A;
  --background-color-12: #4F586B;
  --background-color-13: #F9FAFD;
  --hover-background-colo-1: rgba(213, 224, 242, 0.5);
  --font-color-1: #D5E0F2;
  --font-color-2: #6B758A;
  --font-color-3: #B3B8C8;
  --font-color-4: #4F586B;
  --font-color-5: #7C85A6;
  --font-color-6: #CFD5E6;
  --font-color-7: #FFF;
  --font-color-8: #8F9AB2;
  --font-color-9: #969EB4;
  --font-color-10: #FF643D;
  --title-color: #000;
  --stroke-color: rgba(79, 88, 107, 0.30);
  --stroke-color-2: #434956;
  --border-color: #2E323D;
  --border-color-2: #E4E8EE;
  --disable-color: #2B2F38;
  --active-color-1: #1C66E5;
  --active-color-2: #4791FF;
  --green-color: #27C39F;
  --orange-color: #F06C4B;
  --white-color: #FFF;
  --black-color: #000;
  --red-color: #ED414D;
  --red-color-2: #F23C5B;
  --red-color-3: #E5395C;
  --color-font: #D5E0F2;
  --control-content: rgba(27, 30, 38, 0.9);
  --background-image-color: rgba(61,119,255,0.53);
  --input-color: rgba(27,30,38,0.90);
  --create-room-mode-color-bg:#1D2437;
  --user-control-container-color-bg: rgba(46,50,61,0.60);
  --user-control-container-shadow: none;
  --stream-container-flatten-bg-color: #0D0F15;
  --room-header-bg-color: #1D2029;
  --room-footer-bg-color: #1D2029;
  --room-network-bg-color: #1D2029;
  --room-audiotab-bg-color: #1D2029;
  --room-videotab-bg-color: #1D2029;
  --stop-share-region-bg-color: #1D2029;
  --setting-dialog-bg-color: #1D2029;
  --icon-arrow-hover: rgba(46,50,61,0.70);
  --el-dialog-bg-color: #1D2029;
  --tabs-title-font-color: #7C85A6;
  --center-user-info-container-bg-color: #0D0F15;
  --stream-info-bg-color: #0D0F15;
  --el-dialog-bg-color-select: #1D2029;
  --el-text-color-primary-select: #CFD4E6;
  --el-text-color-regular-select: #7C85A6;
  --el-fill-color-blank-select: #2E323D;
  --el-border-color-select: #2E323D;
  --setting-name-color: #CFD4E6;
  --el-drawer-header-color: #CFD4E6;
  --user-extra-info-bg-color: #4D70FF;
  --user-extra-info-color: #2E323D;
  --check-select-color: #FFF;
  --member-item-container-hover-bg-color: rgba(46,50,61,0.70);
  --el-bg-color-select: #1D2029;
  --el-bg-color-overlay-select: #1D2029;
  --el-border-color-light-select: #2E323D;
  --el-fill-color-light-select: #2E323D;
  --input-bg-color: #2E323D;
  --input-font-color: #CFD5E6;
  --input-border-color: #2E323D;
  --invite-title-color: #CFD4E6;
  --chat-editor-bg-color: #2E323D;
  --chat-editor-input-color:#292D38;
  --message-list-color: #1D2029;
  --textarea-color: #fff;
  --send-btn-color: #3D4352;
  --message-color: #3D4352;
  --background-color-style: #010101;
  --stream-container-border: #1B1E26;
  --apply-list-container-bg-color: #1D2029;
  --apply-list-container-color: #CFD4E6;
  --room-sidebar-bg-color: #1D2029;
  --create-room-option: rgba(50,59,84,0.60);
  --create-room-option-color: #EEE;
  --create-room-option-tab: #006EFF;
  --create-room-option-icon: #EEE;
  --create-room-option-icon-color:#EEE;
  --control-region-bg-color: rgba(13,16,21,0.60);
  --dialog-tabs-bg-color: rgba(0,0,0,0.20);
  --divide-line-color: #2E323D;
  --divice-line: #CFD4E6;
  --el-drawer-divide: #0D0F15;
  --send-btn: #CFD4E6;
  --invite-region: #FFF;
  --layout-list: #1D2029;
  --layout-item: #2E323D;
  --stream-list-container: #1D2029;
  --more-btn-background: rgba(173,182,204,0.10);
  --user-operate-list: #2E323D;
  --user-operate-item: #CFD4E6;
  --active-blur-background-color: rgba(27,93,172,0.85);
  --divide-line-color-setting: transparent;
  --el-disabled-background: #606266;
  --el-disabled-border: #909399;
  --el-border-lighter: #2E323D;
  --title-active: #B3B8C8;
  --mic-bar-color: #2E323D;
  --more-notice-color: #7C85A6;
  --setting-dialog: none;
  --caret-color: #fff;
  --apply-container-primary: #CFD4E6;
  --apply-container-outline: #CFD4E6;
  --el-drawer-body: #1D2029;
  --input-color-setting: #1D2029;
  --input-color-setting-hover: #2E323D;
  --switch-core-bg: #2E323D;
  --input-color-font: #CFD4E6;
  --input-color-setting-border: #2E323D;
  --el-message-box: #1D2029;
  --el-message-box-title: #CFD4E6;
  --el-button-text-color: #7C85A6;
  --selected-screen-share-dialog: #006EFF;
  /* H5 New Content */
  --log-out-mobile: rgba(0, 0, 0, 0.7);
  --log-out: #2C2C2E;
  --log-out-cancel: #2C2C2E;
  --room-detail: #292D38;
  --room-detail-background: black;
  --room-detail-title: white;
  --choose-type: #4F515A;
  --emoji-background-color:#2f313b;
  --chat-editor-input-color-h5:#292D38;
  --chat-editor-bg-color-h5: #0D1015;
  --message-list-color-h5: #1B1E26;
  --popup-mute-background-color-h5: #FFF;
  --mute-button-color-h5: #CFD5E6;
  --member-control-background-color-h5: #1B1E26;
  --member-border-color-h5:rgba(207, 212, 230, 0.1);
  --member-title-content-h5: #CFD5E6;
  --end-control-text-h5: #292D38;
  --end-control-title-h5: #CACACB;
  --end-control-cancel-h5: #FFF;
  --transfer-input-color-h5: #292D38;
  --popup-background-color-h5: #1B1E26;
  --popup-title-color-h5: #CFD4E6;
  --popup-content-color-h5: #7C85A6;
  --close-cancel-h5: #5a5a5e;
  --dialog-title-h5: #FFF;
  --manage-member-button-h5:#292D38;
  --message-body-h5: #292D38;
  --user-extra-info-bg-color-h5: #0565FA;
  --user-extra-info-color-h5: #FFF;
  --apply-container-background-outline-h5: #292D38;
  --apply-container-outline-h5: #CFD5E6;
}
.tui-theme-white {
  --background-color-1: #FFF;
  --background-color-2: #FBFCFE;
  --background-color-3: #F0F3FA;
  --background-color-4: #D5E0F2;
  --background-color-5: transparent;
  --background-color-6: #BDBDBD;
  --background-color-7: #F9FAFC;
  --background-color-8: #FFF;
  --background-color-9: #F7F9FC;
  --background-color-10: #E7EAF7;
  --background-color-11: #F0F3FA;
  --background-color-12: #FFF;
  --background-color-13: #F9FAFD;
  --hover-background-color-1: rgba(213, 224, 242, 0.5);
  --font-color-1: #4F586B;
  --font-color-2: #B2BBD1;
  --font-color-3: #000;
  --font-color-4: #4F586B;
  --font-color-5: #4F586B;
  --font-color-6: #0F1014;
  --font-color-7: #FFF;
  --font-color-8: #4F586B;
  --font-color-9: #969EB4;
  --font-color-10: #FF643D;
  --title-color: #0F1014;
  --stroke-color: #E4EAF7;
  --stroke-color-2: #EAEFF8;
  --border-color: #E4E8EE;
  --border-color-2: #E4E8EE;
  --disable-color: #F7F9FC;
  --active-color-1: #1C66E5;
  --active-color-2: #1C66E5;
  --green-color: #27C39F;
  --orange-color: #F06C4B;
  --white-color: #FFF;
  --black-color: #000;
  --red-color: #ED414D;
  --red-color-2: #F23C5B;
  --red-color-3: #E5395C;
  --control-content: #FFF;
  --background-image-color: transparent;
  --input-color: #FFF;
  --create-room-mode-color-bg: #FFF;
  --user-control-container-color-bg: #E8E8E8;
  --user-control-container-shadow: 0 12px 32px rgba(0, 0, 0, .1), 0 2px 6px;
  --stream-container-flatten-bg-color: rgba(242,242,242,1);
  --room-header-bg-color: #FFF;
  --room-footer-bg-color: #FFF;
  --room-network-bg-color: #FFF;
  --room-audiotab-bg-color: #FFF;
  --room-videotab-bg-color: #FFF;
  --stop-share-region-bg-color: #FFF;
  --setting-dialog-bg-color: #FFF;
  --icon-arrow-hover: rgba(232, 232, 232, 0.7);
  --el-dialog-bg-color: #FFF;
  --tabs-title-font-color: #000;
  --center-user-info-container-bg-color: #F2F2F2;
  --stream-info-bg-color: #FFF;
  --title-color-bg: #666;
  --title-color-font: #000;
  --el-dialog-bg-color-select: #FFF;
  --el-text-color-primary-select: #000;
  --el-text-color-regular-select: #596174;
  --el-fill-color-blank-select: #FFF;
  --el-border-color-select: #C8CACC;
  --setting-name-color: #000;
  --el-drawer-header-color: #000;
  --user-extra-info-bg-color: #006EFF;
  --user-extra-info-color: #FFF;
  --member-item-container-hover-bg-color: #F3F3F3;
  --el-bg-color-select: #FFF;
  --el-bg-color-overlay-select: #F2F2F2;
  --el-border-color-light-select: #F2F2F2;
  --el-fill-color-light-select: rgba(222, 222, 215, 0.7);
  --input-bg-color: #F2F2F2;
  --input-font-color: #000;
  --input-border-color: #F2F2F2;
  --invite-title-color: #7C85A6;
  --chat-editor-bg-color: #FFF;
  --message-list-color: #F6F6F6;
  --textarea-color: #000;
  --send-btn-color: #006EFF;
  --message-color: #006EFF;
  --stream-container-border: #fff;
  --apply-list-container-bg-color: #F2F2F2;
  --apply-list-container-color: #000;
  --room-sidebar-bg-color: #F2F2F2;
  --create-room-option: #eee;
  --create-room-option-tab: #006EFF;
  --create-room-option-color: #006EFF;
  --create-room-option-icon: #000;
  --create-room-option-icon-color:#006EFF;
  --control-region-bg-color: #EEE;
  --dialog-tabs-bg-color: #F0F3FA;
  --divide-line-color: transparent;
  --divice-line: #dcdcdc;
  --el-drawer-divide: transparent;
  --send-btn: #FFF;
  --invite-region: #000;
  --layout-list: #EEE;
  --layout-item: #FFF;
  --stream-list-container: #EEE;
  --more-btn-background: #006EFF;
  --user-operate-list: #EEE;
  --user-operate-item: #1D1029;
  --active-blur-background-color: transparent;
  --divide-line-color-setting: #dcdcdc;
  --el-disabled-border: #b6b6b6;
  --el-disabled-background: #dcdcdc;
  --el-border-lighter: #dcdcdc;
  --title-active: #666;
  --mic-bar-color: #babbbe;
  --more-notice-color: #000;
  --setting-dialog: 8px;
  --caret-color: #000;
  --apply-container-primary: #FFF;
  --apply-container-outline: #000;
  --el-drawer-body: #FFF;
  --input-color-setting: #FFF;
  --input-color-setting-hover: #f5f7fa;
  --switch-core-bg: #dcdfe6;
  --input-color-font: #646366;
  --input-color-setting-border: #babebe;
  --el-message-box: #FFF;
  --el-message-box-title: #000;
  --el-button-text-color: #646366;
  --selected-screen-share-dialog: #006EFF;
  /* H5 New Content */
  --log-out-mobile: rgba(0, 0, 0, 0.7);
  --log-out: #F9F9F9C7;
  --log-out-cancel: #FFF;
  --room-detail: #F5F5F5;
  --room-detail-background: white;
  --room-detail-title: black;
  --choose-type: #E1E1E3;
  --emoji-background-color:#efecec;
  --chat-editor-input-color-h5:#dfdcdc;
  --chat-editor-bg-color-h5: #f1f1f1;
  --message-list-color-h5: #d4d4d4;
  --popup-mute-background-color-h5: #ececed;
  --mute-button-color-h5: #FFF;
  --member-control-background-color-h5: #F2F2F2;
  --member-border-color-h5: #FFF;
  --member-title-content-h5: #5f5c5c;
  --end-control-text-h5: #CFD4E6;
  --end-control-title-h5: rgba(37, 37, 37, 0.78);
  --end-control-cancel-h5: #2C2C2E;
  --transfer-input-color-h5: #d4d4d4;
  --popup-background-color-h5: #d4d4d4;
  --popup-title-color-h5: #141313;
  --popup-content-color-h5: #636060;
  --close-cancel-h5: #006EFF;
  --dialog-title-h5: #2B2E38;
  --manage-member-button-h5:#006EFF;
  --message-body-h5: #817e7e;
  --user-extra-info-bg-color-h5: #006EFF;
  --user-extra-info-color-h5: #FFF;
  --apply-container-background-outline-h5: #006EFF;
  --apply-container-outline-h5: #FFF;
}
.tui-room :not([class|=el]) {
  transition: background-color 0.3s, color 0.3s, box-shadow 0.3s;
}.tui-room[data-v-c3c5557a] {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  min-width: 850px;
  height: 100%;
  min-height: 400px;
  color: var(--font-color-1);
  text-align: left;
  background-color: var(--background-color-1);
}
.tui-room .header[data-v-c3c5557a] {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  width: 100%;
  height: 64px;
  background-color: var(--background-color-2);
  box-shadow: 0 1px 0 var(--header-shadow-color);
}
.tui-room .content[data-v-c3c5557a] {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: var(--background-color-1);
}
.tui-room.tui-room-h5[data-v-c3c5557a] {
  width: 100%;
  min-width: 350px;
  height: 100%;
  min-height: 525px;
}
#roomContainer.chat-room[data-v-c3c5557a] {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 999;
  width: 80%;
  height: 80%;
  margin: auto;
  border-radius: 10px;
}
#roomContainer.tui-room-h5[data-v-c3c5557a],
#roomContainer .chat-room[data-v-c3c5557a] {
  width: 100%;
  height: 100%;
}
.tui-theme-white .tui-room[data-v-c3c5557a] {
  --header-shadow-color: #e3eaf7;
  --footer-shadow-color: rgba(197, 210, 229, 0.2);
}
.tui-theme-black .tui-room[data-v-c3c5557a] {
  --header-shadow-color: rgba(34, 38, 46, 0.3);
  --footer-shadow-color: rgba(34, 38, 46, 0.3);
}
.tui-theme-white.tui-room[data-v-c3c5557a] {
  --header-shadow-color: #e3eaf7;
  --footer-shadow-color: rgba(197, 210, 229, 0.2);
}
.tui-theme-black.tui-room[data-v-c3c5557a] {
  --header-shadow-color: rgba(34, 38, 46, 0.3);
  --footer-shadow-color: rgba(34, 38, 46, 0.3);
}.user-info-container[data-v-a4ccc14d] {
  position: relative;
}
.user-info-container .user-info-content[data-v-a4ccc14d] {
  display: flex;
  align-items: center;
  cursor: pointer;
}
.user-info-container .user-info-content .avatar[data-v-a4ccc14d] {
  width: 28px;
  height: 28px;
  border-radius: 50%;
}
.user-info-container .user-info-content .name[data-v-a4ccc14d] {
  max-width: 100px;
  margin-left: 20px;
  overflow: hidden;
  font-size: 16px;
  color: var(--font-color);
  text-overflow: ellipsis;
  white-space: nowrap;
}
.user-info-container .user-info-content .down-icon[data-v-a4ccc14d] {
  margin-left: 4px;
}
.user-info-container .user-control-container[data-v-a4ccc14d] {
  position: absolute;
  top: calc(100% + 14px);
  right: 0;
  padding: 10px 0;
  color: var(--font-color);
  background: var(--user-control-container-color-bg);
  border-radius: 4px;
  box-shadow: var(--user-control-container-shadow);
}
.user-info-container .user-control-container .user-control-item-foot[data-v-a4ccc14d],
.user-info-container .user-control-container .user-control-item-head[data-v-a4ccc14d] {
  width: 104px;
  height: 20px;
  font-size: 14px;
  text-align: center;
  cursor: pointer;
}
.user-info-container .logout-mobile[data-v-a4ccc14d] {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  z-index: 9;
  box-sizing: border-box;
  width: 100vw;
  height: auto;
  background: var(--log-out-mobile);
}
.user-info-container .logout-mobile-main[data-v-a4ccc14d] {
  position: absolute;
  bottom: 34px;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}
.user-info-container .logout-mobile .logout[data-v-a4ccc14d] {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 90%;
  padding: 1rem 0;
  background: var(--log-out);
  border-radius: 14px;
}
.user-info-container .logout-mobile .logout i[data-v-a4ccc14d] {
  font-family: "PingFang SC";
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  color: #ff2e2e;
  text-align: center;
}
.user-info-container .logout-mobile .close[data-v-a4ccc14d] {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 90%;
  padding: 1em 0;
  margin-top: 0.625rem;
  background: var(--log-out-cancel);
  backdrop-filter: blur(27.1828px);
  border-radius: 14px;
}
.user-info-container .logout-mobile .close i[data-v-a4ccc14d] {
  font-family: "PingFang SC";
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  color: #007aff;
  text-align: center;
}.tui-theme-white .user-control-container[data-v-d4609867] {
  --filter-color: drop-shadow(0px 0px 4px rgba(32, 77, 141, 0.03))
    drop-shadow(0px 4px 10px rgba(32, 77, 141, 0.06))
    drop-shadow(0px 1px 14px rgba(32, 77, 141, 0.05));
}
.tui-theme-black .user-control-container[data-v-d4609867] {
  --filter-color: drop-shadow(0px 8px 40px rgba(23, 25, 31, 0.6))
    drop-shadow(0px 4px 12px rgba(23, 25, 31, 0.4));
}
.user-info-container[data-v-d4609867] {
  position: relative;
}
.user-info-container .user-info-content[data-v-d4609867] {
  display: flex;
  align-items: center;
  cursor: pointer;
}
.user-info-container .user-info-content .avatar[data-v-d4609867] {
  width: 28px;
  height: 28px;
  border-radius: 50%;
}
.user-info-container .user-info-content .name[data-v-d4609867] {
  max-width: 100px;
  margin-left: 10px;
  overflow: hidden;
  font-size: 16px;
  color: var(--font-color);
  text-overflow: ellipsis;
  white-space: nowrap;
}
.user-info-container .user-info-content .down-icon[data-v-d4609867] {
  margin-left: 4px;
}
.user-info-container .user-info-content .up-icon[data-v-d4609867] {
  margin-left: 4px;
  transform: rotate(180deg);
}
.user-info-container .user-control-container[data-v-d4609867] {
  position: absolute;
  top: calc(100% + 15px);
  right: 0;
  min-width: 100px;
  padding: 10px;
  background: #fff;
  filter: var(--filter-color);
  border-radius: 8px;
}
.user-info-container .user-control-container[data-v-d4609867]::before {
  position: absolute;
  top: -20px;
  right: 20px;
  width: 0;
  content: "";
  border-top: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 10px solid #fff;
  border-left: 10px solid transparent;
}
.user-info-container .user-control-container[data-v-d4609867]::after {
  position: absolute;
  top: -20px;
  left: 0;
  width: 100%;
  height: 20px;
  content: "";
  background-color: transparent;
}
.user-info-container .user-control-container .user-control-item-foot[data-v-d4609867],
.user-info-container .user-control-container .user-control-item-head[data-v-d4609867] {
  height: 20px;
  font-size: 14px;
  color: #4f586b;
  text-align: center;
  cursor: pointer;
}
.edit-content[data-v-d4609867] {
  display: flex;
  align-items: center;
  width: 100%;
}
.edit-content .edit-name-input[data-v-d4609867] {
  flex-grow: 1;
  width: auto;
  margin-left: 16px;
}
.button[data-v-d4609867] {
  margin-left: 12px;
}.container[data-v-bfd37767] {
  position: relative;
  display: inline-block;
  width: 100%;
}
.datepicker-input[data-v-bfd37767] {
  width: 100%;
  cursor: pointer;
}
.picker[data-v-bfd37767] {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1000;
  display: inline-block;
  width: 100%;
  min-width: 222px;
  padding: 5px;
  font-size: 12px;
  color: #000;
  background-color: #fff;
  border: 1px solid var(--stroke-color);
  border-radius: 4px;
}
.picker-header[data-v-bfd37767] {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 5px;
  font-size: 14px;
  line-height: normal;
}
.picker-header .current-time[data-v-bfd37767] {
  width: 80%;
  font-weight: bold;
  color: black;
}
.arrow[data-v-bfd37767] {
  display: inline-block;
  padding: 0 5px;
  cursor: pointer;
  background-color: transparent;
  border: none;
}
.arrow[data-v-bfd37767]:hover {
  color: #409eff;
}
.picker-weekdays[data-v-bfd37767] {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
}
.weekday[data-v-bfd37767] {
  padding: 5px;
  line-height: initial;
  text-align: center;
  background-color: #fff;
}
.picker-body[data-v-bfd37767] {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
}
.day[data-v-bfd37767] {
  position: relative;
  padding: 5px;
  line-height: initial;
  text-align: center;
  cursor: pointer;
  background-color: #fff;
}
.day[data-v-bfd37767]:hover {
  background-color: #ecf5ff;
}
.day.selected[data-v-bfd37767] {
  color: white;
  background-color: #409eff;
}
.day.today .today-dot[data-v-bfd37767] {
  position: absolute;
  bottom: 0;
  left: 50%;
  display: inline-block;
  width: 5px;
  height: 5px;
  background-color: #409eff;
  border-radius: 50%;
  transform: translateX(-50%);
}
.day.past[data-v-bfd37767] {
  color: #ccc;
  pointer-events: none;
}.invite-member[data-v-50de092b] {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 10px;
}
.invite-member .invite-member-container[data-v-50de092b] {
  display: flex;
  align-items: stretch;
  min-width: 400px;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: #4f586b;
}
.invite-member .invite-member-container .invite-member-title[data-v-50de092b] {
  min-width: 80px;
  margin-right: 10px;
}
.invite-member .invite-member-container .invite-member-content[data-v-50de092b] {
  max-width: 360px;
  overflow: hidden;
  font-weight: 500;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.invite-member .invite-member-container .copy[data-v-50de092b] {
  width: 20px;
  min-width: 20px;
  height: 20px;
  margin-left: 8px;
  color: var(--active-color-1);
  cursor: pointer;
}
.invite-member.h5 .invite-member-title[data-v-50de092b] {
  font-size: 14px;
  font-weight: 400;
  color: #8f9ab2;
}
.invite-member.h5 .invite-member-container[data-v-50de092b] {
  min-width: auto;
}.schedule-conference-form[data-v-de59a95f] {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.schedule-conference-form .form-items-container[data-v-de59a95f] {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 16px 5%;
  background-color: #fff;
  border-radius: 8px;
}
.schedule-conference-form .form-item[data-v-de59a95f] {
  display: flex;
  align-items: center;
}
.schedule-conference-form .form-item .form-label[data-v-de59a95f] {
  display: inline-block;
  width: 100px;
  min-width: 100px;
  font-size: 14px;
  font-weight: 400;
  color: #4f586b;
}
.schedule-conference-form .form-item .form-value[data-v-de59a95f] {
  display: flex;
  align-items: center;
  width: 100%;
  height: 42px;
  overflow: auto;
  font-size: 14px;
  font-weight: 400;
  line-height: 42px;
  color: #0f1014;
}
.schedule-conference-form .form-item .form-value .search-user[data-v-de59a95f] {
  height: 42px;
}
.schedule-conference-form .form-item .form-value .form-input[data-v-de59a95f] {
  width: 100%;
}
.schedule-conference-form .form-item .form-value .checkbox-group[data-v-de59a95f] {
  display: flex;
  flex-direction: column;
}
.schedule-conference-form .form-item .form-value .checkbox-group-item[data-v-de59a95f] {
  max-width: 145px;
}
.schedule-conference-form .form-item .form-value .checkbox-group-item[data-v-de59a95f]:hover {
  color: #409eff;
}
.schedule-conference-form .form-item .form-value .select[data-v-de59a95f] {
  width: 100%;
}
.schedule-conference-form .form-item .form-value .date-picker[data-v-de59a95f] {
  width: 210px;
}
.schedule-conference-form .form-item .form-value .time-picker[data-v-de59a95f] {
  width: 110px;
}
.schedule-conference-form .form-item .form-value .select-attendees[data-v-de59a95f] {
  cursor: pointer;
}
.schedule-conference-form .form-item .form-value .select-attendees[data-v-de59a95f]:hover {
  color: var(--active-color-1);
}
.schedule-conference-form .form-item .form-value .select-search-result-item[data-v-de59a95f] {
  display: inline-block;
  width: 100%;
  height: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.schedule-conference-form .form-item .form-value .form-attendees[data-v-de59a95f] {
  display: flex;
  flex-wrap: wrap;
  gap: 2px;
  justify-content: flex-start;
  width: 100%;
  max-height: 100px;
  margin-top: 6px;
  overflow: auto;
  line-height: normal;
}
.schedule-conference-form .form-item .form-value .form-attendees-item[data-v-de59a95f] {
  box-sizing: border-box;
  display: flex;
  flex-basis: calc(33.3333% - 2px);
  align-items: center;
  padding: 2px 8px;
  overflow: hidden;
  line-height: normal;
  background-color: #e3f0fd;
  border-radius: 4px;
}
.schedule-conference-form .form-item .form-value .form-attendees-item-container[data-v-de59a95f] {
  display: flex;
  align-items: center;
}
.schedule-conference-form .form-item .form-value .form-attendees-item-avatar[data-v-de59a95f] {
  width: 20px;
  min-width: 20px;
  height: 20px;
  min-height: 20px;
  margin-right: 6px;
}
.schedule-conference-form .form-item .form-value .form-attendees-item-name[data-v-de59a95f] {
  display: inline;
  width: 100%;
  margin: initial;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.schedule-conference-form .form-item .form-value .form-attendees-item-remove[data-v-de59a95f] {
  margin-left: auto;
  color: #b3acac;
  cursor: pointer;
}
.schedule-conference-form .form-item .form-value .form-attendees[data-v-de59a95f]:hover {
  overflow: auto;
}
.schedule-conference-form .form-item .form-value.flex-end[data-v-de59a95f] {
  justify-content: flex-end;
}
.schedule-conference-form .form-item.column[data-v-de59a95f] {
  align-items: flex-start;
}
.schedule-conference-form .form-item.column .form-label[data-v-de59a95f] {
  height: 42px;
  line-height: 42px;
}
.schedule-conference-form .form-item.column .form-value[data-v-de59a95f] {
  display: flex;
  flex-direction: column;
  height: auto;
}
.schedule-conference-footer[data-v-de59a95f] {
  display: flex;
  gap: 12px;
  align-items: center;
  justify-content: center;
  width: 100%;
}
.schedule-conference-footer .footer-button[data-v-de59a95f] {
  width: 100%;
  margin-top: 10px;
  border-radius: 6px;
}
.invite-member[data-v-de59a95f] {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.invite-member .invite-member-title[data-v-de59a95f] {
  color: #4f586b;
}
.invite-member .invite-member-item[data-v-de59a95f] {
  display: flex;
  justify-content: space-between;
  padding: 10px 16px;
  margin-top: 8px;
  color: #0f1014;
  background: #f9fafc;
  border: 1px solid #e4e8ee;
  border-radius: 8px;
}
.invite-member .invite-member-item .copy[data-v-de59a95f] {
  width: 20px;
  height: 20px;
  cursor: pointer;
}.invite-member[data-v-9f8a737a] {
  display: flex;
  flex-direction: column;
  gap: 20px;
  user-select: none;
}
.invite-member .invite-member-title[data-v-9f8a737a] {
  color: #4f586b;
}
.invite-member .invite-member-item[data-v-9f8a737a] {
  display: flex;
  justify-content: space-between;
  padding: 10px 16px;
  margin-top: 8px;
  color: #0f1014;
  background: #f9fafc;
  border: 1px solid #e4e8ee;
  border-radius: 8px;
}
.invite-member .invite-member-item .invite-member-content[data-v-9f8a737a] {
  max-width: 400px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.invite-member .invite-member-item .copy[data-v-9f8a737a] {
  width: 20px;
  height: 20px;
  cursor: pointer;
}.schedule-conference-form[data-v-8ecae26b] {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.schedule-conference-form .form-item[data-v-8ecae26b] {
  display: flex;
  align-items: center;
}
.schedule-conference-form .form-item .form-label[data-v-8ecae26b] {
  display: inline-block;
  width: 100px;
  min-width: 100px;
  font-size: 14px;
  font-weight: 400;
  color: #4f586b;
}
.schedule-conference-form .form-item .form-value[data-v-8ecae26b] {
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: 42px;
  font-size: 14px;
  font-weight: 400;
  line-height: 42px;
  color: #0f1014;
}
.schedule-conference-form .form-item .form-value .search-user[data-v-8ecae26b] {
  height: 42px;
}
.schedule-conference-form .form-item .form-value .form-input[data-v-8ecae26b] {
  width: 100%;
}
.schedule-conference-form .form-item .form-value .checkbox-group[data-v-8ecae26b] {
  display: flex;
  flex-direction: column;
}
.schedule-conference-form .form-item .form-value .checkbox-group-item[data-v-8ecae26b] {
  max-width: 145px;
}
.schedule-conference-form .form-item .form-value .checkbox-group-item[data-v-8ecae26b]:hover {
  color: #409eff;
}
.schedule-conference-form .form-item .form-value .select[data-v-8ecae26b] {
  width: 100%;
}
.schedule-conference-form .form-item .form-value .date-picker[data-v-8ecae26b] {
  width: 210px;
}
.schedule-conference-form .form-item .form-value .time-picker[data-v-8ecae26b] {
  width: 110px;
}
.schedule-conference-form .form-item .form-value .select-attendees[data-v-8ecae26b] {
  cursor: pointer;
}
.schedule-conference-form .form-item .form-value .select-attendees[data-v-8ecae26b]:hover {
  color: var(--active-color-1);
}
.schedule-conference-form .form-item .form-value .select-search-result-item[data-v-8ecae26b] {
  display: inline-block;
  width: 100%;
  height: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.schedule-conference-form .form-item .form-value .form-attendees[data-v-8ecae26b] {
  display: flex;
  flex-wrap: wrap;
  gap: 2px;
  justify-content: flex-start;
  max-height: 100px;
  margin-top: 6px;
  overflow: hidden;
  line-height: normal;
}
.schedule-conference-form .form-item .form-value .form-attendees-item[data-v-8ecae26b] {
  box-sizing: border-box;
  display: flex;
  flex-basis: calc(33.3333% - 2px);
  align-items: center;
  padding: 2px 8px;
  overflow: hidden;
  line-height: normal;
  background-color: #e3f0fd;
  border-radius: 4px;
}
.schedule-conference-form .form-item .form-value .form-attendees-item-avatar[data-v-8ecae26b] {
  width: 20px;
  min-width: 20px;
  height: 20px;
  min-height: 20px;
  margin-right: 6px;
}
.schedule-conference-form .form-item .form-value .form-attendees-item-name[data-v-8ecae26b] {
  display: inline;
  width: 100%;
  margin: initial;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.schedule-conference-form .form-item .form-value .form-attendees-item-remove[data-v-8ecae26b] {
  margin-left: auto;
  color: #b3acac;
  cursor: pointer;
}
.schedule-conference-form .form-item .form-value .form-attendees[data-v-8ecae26b]:hover {
  overflow: auto;
}
.schedule-conference-form .form-item .form-value .icon[data-v-8ecae26b] {
  cursor: pointer;
}
.schedule-conference-form .form-item.column[data-v-8ecae26b] {
  align-items: flex-start;
}
.schedule-conference-form .form-item.column .form-label[data-v-8ecae26b] {
  height: 42px;
  line-height: 42px;
}
.schedule-conference-form .form-item.column .form-value[data-v-8ecae26b] {
  display: flex;
  flex-direction: column;
  height: auto;
}
.schedule-conference-form .form-item.column .password-container[data-v-8ecae26b] {
  display: flex;
  flex-direction: column;
  width: 100%;
}
.schedule-conference-form .form-item.column .password-container .form-title[data-v-8ecae26b] {
  color: #0f1014;
}
.schedule-conference-footer[data-v-8ecae26b] {
  display: flex;
  gap: 12px;
  align-items: center;
  justify-content: center;
  width: 100%;
}
.schedule-conference-footer .footer-button[data-v-8ecae26b] {
  width: 116px;
  height: 32px;
}
.invite-member[data-v-8ecae26b] {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.invite-member .invite-member-title[data-v-8ecae26b] {
  color: #4f586b;
}
.invite-member .invite-member-item[data-v-8ecae26b] {
  display: flex;
  justify-content: space-between;
  padding: 10px 16px;
  margin-top: 8px;
  color: #0f1014;
  background: #f9fafc;
  border: 1px solid #e4e8ee;
  border-radius: 8px;
}
.invite-member .invite-member-item .copy[data-v-8ecae26b] {
  width: 20px;
  height: 20px;
  cursor: pointer;
}.detail-container[data-v-3cc46623] {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.detail-content[data-v-3cc46623] {
  display: flex;
  align-items: stretch;
  min-width: 300px;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: #4f586b;
}
.detail-content .detail-title[data-v-3cc46623] {
  width: 84px;
  margin-right: 12px;
  color: #2b2e38;
}
.detail-content .detail-info[data-v-3cc46623] {
  display: flex;
  flex: 1;
  flex-direction: row;
  align-items: center;
  overflow: auto;
  text-wrap: nowrap;
  white-space: nowrap;
}
.detail-content .detail-item[data-v-3cc46623] {
  max-width: 360px;
  overflow: hidden;
  font-weight: 500;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.detail-content .copy-container[data-v-3cc46623] {
  display: flex;
  margin-left: 6px;
  color: var(--active-color-2);
  cursor: pointer;
}
.detail-content .copy-container .copy[data-v-3cc46623] {
  width: 20px;
  height: 20px;
}
.detail-content .detail-status[data-v-3cc46623] {
  margin-left: 10px;
}
.h5.detail-container[data-v-3cc46623] {
  padding: 16px 5%;
}
.h5.detail-container .detail-content[data-v-3cc46623] {
  font-size: 16px;
  font-weight: 400;
}
.h5.detail-container .detail-info[data-v-3cc46623] {
  justify-content: flex-end;
  color: rgba(43, 46, 56, 0.7);
}
.h5.detail-container .detail-item[data-v-3cc46623] {
  font-weight: 400;
}
.status-not-start[data-v-3cc46623] {
  color: var(--font-color-10);
}
.status-running[data-v-3cc46623] {
  color: var(--active-color-1);
}
.status-finished[data-v-3cc46623] {
  color: #b2bbd1;
}.tui-theme-black .operate-list[data-v-dab9a75e] {
  --operation-box-shadow: 0px 3px 8px rgba(34, 38, 46, 0.3),
    0px 6px 40px rgba(34, 38, 46, 0.3);
}
.tui-theme-white .operate-list[data-v-dab9a75e] {
  --operation-box-shadow: 0px 3px 8px #e9f0fb, 0px 6px 40px rgba(0, 0, 0, 0.1);
}
.schedule-room-control[data-v-dab9a75e] {
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  padding: 10px;
  user-select: none;
}
.schedule-room-control .schedule-room-info[data-v-dab9a75e] {
  flex: 1;
}
.schedule-room-control .schedule-room-info .schedule-title[data-v-dab9a75e] {
  display: flex;
  gap: 6px;
  align-items: center;
  max-width: 220px;
  font-size: 16px;
  font-weight: 500;
  color: var(--font-color-4);
}
.schedule-room-control .schedule-room-info .schedule-title .schedule-title-text[data-v-dab9a75e] {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.schedule-room-control .schedule-room-info .schedule-title .schedule-title-icon[data-v-dab9a75e] {
  min-width: 6px;
}
.schedule-room-control .schedule-room-info .schedule-content[data-v-dab9a75e] {
  display: flex;
  margin-top: 6px;
  font-size: 14px;
  font-weight: 400;
  color: var(--font-color-4);
}
.schedule-room-control .schedule-room-info .schedule-content .schedule-content-time[data-v-dab9a75e] {
  min-width: 94px;
  max-width: 94px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.schedule-room-control .schedule-room-info .schedule-content .schedule-content-time .segregation-level[data-v-dab9a75e] {
  display: inline-block;
  width: 10px;
  height: 1px;
  margin: 0 4px 4px;
  background-color: var(--font-color-4);
}
.schedule-room-control .schedule-room-info .schedule-content .schedule-content-room-id[data-v-dab9a75e] {
  flex-wrap: nowrap;
  min-width: 60px;
  max-width: 84px;
  padding-right: 10px;
  text-overflow: ellipsis;
}
.schedule-room-control .schedule-room-info .schedule-content .segregation-vertical[data-v-dab9a75e] {
  width: 1px;
  height: 10px;
  margin: 5px 10px 0 5px;
  background-color: #969eb4;
}
.schedule-room-control[data-v-dab9a75e]:hover {
  cursor: pointer;
  background-color: rgba(150, 158, 180, 0.1);
  border-radius: 8px;
}
.room-detail-content[data-v-dab9a75e] {
  background-color: #fff;
  border-radius: 8px;
}
.room-detail.h5 .detail-footer[data-v-dab9a75e] {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 16px;
}
.room-detail.h5 .detail-footer .footer-button[data-v-dab9a75e] {
  font-size: 16px;
  font-weight: 500;
  border-radius: 6px;
}
.invite-member-panel[data-v-dab9a75e] {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 1000;
  width: 100%;
  padding: 20px 12px 36px;
  background-color: #fff;
  border-radius: 18px 18px 0 0;
}
.invite-member-panel .invite-member-close[data-v-dab9a75e] {
  display: flex;
  justify-content: center;
  padding-bottom: 12px;
  text-align: center;
}
.invite-member-panel .invite-member-header[data-v-dab9a75e] {
  margin-bottom: 12px;
  font-size: 18px;
  font-weight: 500;
  color: #4f586b;
}
.schedule-room-operate[data-v-dab9a75e] {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.schedule-room-operate .ellipsis[data-v-dab9a75e],
.schedule-room-operate .link[data-v-dab9a75e] {
  width: 30px;
  height: 30px;
  margin-right: 6px;
  color: var(--active-color-1);
}
.schedule-room-operate .ellipsis[data-v-dab9a75e]:hover,
.schedule-room-operate .link[data-v-dab9a75e]:hover {
  background: rgba(150, 158, 180, 0.1);
  border-radius: 4px;
}
.schedule-room-operate .operate-list[data-v-dab9a75e] {
  position: absolute;
  z-index: 1;
  display: flex;
  flex-direction: column;
  min-width: 96px;
  padding: 20px;
  background: #fff;
  border-radius: 8px;
  box-shadow: var(--operation-box-shadow);
}
.schedule-room-operate .operate-list[data-v-dab9a75e]::before {
  position: absolute;
  width: 0;
  content: "";
  border-top: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 10px solid #fff;
  border-left: 10px solid transparent;
}
.schedule-room-operate .operate-list .operate-item[data-v-dab9a75e] {
  display: flex;
  justify-content: center;
  height: 20px;
  color: #6b758a;
  cursor: pointer;
}
.schedule-room-operate .operate-list .operate-item .operate-text[data-v-dab9a75e] {
  font-size: 14px;
  white-space: nowrap;
}
.schedule-room-operate .operate-list .operate-item[data-v-dab9a75e]:not(:first-child) {
  margin-top: 20px;
}
.schedule-room-operate .operate-list .operate-item[data-v-dab9a75e]:hover {
  color: var(--active-color-1);
}
.schedule-room-operate .operate-list .cancel-text[data-v-dab9a75e] {
  color: var(--red-color-2);
}
.schedule-room-operate .operate-list .cancel-text[data-v-dab9a75e]:hover {
  color: var(--red-color-2);
}
.schedule-room-operate .down[data-v-dab9a75e] {
  top: 50px;
  right: 74px;
}
.schedule-room-operate .down[data-v-dab9a75e]::before {
  top: -20px;
  right: 60px;
}
.schedule-room-operate .down[data-v-dab9a75e]::after {
  top: -20px;
  left: 0;
}
.schedule-room-operate .up[data-v-dab9a75e] {
  right: 74px;
  bottom: 50px;
}
.schedule-room-operate .up[data-v-dab9a75e]::before {
  right: 60px;
  bottom: -20px;
  transform: rotate(180deg);
}
.schedule-room-operate .up[data-v-dab9a75e]::after {
  bottom: -20px;
  left: 0;
}
.schedule-detail-closed[data-v-dab9a75e] {
  color: #4f586b;
}
.button[data-v-dab9a75e] {
  margin-left: 10px;
}
.status-not-start[data-v-dab9a75e] {
  color: var(--font-color-10);
}
.status-running[data-v-dab9a75e] {
  color: var(--active-color-1);
}
.status-finished[data-v-dab9a75e] {
  color: #b2bbd1;
}
.mask[data-v-dab9a75e] {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}
.hidden[data-v-dab9a75e] {
  pointer-events: none;
  opacity: 0;
}@keyframes loading-rotate-2ee85976 {
0% {
    transform: rotate(0deg);
}
100% {
    transform: rotate(360deg);
}
}
.schedule-room.schedule-room-pc[data-v-2ee85976] {
  min-width: 470px;
  padding: 20px 0;
  margin-left: 20px;
  user-select: none;
  background-color: var(--white-color);
  border-radius: 24px;
  box-shadow: rgba(197, 210, 229, 0.3);
}
.schedule-room[data-v-2ee85976] {
  position: relative;
  width: 100%;
}
.schedule-room .schedule-room-history[data-v-2ee85976] {
  position: absolute;
  top: 20px;
  right: 20px;
  display: flex;
  font-size: 14px;
  font-weight: 500;
  color: var(--active-color-1);
  cursor: pointer;
}
.schedule-room .schedule-room-history .arrow[data-v-2ee85976] {
  margin-left: 4px;
}
.schedule-room .schedule-loading[data-v-2ee85976] {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  font-size: 14px;
  font-weight: 400;
  color: #8f9ab2;
}
.schedule-room .schedule-loading .loading[data-v-2ee85976] {
  margin-bottom: 10px;
  animation: loading-rotate-2ee85976 1.5s linear infinite;
}
.schedule-room .schedule-room-container[data-v-2ee85976] {
  height: 504px;
  padding: 0 2px 0 10px;
  margin-right: 2px;
  overflow-y: scroll;
}
.schedule-room .schedule-room-container .schedule-room-date[data-v-2ee85976] {
  display: flex;
  padding: 10px;
  font-size: 14px;
  font-weight: 400;
  color: var(--font-color-9);
}
.schedule-room .schedule-room-container .schedule-room-date .date[data-v-2ee85976] {
  margin-right: 2px;
}
.schedule-room .schedule-no-body[data-v-2ee85976] {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 504px;
}
.schedule-room .schedule-no-body .text[data-v-2ee85976] {
  margin-top: 10px;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  color: #8f9ab2;
}
.schedule-room[data-v-2ee85976] ::-webkit-scrollbar-track {
  background: transparent;
}
.schedule-room[data-v-2ee85976] ::-webkit-scrollbar {
  width: 6px;
}
.schedule-room[data-v-2ee85976] ::-webkit-scrollbar-thumb {
  background-color: #e0e2e9;
  border-radius: 10px;
}
.schedule-room.schedule-room-h5[data-v-2ee85976] {
  height: 100%;
  padding: 10px 0;
}
.schedule-room.schedule-room-h5 .schedule-room-container[data-v-2ee85976] {
  height: 100%;
  overflow: auto;
}.control-container[data-v-b3ba323e] {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100vw;
  height: 100%;
  padding-top: 4rem;
}
.control-container .container-button-group[data-v-b3ba323e] {
  display: flex;
  gap: 20px;
  padding: 18px 26px;
  border-bottom: 1px solid #ccc;
}
.control-container .container-button-group .button-item[data-v-b3ba323e] {
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
  justify-content: center;
  width: 90px;
  height: 80px;
  font-size: 14px;
  color: #fff;
  text-align: center;
  background-color: #006eff;
  border-radius: 8px;
}
.control-container .container-button-group .button-item .button-icon[data-v-b3ba323e] {
  width: 22px;
  height: 22px;
  background-size: cover;
}
.control-container .conference-list-container[data-v-b3ba323e] {
  width: 100%;
  height: 100%;
  overflow: auto;
}
.control-container .conference-list-container .list-empty[data-v-b3ba323e] {
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: center;
  width: 100%;
  height: 100%;
  margin-top: 36%;
  font-size: 14px;
  color: #8f9ab2;
  text-align: center;
}
.container-header[data-v-b3ba323e] {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 80px;
}
.container-icon[data-v-b3ba323e] {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.container-bottom[data-v-b3ba323e] {
  display: flex;
  flex-direction: column;
  width: 210px;
  padding-top: 250px;
}
.create-room[data-v-b3ba323e] {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 6%;
  margin-top: 5%;
  background-image: linear-gradient(-45deg, #006eff 0%, #0c59f2 100%);
  border-radius: 8px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
}
.add-icon[data-v-b3ba323e] {
  width: 22px;
  height: 22px;
  background-size: cover;
}
.join-room[data-v-b3ba323e] {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 6%;
  background-image: linear-gradient(-45deg, #006eff 0%, #0c59f2 100%);
  border-radius: 8px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
}
.enter-icon[data-v-b3ba323e] {
  width: 22px;
  height: 22px;
  background-size: cover;
}
.title[data-v-b3ba323e] {
  padding-left: 10px;
  line-height: 34px;
  color: #fff;
}
.room-detail[data-v-b3ba323e] {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  z-index: 9;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100vw;
  height: auto;
  overflow-y: scroll;
  background: var(--room-detail);
}
.room-detail-header[data-v-b3ba323e] {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 5%;
  background: var(--room-detail-background);
}
.room-detail-header-title[data-v-b3ba323e] {
  flex: 1;
  color: var(--room-detail-title);
  text-align: center;
}
.close-icon[data-v-b3ba323e] {
  position: absolute;
  left: 22px;
  width: 10px;
  height: 18px;
  background-size: cover;
}
.room-detail-middle[data-v-b3ba323e] {
  width: 90%;
}
.room-detail-info[data-v-b3ba323e] {
  margin-top: 20px;
  background: var(--room-detail-background);
  border-radius: 6px;
}
.room-detail-info-box[data-v-b3ba323e] {
  display: flex;
  align-items: center;
  padding: 15px 12px;
}
.room-detail-title[data-v-b3ba323e] {
  min-width: 64px;
  color: var(--room-detail-title);
}
.chevron-down-icon[data-v-b3ba323e] {
  display: flex;
  width: 14px;
  height: 9px;
}
.room-show-title[data-v-b3ba323e] {
  flex: 1;
  padding-left: 26px;
  color: var(--room-detail-title);
}
.room-show-name[data-v-b3ba323e] {
  flex: 1;
  max-width: 180px;
  padding-left: 56px;
  overflow: hidden;
  color: var(--room-detail-title);
  text-overflow: ellipsis;
  white-space: nowrap;
}
.roomid-input[data-v-b3ba323e] {
  flex: 1;
  width: 100%;
  padding-left: 56px;
  font-size: 16px;
  color: #676c80;
  background: var(--room-detail-background);
  border: 0;
  outline: none;
}
.room-detail-setting[data-v-b3ba323e] {
  margin-top: 20px;
  background: var(--room-detail-background);
  border-radius: 6px;
}
.room-detail-setting-list[data-v-b3ba323e] {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px 12px;
  color: var(--room-detail-title);
}
.room-detail-bottom[data-v-b3ba323e] {
  position: absolute;
  bottom: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 90%;
  padding: 10px;
  background-image: linear-gradient(-45deg, #006eff 0%, #0c59f2 100%);
  border-radius: 8px;
}
.button[data-v-b3ba323e] {
  padding: 0 5.75rem;
  color: white;
}
.room-type-container[data-v-b3ba323e] {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 11;
  width: 100vw;
  padding-bottom: 25px;
  background: var(--log-out-cancel);
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  transition: all 0.25s linear;
}
.close-room-type-container[data-v-b3ba323e] {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 11;
  width: 100vw;
  height: 0;
  background: var(--log-out-cancel);
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  transition: all 0.25s linear;
}
.room-choose-mobile[data-v-b3ba323e] {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  z-index: 9;
  box-sizing: border-box;
  width: 100vw;
  height: auto;
  background: var(--log-out-mobile);
}
.room-choose-button[data-v-b3ba323e] {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}
.choose-cancel[data-v-b3ba323e] {
  z-index: 11;
  padding: 20px;
  color: var(--room-detail-title);
}
.choose-confirm[data-v-b3ba323e] {
  z-index: 11;
  padding: 20px;
  color: #146efa;
}
.room-type-hidden[data-v-b3ba323e] {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: var(--log-out-cancel);
  border-radius: 13px;
}
.room-choose-title[data-v-b3ba323e] {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 12px;
}
.room-current-title[data-v-b3ba323e] {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 12px;
  overflow: hidden;
  color: var(--room-detail-title);
  text-overflow: ellipsis;
  white-space: nowrap;
  background: var(--choose-type);
}
.slider-box[data-v-b3ba323e] {
  display: flex;
  align-items: center;
  width: 44px;
  height: 24px;
  background: #e1e1e3;
  border-radius: 15px;
}
.slider-open[data-v-b3ba323e] {
  justify-content: flex-end;
  background: #006eff !important;
}
.slider-block[data-v-b3ba323e] {
  display: inline-block;
  width: 16px;
  height: 16px;
  margin: 0 2px;
  background: #fff;
  border: 0 solid rgba(0, 0, 0, 0.85);
  border-radius: 8px;
  box-shadow: 0 2px 4px 0 #d1d1d1;
}.control-container[data-v-8a671989] {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 760px;
  height: 544px;
  padding: 20px 20px 32px;
  background-color: var(--background-color);
  border-radius: 24px;
  box-shadow: var(--box-shadow);
}
.control-container .stream-preview-container[data-v-8a671989] {
  position: relative;
  width: 100%;
  height: 400px;
  overflow: hidden;
  background-color: #000;
  border-radius: 8px;
}
.control-container .stream-preview-container .stream-preview[data-v-8a671989] {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.control-container .stream-preview-container .attention-info[data-v-8a671989] {
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}
.control-container .stream-preview-container .attention-info .off-camera-info[data-v-8a671989] {
  font-size: 22px;
  font-weight: 400;
  line-height: 34px;
  color: #4f586b;
}
.control-container .stream-preview-container .attention-info .loading[data-v-8a671989] {
  animation: loading-rotate-8a671989 2s linear infinite;
}
.control-container .control-region[data-v-8a671989] {
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: 60px;
}
.control-container .control-region .media-control-region[data-v-8a671989] {
  position: relative;
  display: flex;
  align-items: center;
}
.control-container .control-region .media-control-region .media-control-item[data-v-8a671989]:not(:first-child) {
  margin-left: 20px;
}
.control-container .control-region .media-control-region .media-control-item .media-tab[data-v-8a671989] {
  position: absolute;
  top: -100%;
  left: 0;
}
.control-container .control-region .create-room-option[data-v-8a671989] {
  font-size: 20px;
  font-weight: 400;
  line-height: 22px;
  white-space: nowrap;
}
.control-container .control-region .create-room-option[data-v-8a671989]::before {
  display: block;
  height: 0;
  overflow: hidden;
  font-weight: 500;
  visibility: hidden;
  content: attr(title);
}
.control-container .control-region .room-control-region[data-v-8a671989] {
  display: flex;
}
.control-container .control-region .room-control-region .button-item[data-v-8a671989] {
  width: 206px;
  height: 60px;
}
.control-container .control-region .room-control-region .button-item .button-text[data-v-8a671989] {
  margin-left: 6px;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px;
}
.control-container .control-region .room-control-region .create-room-region[data-v-8a671989] {
  position: relative;
}
.control-container .control-region .room-control-region .create-room-region .create-room-items[data-v-8a671989] {
  position: absolute;
  bottom: calc(100% + 8px);
  left: 50%;
  cursor: pointer;
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 2px 4px rgba(32, 77, 141, 0.03), 0 6px 10px rgba(32, 77, 141, 0.06), 0 3px 14px rgba(32, 77, 141, 0.05);
  transform: translateX(-50%);
}
.control-container .control-region .room-control-region .create-room-region .create-room-items .create-room-item[data-v-8a671989] {
  display: flex;
  justify-content: space-between;
  padding: 19px 32px;
  color: #4f586b;
  transition: background-color 0s, color 0s;
}
.control-container .control-region .room-control-region .create-room-region .create-room-items .create-room-item .create-room-option[data-v-8a671989] {
  font-size: 20px;
  font-weight: 400;
  line-height: 22px;
  white-space: nowrap;
}
.control-container .control-region .room-control-region .create-room-region .create-room-items .create-room-item .create-room-option[data-v-8a671989]::before {
  display: block;
  height: 0;
  overflow: hidden;
  font-weight: 500;
  visibility: hidden;
  content: attr(title);
}
.control-container .control-region .room-control-region .create-room-region .create-room-items .create-room-item[data-v-8a671989]:hover {
  color: var(--active-color-1);
}
.control-container .control-region .room-control-region .create-room-region .create-room-items .create-room-item:hover .create-room-option[data-v-8a671989] {
  font-weight: 500;
}
.control-container .control-region .room-control-region .create-room-region .create-room-items .create-room-item .create-room-icon[data-v-8a671989] {
  margin-left: 8px;
}
.control-container .control-region .room-control-region .enter-room-region[data-v-8a671989] {
  margin-left: 20px;
}
.control-container .control-region .room-control-region .enter-room-region .enter-room-action[data-v-8a671989] {
  position: relative;
  width: 170px;
  height: 60px;
  padding: 0 14px;
  line-height: 60px;
  background-color: var(--background-color);
  border: 2px solid var(--active-color-1);
  border-radius: 30px;
}
.control-container .control-region .room-control-region .enter-room-region .enter-room-action .input[data-v-8a671989] {
  max-width: 140px;
  padding: 0;
  font-size: 20px;
  font-weight: 500;
  line-height: 28px;
  color: var(--font-color-1);
  background-color: transparent;
  border: 0;
  outline: none;
  --input-placeholder-color: rgba(143, 154, 178, 0.7);
}
.control-container .control-region .room-control-region .enter-room-region .enter-room-action .input[data-v-8a671989]::placeholder {
  color: var(--input-placeholder-color);
}
.control-container .control-region .room-control-region .enter-room-region .enter-room-action .enter-button[data-v-8a671989] {
  position: absolute;
  top: 8px;
  right: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background-color: #90b3f0;
  border-radius: 26px;
}
.control-container .control-region .room-control-region .enter-room-region .enter-room-action .enter-button.active[data-v-8a671989] {
  cursor: pointer;
  background-color: var(--active-color-1);
}
.control-container .control-region .room-control-region .schedule-room-region[data-v-8a671989] {
  margin-left: 20px;
}
.tui-theme-white .control-container[data-v-8a671989] {
  --background-color: #fff;
  --box-shadow: 0px 8px 30px 0px rgba(197, 210, 229, 0.3),
    0px 2px 3px 0px rgba(197, 210, 229, 0.3);
}
.tui-theme-black .control-container[data-v-8a671989] {
  --background-color: rgba(79, 88, 107, 0.3);
  --box-shadow: 0px 4px 30px 0px rgba(34, 38, 46, 0.3),
    0px 0px 3px 0px rgba(34, 38, 46, 0.3);
}
@keyframes loading-rotate-8a671989 {
0% {
    transform: rotate(0deg);
}
100% {
    transform: rotate(360deg);
}
}
.room-control-main[data-v-8a671989] {
  display: flex;
}.pc-en-logo[data-v-7e1c76c2] {
  display: flex;
  align-items: center;
  transform: scale(0.9);
}
.pc-en-logo .title[data-v-7e1c76c2] {
  margin-left: 10px;
}
.pc-en-logo .white[data-v-7e1c76c2] {
  color: #202c40;
}
.pc-en-logo .black[data-v-7e1c76c2] {
  color: #d5e0f2;
}
.pc-en-logo.mobile[data-v-7e1c76c2] {
  transform: scale(0.6);
}
.mobile-zh-logo[data-v-7e1c76c2] {
  display: flex;
  flex-direction: column;
}
.mobile-zh-logo .logo[data-v-7e1c76c2] {
  margin-bottom: 7px;
}
.mobile-zh-logo .white[data-v-7e1c76c2] {
  color: #000;
}
.mobile-zh-logo .black[data-v-7e1c76c2] {
  color: #fff;
}.invitation-notification-container[data-v-f4251e8d] {
  position: fixed;
  top: 40px;
  right: 20px;
  padding: 20px 30px 10px 20px;
  background-color: var(--white-color);
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 15px;
}
.invitation-notification-container .invitation-notification-inviter[data-v-f4251e8d] {
  display: flex;
  align-items: center;
}
.invitation-notification-container .invitation-notification-inviter .invitation-notification-title[data-v-f4251e8d] {
  overflow: hidden;
  font-size: 14px;
  font-weight: 400;
  color: var(--font-color-4);
  text-overflow: ellipsis;
  white-space: nowrap;
}
.invitation-notification-container .invitation-notification-inviter .avatar[data-v-f4251e8d] {
  width: 30px;
  height: 30px;
  margin-right: 5px;
}
.invitation-notification-container .invitation-notification-room-info-container[data-v-f4251e8d] {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.invitation-notification-container .invitation-notification-room-info-container .invitation-notification-room-text[data-v-f4251e8d] {
  max-width: 20px;
  overflow: hidden;
  font-size: 14px;
  font-weight: 400;
  color: rgb(79, 88, 107);
  text-overflow: ellipsis;
  white-space: nowrap;
}
.invitation-notification-container .invitation-notification-room-text-split[data-v-f4251e8d] {
  display: block;
  width: 1px;
  height: 14px;
  background-color: rgba(0, 0, 0, 0.1);
}
.invitation-notification-container .invitation-notification-bottom-split[data-v-f4251e8d] {
  display: block;
  width: 100%;
  height: 1px;
  margin-top: 15px;
  background-color: rgba(0, 0, 0, 0.1);
}
.invitation-notification-container .invitation-notification-bottom-container[data-v-f4251e8d] {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 10px;
}
.invitation-notification-container .invitation-notification-bottom-container .invitation-notification-bottom[data-v-f4251e8d] {
  font-size: 14px;
  font-weight: 500;
  color: rgb(143, 154, 178);
  cursor: pointer;
}
.invitation-notification-container .icon[data-v-f4251e8d] {
  display: flex;
  align-items: center;
  width: 16px;
  height: 16px;
}
.invitation-notification-container .invitation-notification-room-name[data-v-f4251e8d] {
  display: block;
  max-width: 300px;
  padding: 5px 0;
  overflow: hidden;
  font-size: 20px;
  font-weight: 500;
  color: rgb(34, 38, 46);
  text-overflow: ellipsis;
  white-space: nowrap;
}
.invitation-notification-container .button-text[data-v-f4251e8d] {
  padding-left: 5px;
}body, html {
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;
}
#roomContainer {
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;
  overflow: hidden;
  touch-action: manipulation;
  user-select: none;
}
#roomContainer *, ::before, ::after {
  box-sizing: border-box;
}
.pre-conference-container *, ::before, ::after {
  box-sizing: border-box;
}
.tui-theme-black {
  --background-color-1: #0F1014;
  --background-color-2: #22262E;
  --background-color-3: #4F586B;
  --background-color-4: #D5E0F2;
  --background-color-5: transparent;
  --background-color-6: #373942;
  --background-color-7: #2E323D;
  --background-color-8: #22262E;
  --background-color-9: #2E323D;
  --background-color-10: #2B2F38;
  --background-color-11: #2B303A;
  --background-color-12: #4F586B;
  --background-color-13: #F9FAFD;
  --hover-background-colo-1: rgba(213, 224, 242, 0.5);
  --font-color-1: #D5E0F2;
  --font-color-2: #6B758A;
  --font-color-3: #B3B8C8;
  --font-color-4: #4F586B;
  --font-color-5: #7C85A6;
  --font-color-6: #CFD5E6;
  --font-color-7: #FFF;
  --font-color-8: #8F9AB2;
  --font-color-9: #969EB4;
  --font-color-10: #FF643D;
  --title-color: #000;
  --stroke-color: rgba(79, 88, 107, 0.30);
  --stroke-color-2: #434956;
  --border-color: #2E323D;
  --border-color-2: #E4E8EE;
  --disable-color: #2B2F38;
  --active-color-1: #1C66E5;
  --active-color-2: #4791FF;
  --green-color: #27C39F;
  --orange-color: #F06C4B;
  --white-color: #FFF;
  --black-color: #000;
  --red-color: #ED414D;
  --red-color-2: #F23C5B;
  --red-color-3: #E5395C;
  --color-font: #D5E0F2;
  --control-content: rgba(27, 30, 38, 0.9);
  --background-image-color: rgba(61,119,255,0.53);
  --input-color: rgba(27,30,38,0.90);
  --create-room-mode-color-bg:#1D2437;
  --user-control-container-color-bg: rgba(46,50,61,0.60);
  --user-control-container-shadow: none;
  --stream-container-flatten-bg-color: #0D0F15;
  --room-header-bg-color: #1D2029;
  --room-footer-bg-color: #1D2029;
  --room-network-bg-color: #1D2029;
  --room-audiotab-bg-color: #1D2029;
  --room-videotab-bg-color: #1D2029;
  --stop-share-region-bg-color: #1D2029;
  --setting-dialog-bg-color: #1D2029;
  --icon-arrow-hover: rgba(46,50,61,0.70);
  --el-dialog-bg-color: #1D2029;
  --tabs-title-font-color: #7C85A6;
  --center-user-info-container-bg-color: #0D0F15;
  --stream-info-bg-color: #0D0F15;
  --el-dialog-bg-color-select: #1D2029;
  --el-text-color-primary-select: #CFD4E6;
  --el-text-color-regular-select: #7C85A6;
  --el-fill-color-blank-select: #2E323D;
  --el-border-color-select: #2E323D;
  --setting-name-color: #CFD4E6;
  --el-drawer-header-color: #CFD4E6;
  --user-extra-info-bg-color: #4D70FF;
  --user-extra-info-color: #2E323D;
  --check-select-color: #FFF;
  --member-item-container-hover-bg-color: rgba(46,50,61,0.70);
  --el-bg-color-select: #1D2029;
  --el-bg-color-overlay-select: #1D2029;
  --el-border-color-light-select: #2E323D;
  --el-fill-color-light-select: #2E323D;
  --input-bg-color: #2E323D;
  --input-font-color: #CFD5E6;
  --input-border-color: #2E323D;
  --invite-title-color: #CFD4E6;
  --chat-editor-bg-color: #2E323D;
  --chat-editor-input-color:#292D38;
  --message-list-color: #1D2029;
  --textarea-color: #fff;
  --send-btn-color: #3D4352;
  --message-color: #3D4352;
  --background-color-style: #010101;
  --stream-container-border: #1B1E26;
  --apply-list-container-bg-color: #1D2029;
  --apply-list-container-color: #CFD4E6;
  --room-sidebar-bg-color: #1D2029;
  --create-room-option: rgba(50,59,84,0.60);
  --create-room-option-color: #EEE;
  --create-room-option-tab: #006EFF;
  --create-room-option-icon: #EEE;
  --create-room-option-icon-color:#EEE;
  --control-region-bg-color: rgba(13,16,21,0.60);
  --dialog-tabs-bg-color: rgba(0,0,0,0.20);
  --divide-line-color: #2E323D;
  --divice-line: #CFD4E6;
  --el-drawer-divide: #0D0F15;
  --send-btn: #CFD4E6;
  --invite-region: #FFF;
  --layout-list: #1D2029;
  --layout-item: #2E323D;
  --stream-list-container: #1D2029;
  --more-btn-background: rgba(173,182,204,0.10);
  --user-operate-list: #2E323D;
  --user-operate-item: #CFD4E6;
  --active-blur-background-color: rgba(27,93,172,0.85);
  --divide-line-color-setting: transparent;
  --el-disabled-background: #606266;
  --el-disabled-border: #909399;
  --el-border-lighter: #2E323D;
  --title-active: #B3B8C8;
  --mic-bar-color: #2E323D;
  --more-notice-color: #7C85A6;
  --setting-dialog: none;
  --caret-color: #fff;
  --apply-container-primary: #CFD4E6;
  --apply-container-outline: #CFD4E6;
  --el-drawer-body: #1D2029;
  --input-color-setting: #1D2029;
  --input-color-setting-hover: #2E323D;
  --switch-core-bg: #2E323D;
  --input-color-font: #CFD4E6;
  --input-color-setting-border: #2E323D;
  --el-message-box: #1D2029;
  --el-message-box-title: #CFD4E6;
  --el-button-text-color: #7C85A6;
  --selected-screen-share-dialog: #006EFF;
  /* H5 New Content */
  --log-out-mobile: rgba(0, 0, 0, 0.7);
  --log-out: #2C2C2E;
  --log-out-cancel: #2C2C2E;
  --room-detail: #292D38;
  --room-detail-background: black;
  --room-detail-title: white;
  --choose-type: #4F515A;
  --emoji-background-color:#2f313b;
  --chat-editor-input-color-h5:#292D38;
  --chat-editor-bg-color-h5: #0D1015;
  --message-list-color-h5: #1B1E26;
  --popup-mute-background-color-h5: #FFF;
  --mute-button-color-h5: #CFD5E6;
  --member-control-background-color-h5: #1B1E26;
  --member-border-color-h5:rgba(207, 212, 230, 0.1);
  --member-title-content-h5: #CFD5E6;
  --end-control-text-h5: #292D38;
  --end-control-title-h5: #CACACB;
  --end-control-cancel-h5: #FFF;
  --transfer-input-color-h5: #292D38;
  --popup-background-color-h5: #1B1E26;
  --popup-title-color-h5: #CFD4E6;
  --popup-content-color-h5: #7C85A6;
  --close-cancel-h5: #5a5a5e;
  --dialog-title-h5: #FFF;
  --manage-member-button-h5:#292D38;
  --message-body-h5: #292D38;
  --user-extra-info-bg-color-h5: #0565FA;
  --user-extra-info-color-h5: #FFF;
  --apply-container-background-outline-h5: #292D38;
  --apply-container-outline-h5: #CFD5E6;
}
.tui-theme-white {
  --background-color-1: #FFF;
  --background-color-2: #FBFCFE;
  --background-color-3: #F0F3FA;
  --background-color-4: #D5E0F2;
  --background-color-5: transparent;
  --background-color-6: #BDBDBD;
  --background-color-7: #F9FAFC;
  --background-color-8: #FFF;
  --background-color-9: #F7F9FC;
  --background-color-10: #E7EAF7;
  --background-color-11: #F0F3FA;
  --background-color-12: #FFF;
  --background-color-13: #F9FAFD;
  --hover-background-color-1: rgba(213, 224, 242, 0.5);
  --font-color-1: #4F586B;
  --font-color-2: #B2BBD1;
  --font-color-3: #000;
  --font-color-4: #4F586B;
  --font-color-5: #4F586B;
  --font-color-6: #0F1014;
  --font-color-7: #FFF;
  --font-color-8: #4F586B;
  --font-color-9: #969EB4;
  --font-color-10: #FF643D;
  --title-color: #0F1014;
  --stroke-color: #E4EAF7;
  --stroke-color-2: #EAEFF8;
  --border-color: #E4E8EE;
  --border-color-2: #E4E8EE;
  --disable-color: #F7F9FC;
  --active-color-1: #1C66E5;
  --active-color-2: #1C66E5;
  --green-color: #27C39F;
  --orange-color: #F06C4B;
  --white-color: #FFF;
  --black-color: #000;
  --red-color: #ED414D;
  --red-color-2: #F23C5B;
  --red-color-3: #E5395C;
  --control-content: #FFF;
  --background-image-color: transparent;
  --input-color: #FFF;
  --create-room-mode-color-bg: #FFF;
  --user-control-container-color-bg: #E8E8E8;
  --user-control-container-shadow: 0 12px 32px rgba(0, 0, 0, .1), 0 2px 6px;
  --stream-container-flatten-bg-color: rgba(242,242,242,1);
  --room-header-bg-color: #FFF;
  --room-footer-bg-color: #FFF;
  --room-network-bg-color: #FFF;
  --room-audiotab-bg-color: #FFF;
  --room-videotab-bg-color: #FFF;
  --stop-share-region-bg-color: #FFF;
  --setting-dialog-bg-color: #FFF;
  --icon-arrow-hover: rgba(232, 232, 232, 0.7);
  --el-dialog-bg-color: #FFF;
  --tabs-title-font-color: #000;
  --center-user-info-container-bg-color: #F2F2F2;
  --stream-info-bg-color: #FFF;
  --title-color-bg: #666;
  --title-color-font: #000;
  --el-dialog-bg-color-select: #FFF;
  --el-text-color-primary-select: #000;
  --el-text-color-regular-select: #596174;
  --el-fill-color-blank-select: #FFF;
  --el-border-color-select: #C8CACC;
  --setting-name-color: #000;
  --el-drawer-header-color: #000;
  --user-extra-info-bg-color: #006EFF;
  --user-extra-info-color: #FFF;
  --member-item-container-hover-bg-color: #F3F3F3;
  --el-bg-color-select: #FFF;
  --el-bg-color-overlay-select: #F2F2F2;
  --el-border-color-light-select: #F2F2F2;
  --el-fill-color-light-select: rgba(222, 222, 215, 0.7);
  --input-bg-color: #F2F2F2;
  --input-font-color: #000;
  --input-border-color: #F2F2F2;
  --invite-title-color: #7C85A6;
  --chat-editor-bg-color: #FFF;
  --message-list-color: #F6F6F6;
  --textarea-color: #000;
  --send-btn-color: #006EFF;
  --message-color: #006EFF;
  --stream-container-border: #fff;
  --apply-list-container-bg-color: #F2F2F2;
  --apply-list-container-color: #000;
  --room-sidebar-bg-color: #F2F2F2;
  --create-room-option: #eee;
  --create-room-option-tab: #006EFF;
  --create-room-option-color: #006EFF;
  --create-room-option-icon: #000;
  --create-room-option-icon-color:#006EFF;
  --control-region-bg-color: #EEE;
  --dialog-tabs-bg-color: #F0F3FA;
  --divide-line-color: transparent;
  --divice-line: #dcdcdc;
  --el-drawer-divide: transparent;
  --send-btn: #FFF;
  --invite-region: #000;
  --layout-list: #EEE;
  --layout-item: #FFF;
  --stream-list-container: #EEE;
  --more-btn-background: #006EFF;
  --user-operate-list: #EEE;
  --user-operate-item: #1D1029;
  --active-blur-background-color: transparent;
  --divide-line-color-setting: #dcdcdc;
  --el-disabled-border: #b6b6b6;
  --el-disabled-background: #dcdcdc;
  --el-border-lighter: #dcdcdc;
  --title-active: #666;
  --mic-bar-color: #babbbe;
  --more-notice-color: #000;
  --setting-dialog: 8px;
  --caret-color: #000;
  --apply-container-primary: #FFF;
  --apply-container-outline: #000;
  --el-drawer-body: #FFF;
  --input-color-setting: #FFF;
  --input-color-setting-hover: #f5f7fa;
  --switch-core-bg: #dcdfe6;
  --input-color-font: #646366;
  --input-color-setting-border: #babebe;
  --el-message-box: #FFF;
  --el-message-box-title: #000;
  --el-button-text-color: #646366;
  --selected-screen-share-dialog: #006EFF;
  /* H5 New Content */
  --log-out-mobile: rgba(0, 0, 0, 0.7);
  --log-out: #F9F9F9C7;
  --log-out-cancel: #FFF;
  --room-detail: #F5F5F5;
  --room-detail-background: white;
  --room-detail-title: black;
  --choose-type: #E1E1E3;
  --emoji-background-color:#efecec;
  --chat-editor-input-color-h5:#dfdcdc;
  --chat-editor-bg-color-h5: #f1f1f1;
  --message-list-color-h5: #d4d4d4;
  --popup-mute-background-color-h5: #ececed;
  --mute-button-color-h5: #FFF;
  --member-control-background-color-h5: #F2F2F2;
  --member-border-color-h5: #FFF;
  --member-title-content-h5: #5f5c5c;
  --end-control-text-h5: #CFD4E6;
  --end-control-title-h5: rgba(37, 37, 37, 0.78);
  --end-control-cancel-h5: #2C2C2E;
  --transfer-input-color-h5: #d4d4d4;
  --popup-background-color-h5: #d4d4d4;
  --popup-title-color-h5: #141313;
  --popup-content-color-h5: #636060;
  --close-cancel-h5: #006EFF;
  --dialog-title-h5: #2B2E38;
  --manage-member-button-h5:#006EFF;
  --message-body-h5: #817e7e;
  --user-extra-info-bg-color-h5: #006EFF;
  --user-extra-info-color-h5: #FFF;
  --apply-container-background-outline-h5: #006EFF;
  --apply-container-outline-h5: #FFF;
}
.pre-conference-container[data-v-a93692d6] {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  font-family: "PingFang SC";
  color: var(--font-color-1);
  background: var(--background);
  background-size: cover;
}
.pre-conference-container .header[data-v-a93692d6] {
  position: absolute;
  top: 0;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 4rem;
  padding: 0 24px;
}
.pre-conference-container .header .left-header[data-v-a93692d6],
.pre-conference-container .header .right-header[data-v-a93692d6] {
  display: flex;
  align-items: center;
}
.pre-conference-container .header .left-header .header-item[data-v-a93692d6]:not(:first-child),
.pre-conference-container .header .right-header .header-item[data-v-a93692d6]:not(:first-child) {
  margin-left: 16px;
}
.pre-conference-container .pre-home-control[data-v-a93692d6] {
  position: absolute;
  left: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  transform: translateX(-50%);
}
.pre-conference-container .pre-home-control .logo[data-v-a93692d6] {
  margin-bottom: 56px;
}
.pre-conference-container .pre-home-control .pre-home-control-container[data-v-a93692d6] {
  display: flex;
}
.tui-theme-black.pre-conference-container[data-v-a93692d6] {
  --background: var(--background-color-1);
}
.tui-theme-white.pre-conference-container[data-v-a93692d6] {
  --background: url("data:image/png;base64,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");
}.room-message-container.isMe .room-message-card-container[data-v-4aeb21ef] {
  border-top-right-radius: 0;
}
.room-message-container.notMe .room-message-card-container[data-v-4aeb21ef] {
  border-top-left-radius: 0;
}
.room-message-card-container[data-v-4aeb21ef] {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  width: 100%;
  min-width: 238px;
  max-width: 436px;
  height: 100%;
  overflow: hidden;
  user-select: none;
  border: 1px solid #ddd;
  border-radius: 1rem;
}
.room-message-card-container .content[data-v-4aeb21ef] {
  padding: 1.6rem 1rem 1rem;
  background: linear-gradient(90deg, #dceafd -17.36%, rgba(220, 234, 253, 0.4) 103.56%);
  border-bottom: 1px solid #ddd;
}
.room-message-card-container .content .content-title[data-v-4aeb21ef] {
  display: flex;
  flex-direction: row;
}
.room-message-card-container .content .content-title .icon[data-v-4aeb21ef] {
  width: 16px;
  margin-right: 6px;
  background-repeat: no-repeat;
  background-position: center;
}
.room-message-card-container .content .content-desc[data-v-4aeb21ef] {
  padding-top: 0.6rem;
}
.room-message-card-container .content .content-desc .title[data-v-4aeb21ef] {
  overflow: hidden;
  font-size: 16px;
  font-weight: 500;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.room-message-card-container .content .content-desc .users[data-v-4aeb21ef] {
  display: flex;
  flex-direction: row;
  margin-top: 0.6rem;
}
.room-message-card-container .content .content-desc .users .more[data-v-4aeb21ef] {
  font-size: 16px;
  font-weight: bold;
}
.room-message-card-container .content .content-desc .users li[data-v-4aeb21ef] {
  width: 27px;
  min-width: 27px;
  height: 27px;
  margin-right: 10px;
  overflow: hidden;
  border-radius: 3px;
}
.room-message-card-container .content .content-desc .users li img[data-v-4aeb21ef] {
  width: 100%;
}
.room-message-card-container .footer[data-v-4aeb21ef] {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 1rem;
  color: #888;
}
.room-message-card-container .footer .room-info[data-v-4aeb21ef] {
  line-height: 21px;
}
.room-message-card-container .footer .room-info.center[data-v-4aeb21ef] {
  width: 100%;
  text-align: center;
}
.room-message-card-container .footer .room-status[data-v-4aeb21ef] {
  padding: 0.6rem;
  font-weight: 900;
  color: #fff;
  cursor: pointer;
  background-color: #147AFF;
  border-radius: 4px;
}
.content-title.default[data-v-4aeb21ef] {
  color: #888;
}
.content-title.default .icon[data-v-4aeb21ef] {
  background-image: url("data:image/svg+xml,%3csvg%20width='17'%20height='17'%20viewBox='0%200%2017%2017'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M2.10011%203.56676C1.51101%203.56676%201.03345%204.04432%201.03345%204.63342V12.3668C1.03345%2012.9559%201.51101%2013.4334%202.10011%2013.4334H10.8557C11.4448%2013.4334%2011.9223%2012.9559%2011.9223%2012.3668V4.63342C11.9223%204.04432%2011.4448%203.56676%2010.8557%203.56676H2.10011ZM13.0778%2010.2381V6.71426L15.564%205.23907C15.7418%205.13359%2015.9667%205.2617%2015.9667%205.4684V11.5867C15.9667%2011.797%2015.7347%2011.9245%2015.5572%2011.8118L13.0778%2010.2381Z'%20fill='%23888888'/%3e%3cpath%20d='M8.30081%209.77528L8.36937%209.66093C8.35409%209.65177%208.3347%209.64033%208.31659%209.63068L8.25001%209.5952L8.18532%209.63399C8.14764%209.65658%208.09515%209.69099%208.04473%209.72404C8.03779%209.72858%208.0309%209.7331%208.02408%209.73757L8.02372%209.7378C7.92751%209.80123%207.80223%209.88304%207.63349%209.9856C7.42327%2010.1133%207.19272%2010.1008%206.98997%2010.0394C6.78688%209.97794%206.62849%209.87192%206.58307%209.83944L6.58315%209.83934L6.5782%209.83612C6.51542%209.79529%206.15172%209.55749%205.881%209.28701C5.60992%209.01416%205.36963%208.65012%205.33047%208.58946L5.3306%208.58937L5.32685%208.58414C5.29415%208.53849%205.18739%208.37997%205.12544%208.17688C5.06361%207.97416%205.05097%207.74396%205.17932%207.5342C5.28216%207.36721%205.36323%207.24274%205.42576%207.14753L5.42607%207.14704C5.43387%207.13505%205.44193%207.12274%205.45003%207.11035C5.48048%207.06382%205.51162%207.01622%205.5322%206.98109L5.5709%206.91502L5.53334%206.84829L5.5187%206.82268L5.50538%206.7994L5.50541%206.79938L5.50388%206.79679C5.49229%206.77725%205.48023%206.75561%205.46607%206.73021C5.46211%206.72309%205.45798%206.71568%205.45364%206.70793L5.45353%206.70772C4.85378%205.63982%204.45303%205.53216%204.31781%205.53216H4.30982H4.29136L4.27359%205.53717C4.16844%205.56686%204.07356%205.64673%203.99628%205.74429C3.91683%205.84458%203.84602%205.97586%203.79288%206.12969C3.68638%206.43799%203.64747%206.84646%203.76108%207.30215L3.7611%207.30222C4.0065%208.28413%204.53062%209.21646%205.23669%209.92713L5.23724%209.92767C5.94652%2010.6334%206.87957%2011.1561%207.86208%2011.4003C8.31016%2011.513%208.71757%2011.4733%209.02661%2011.3674C9.18088%2011.3145%209.31315%2011.2443%209.41453%2011.1659C9.51288%2011.0899%209.59468%2010.9962%209.62577%2010.892L9.62604%2010.8921L9.62796%2010.8837C9.64335%2010.8166%209.62316%2010.7413%209.59211%2010.674C9.55844%2010.6009%209.50215%2010.5158%209.41677%2010.4204C9.24601%2010.2295%208.95073%209.9883%208.45697%209.71092L8.45668%209.71075C8.42299%209.69194%208.39422%209.67564%208.36874%209.66056L8.30081%209.77528ZM8.30081%209.77528C8.32777%209.79125%208.35772%209.80821%208.39167%209.82717L6.50551%209.9479C6.60736%2010.0207%207.19348%2010.4089%207.70271%2010.0996C7.87345%209.99579%208.00026%209.91298%208.09711%209.84912C8.10401%209.8446%208.11093%209.84007%208.11782%209.83555C8.16879%209.80214%208.2187%209.76944%208.25388%209.74834C8.26886%209.75633%208.28583%209.7663%208.30081%209.77528Z'%20fill='white'%20stroke='white'%20stroke-width='0.266667'/%3e%3c/svg%3e");
}
.content-title.success[data-v-4aeb21ef] {
  color: rgb(21, 183, 45);
}
.content-title.success .icon[data-v-4aeb21ef] {
  background-image: url("data:image/svg+xml,%3csvg%20width='16'%20height='17'%20viewBox='0%200%2016%2017'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M1.60011%203.56665C1.01101%203.56665%200.533447%204.04421%200.533447%204.63332V12.3666C0.533447%2012.9558%201.01101%2013.4333%201.60011%2013.4333H10.3557C10.9448%2013.4333%2011.4223%2012.9558%2011.4223%2012.3666V4.63332C11.4223%204.04421%2010.9448%203.56665%2010.3557%203.56665H1.60011ZM12.5778%2010.2379V6.71416L15.064%205.23896C15.2418%205.13348%2015.4667%205.2616%2015.4667%205.46829V11.5866C15.4667%2011.7969%2015.2347%2011.9244%2015.0572%2011.8117L12.5778%2010.2379Z'%20fill='%2315B72D'/%3e%3cpath%20d='M7.80081%209.7752L7.86937%209.66085C7.85409%209.65168%207.8347%209.64025%207.81659%209.63059L7.75001%209.59512L7.68532%209.63391C7.64764%209.6565%207.59515%209.6909%207.54473%209.72395C7.53779%209.7285%207.5309%209.73302%207.52408%209.73748L7.52372%209.73772C7.42751%209.80115%207.30223%209.88296%207.13349%209.98551C6.92327%2010.1132%206.69272%2010.1007%206.48997%2010.0393C6.28688%209.97786%206.12849%209.87184%206.08307%209.83936L6.08315%209.83925L6.0782%209.83604C6.01542%209.79521%205.65172%209.5574%205.381%209.28693C5.10992%209.01407%204.86963%208.65004%204.83047%208.58937L4.8306%208.58929L4.82685%208.58406C4.79415%208.53841%204.68739%208.37989%204.62544%208.17679C4.56361%207.97408%204.55097%207.74387%204.67932%207.53412C4.78216%207.36712%204.86323%207.24265%204.92576%207.14744L4.92607%207.14695C4.93387%207.13497%204.94193%207.12265%204.95003%207.11026C4.98048%207.06373%205.01162%207.01613%205.0322%206.981L5.0709%206.91493L5.03334%206.8482L5.0187%206.8226L5.00538%206.79931L5.00541%206.7993L5.00388%206.79671C4.99229%206.77717%204.98023%206.75553%204.96607%206.73012C4.96211%206.72301%204.95798%206.71559%204.95364%206.70785L4.95353%206.70763C4.35378%205.63974%203.95303%205.53207%203.81781%205.53207H3.80982H3.79136L3.77359%205.53709C3.66844%205.56678%203.57356%205.64664%203.49628%205.7442C3.41683%205.8445%203.34602%205.97578%203.29288%206.12961C3.18638%206.4379%203.14747%206.84637%203.26108%207.30207L3.2611%207.30214C3.5065%208.28405%204.03062%209.21637%204.73669%209.92705L4.73724%209.92759C5.44652%2010.6333%206.37957%2011.156%207.36208%2011.4002C7.81016%2011.5129%208.21757%2011.4732%208.52661%2011.3673C8.68088%2011.3145%208.81315%2011.2443%208.91453%2011.1658C9.01288%2011.0898%209.09468%2010.9961%209.12577%2010.8919L9.12604%2010.892L9.12796%2010.8836C9.14335%2010.8165%209.12316%2010.7412%209.09211%2010.6739C9.05844%2010.6008%209.00215%2010.5157%208.91677%2010.4203C8.74601%2010.2294%208.45073%209.98821%207.95697%209.71084L7.95668%209.71067C7.92299%209.69186%207.89422%209.67556%207.86874%209.66047L7.80081%209.7752ZM7.80081%209.7752C7.82777%209.79116%207.85772%209.80813%207.89167%209.82708L6.00551%209.94781C6.10736%2010.0206%206.69348%2010.4088%207.20271%2010.0995C7.37345%209.99571%207.50026%209.91289%207.59711%209.84903C7.60401%209.84452%207.61093%209.83999%207.61782%209.83547C7.66879%209.80206%207.7187%209.76935%207.75388%209.74826C7.76886%209.75624%207.78583%209.76622%207.80081%209.7752Z'%20fill='white'%20stroke='white'%20stroke-width='0.266667'/%3e%3c/svg%3e");
}
.content-title.primary[data-v-4aeb21ef] {
  color: #147AFF;
}
.content-title.primary .icon[data-v-4aeb21ef] {
  background-image: url("data:image/svg+xml,%3csvg%20width='16'%20height='17'%20viewBox='0%200%2016%2017'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M1.60011%203.35596C1.01101%203.35596%200.533447%203.83352%200.533447%204.42262V12.156C0.533447%2012.7451%201.01101%2013.2226%201.60011%2013.2226H10.3557C10.9448%2013.2226%2011.4223%2012.7451%2011.4223%2012.156V4.42262C11.4223%203.83352%2010.9448%203.35596%2010.3557%203.35596H1.60011ZM12.5778%2010.0273V6.50346L15.064%205.02827C15.2418%204.92279%2015.4667%205.0509%2015.4667%205.2576V11.3759C15.4667%2011.5862%2015.2347%2011.7137%2015.0572%2011.601L12.5778%2010.0273Z'%20fill='%23147AFF'/%3e%3cpath%20d='M7.80081%209.56451L7.86937%209.45015C7.85409%209.44099%207.8347%209.42955%207.81659%209.4199L7.75001%209.38442L7.68532%209.42321C7.64764%209.4458%207.59515%209.48021%207.54473%209.51326C7.53779%209.51781%207.5309%209.52233%207.52408%209.52679L7.52372%209.52702C7.42751%209.59046%207.30223%209.67227%207.13349%209.77482C6.92327%209.90251%206.69272%209.89001%206.48997%209.82864C6.28688%209.76717%206.12849%209.66115%206.08307%209.62867L6.08315%209.62856L6.0782%209.62534C6.01542%209.58452%205.65172%209.34671%205.381%209.07624C5.10992%208.80338%204.86963%208.43934%204.83047%208.37868L4.8306%208.3786L4.82685%208.37336C4.79415%208.32771%204.68739%208.1692%204.62544%207.9661C4.56361%207.76339%204.55097%207.53318%204.67932%207.32342C4.78216%207.15643%204.86323%207.03196%204.92576%206.93675L4.92607%206.93626C4.93387%206.92428%204.94193%206.91196%204.95003%206.89957C4.98048%206.85304%205.01162%206.80544%205.0322%206.77031L5.0709%206.70424L5.03334%206.63751L5.0187%206.61191L5.00538%206.58862L5.00541%206.5886L5.00388%206.58601C4.99229%206.56647%204.98023%206.54484%204.96607%206.51943C4.96211%206.51231%204.95798%206.5049%204.95364%206.49715L4.95353%206.49694C4.35378%205.42905%203.95303%205.32138%203.81781%205.32138H3.80982H3.79136L3.77359%205.32639C3.66844%205.35608%203.57356%205.43595%203.49628%205.53351C3.41683%205.6338%203.34602%205.76508%203.29288%205.91891C3.18638%206.22721%203.14747%206.63568%203.26108%207.09137L3.2611%207.09145C3.5065%208.07335%204.03062%209.00568%204.73669%209.71635L4.73724%209.7169C5.44652%2010.4226%206.37957%2010.9453%207.36208%2011.1895C7.81016%2011.3022%208.21757%2011.2625%208.52661%2011.1566C8.68088%2011.1038%208.81315%2011.0336%208.91453%2010.9552C9.01288%2010.8791%209.09468%2010.7854%209.12577%2010.6812L9.12604%2010.6813L9.12796%2010.6729C9.14335%2010.6058%209.12316%2010.5305%209.09211%2010.4632C9.05844%2010.3901%209.00215%2010.305%208.91677%2010.2096C8.74601%2010.0187%208.45073%209.77752%207.95697%209.50014L7.95668%209.49998C7.92299%209.48117%207.89422%209.46486%207.86874%209.44978L7.80081%209.56451ZM7.80081%209.56451C7.82777%209.58047%207.85772%209.59743%207.89167%209.61639L6.00551%209.73712C6.10736%209.80996%206.69348%2010.1981%207.20271%209.88878C7.37345%209.78501%207.50026%209.7022%207.59711%209.63834C7.60401%209.63382%207.61093%209.62929%207.61782%209.62478C7.66879%209.59137%207.7187%209.55866%207.75388%209.53757C7.76886%209.54555%207.78583%209.55553%207.80081%209.56451Z'%20fill='white'%20stroke='white'%20stroke-width='0.266667'/%3e%3c/svg%3e");
}
.room-message-card-container .footer.in-room .room-status[data-v-4aeb21ef] {
  color: #999;
  background-color: #F3F4F4;
}
.room-message-card-container.destroyed .content[data-v-4aeb21ef] {
  background: rgba(221, 221, 221, 0.3);
}.common-icon-container[data-v-1da8a3b2] {
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}
.common-icon-container-mobile[data-v-1da8a3b2] {
  cursor: none;
}.chat-header[data-v-14f4476c] {
  display: flex;
  min-width: 0;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
.chat-header-container[data-v-14f4476c] {
  display: flex;
  min-width: 0;
  flex-direction: column;
  justify-content: flex-start;
}
.chat-header-content[data-v-14f4476c] {
  margin-right: 20px;
  flex: 1;
  font-size: 16px;
  line-height: 30px;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: #000;
  letter-spacing: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.chat-header-back[data-v-14f4476c], .chat-header-setting[data-v-14f4476c] {
  width: 27px;
  height: 27px;
}
.chat-header-back .icon[data-v-14f4476c], .chat-header-setting .icon[data-v-14f4476c] {
  width: 100%;
  height: 100%;
}
.chat-header-h5-back[data-v-14f4476c] {
  display: flex;
  justify-content: center;
  align-items: center;
}
.chat-header-h5-content[data-v-14f4476c] {
  margin: 0 20px;
  text-align: center;
}[data-v-44d9a08c]:not(not) {
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  min-width: 0;
}
.avatar-container[data-v-44d9a08c] {
  position: relative;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  flex: 0 0 auto;
}
.avatar-container .placeholder[data-v-44d9a08c] {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #ececec;
  transition: opacity 0.3s, background-color 0.1s ease-out;
}
.avatar-container .placeholder.skeleton-animation[data-v-44d9a08c] {
  animation: breath-44d9a08c 2s linear 0.3s infinite;
}
.avatar-container .placeholder.hidden[data-v-44d9a08c] {
  opacity: 0;
}
.avatar-container .avatar-image[data-v-44d9a08c] {
  width: 100%;
  height: 100%;
}
@keyframes breath-44d9a08c {
50% {
    /* stylelint-disable-next-line scss/no-global-function-names */
    background-color: rgb(210.5, 210.5, 210.5);
}
}.overlay-container[data-v-7c386a69] {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
}
.overlay-container .overlay-mask[data-v-7c386a69] {
  z-index: -1;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  opacity: 0;
  transition: opacity 0.15s linear;
  animation: fade-in-7c386a69 0.15s linear;
}
.overlay-container .full-screen[data-v-7c386a69] {
  width: 100%;
  height: 100%;
}
.overlay-mask.fade-in[data-v-7c386a69] {
  opacity: 1;
}
@keyframes fade-in-7c386a69 {
0% {
    opacity: 0;
}
100% {
    opacity: 1;
}
}[data-v-69f0b47f]:not(not) {
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  min-width: 0;
}
.drawer[data-v-69f0b47f] {
  position: absolute;
  z-index: 1;
  background-color: #fff;
  overflow: hidden;
  transition: transform 0.15s ease-out;
}
.drawer .drawer-container[data-v-69f0b47f] {
  background-color: #fff;
  height: 100%;
  width: 100%;
}
.origin-bottom[data-v-69f0b47f] {
  bottom: 0;
  left: 0;
  right: 0;
  transform: translateY(100%);
  animation: slide-from-bottom-69f0b47f 0.15s ease-out;
}
.origin-right[data-v-69f0b47f] {
  top: 0;
  bottom: 0;
  right: 0;
  transform: translateX(100%);
  animation: slide-from-right-69f0b47f 0.15s ease-out;
}
.slide-bottom[data-v-69f0b47f] {
  transform: translateY(0);
}
.slide-right[data-v-69f0b47f] {
  transform: translateX(0);
}
@keyframes slide-from-bottom-69f0b47f {
0% {
    transform: translateY(100%);
}
100% {
    transform: translateY(0);
}
}
@keyframes slide-from-right-69f0b47f {
0% {
    transform: translateX(100%);
}
100% {
    transform: translateX(0);
}
}[data-v-f7281441]:not(not) {
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  min-width: 0;
}
.flex-row[data-v-f7281441] {
  flex-direction: row;
}
.application-tips[data-v-f7281441] {
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 100%;
  padding: 5px 0;
  font-size: 14px;
  background-color: #fce4d3;
}
.application-tips .application-tips-btn[data-v-f7281441] {
  color: #006eff;
  cursor: pointer;
  margin-left: 12px;
}
.application-contaienr[data-v-f7281441] {
  padding: 50px 18px 10px;
  background-color: #fff;
  height: 100%;
  overflow: hidden auto;
  font-size: 14px;
}
.application-contaienr .application-header[data-v-f7281441] {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  padding: 10px 20px;
  flex-direction: row-reverse;
  color: #679ce1;
  font-size: 14px;
}
.application-contaienr .application-item[data-v-f7281441] {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 10px 0;
  transition: transform 0.15s ease-out;
}
.application-contaienr .application-item + .application-item[data-v-f7281441] {
  border-top: 0.5px solid #d0d0d0;
}
.application-contaienr .application-item .application-item-info[data-v-f7281441] {
  margin-left: 8px;
  margin-right: 8px;
  font-size: 14px;
}
.application-contaienr .application-item .application-item-info .application-item-nick[data-v-f7281441] {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.application-contaienr .application-item .application-item-info .application-item-note[data-v-f7281441] {
  color: #989191;
  font-size: 12px;
}
.application-contaienr .application-item .application-item-operation[data-v-f7281441] {
  flex-direction: row;
  margin-left: auto;
  padding: 8px;
  flex: 0 0 auto;
  font-size: 14px;
}
.application-contaienr .application-item .application-item-operation .agree[data-v-f7281441] {
  color: #679ce1;
  cursor: pointer;
}
.application-contaienr .application-item .application-item-operation .reject[data-v-f7281441] {
  margin-left: 12px;
  color: #fb355d;
  cursor: pointer;
}
.application-contaienr .removed[data-v-f7281441] {
  transform: translateX(-100%);
}.message-text-container[data-v-e3c6fedb] {
  display: inline;
}
.text-select[data-v-e3c6fedb] {
  -webkit-user-select: text;
  -moz-user-select: text;
  -ms-user-select: text;
  user-select: text;
}
.emoji[data-v-e3c6fedb] {
  vertical-align: bottom;
  width: 20px;
  height: 20px;
}
.text[data-v-e3c6fedb] {
  white-space: pre-wrap;
  word-break: break-all;
  font-size: 14px;
  text-size-adjust: none;
}body[data-v-42bbcaf4], div[data-v-42bbcaf4], ul[data-v-42bbcaf4], ol[data-v-42bbcaf4], dt[data-v-42bbcaf4], dd[data-v-42bbcaf4], li[data-v-42bbcaf4], dl[data-v-42bbcaf4], h1[data-v-42bbcaf4], h2[data-v-42bbcaf4], h3[data-v-42bbcaf4], h4[data-v-42bbcaf4], p[data-v-42bbcaf4] {
  margin: 0;
  padding: 0;
  font-style: normal;
  /* font:12px/22px"\\5B8B\\4F53",Arial,Helvetica,sans-serif; */
}
ol[data-v-42bbcaf4], ul[data-v-42bbcaf4], li[data-v-42bbcaf4] {
  list-style: none;
}
img[data-v-42bbcaf4] {
  border: 0;
  vertical-align: middle;
  pointer-events: none;
}
body[data-v-42bbcaf4] {
  color: #000;
  background: #FFF;
}
.clear[data-v-42bbcaf4] {
  clear: both;
  height: 1px;
  width: 100%;
  overflow: hidden;
  margin-top: -1px;
}
a[data-v-42bbcaf4] {
  color: #000;
  text-decoration: none;
  cursor: pointer;
}
a[data-v-42bbcaf4]:hover {
  text-decoration: none;
}
input[data-v-42bbcaf4], textarea[data-v-42bbcaf4] {
  user-select: auto;
}
input[data-v-42bbcaf4]:focus, input[data-v-42bbcaf4]:active, textarea[data-v-42bbcaf4]:focus, textarea[data-v-42bbcaf4]:active {
  outline: none;
}
.chat-aside[data-v-42bbcaf4] {
  position: absolute;
  top: 50px;
  right: 0;
  box-sizing: border-box;
  width: 360px !important;
  border-radius: 8px 0 0 8px;
  z-index: 9999;
  max-height: calc(100% - 50px);
}
.image-container[data-v-42bbcaf4] {
  overflow: hidden;
  background-color: #f4f4f4;
}
.image-container .message-image[data-v-42bbcaf4] {
  max-width: min(100vw - 180px, 300px);
  max-height: min(100vw - 180px, 300px);
  width: inherit;
  height: inherit;
}
.image-container .message-image-h5[data-v-42bbcaf4] {
  max-width: calc(100vw - 180px);
  max-height: calc(100vw - 180px);
}body[data-v-7c9f5c5e], div[data-v-7c9f5c5e], ul[data-v-7c9f5c5e], ol[data-v-7c9f5c5e], dt[data-v-7c9f5c5e], dd[data-v-7c9f5c5e], li[data-v-7c9f5c5e], dl[data-v-7c9f5c5e], h1[data-v-7c9f5c5e], h2[data-v-7c9f5c5e], h3[data-v-7c9f5c5e], h4[data-v-7c9f5c5e], p[data-v-7c9f5c5e] {
  margin: 0;
  padding: 0;
  font-style: normal;
  /* font:12px/22px"\\5B8B\\4F53",Arial,Helvetica,sans-serif; */
}
ol[data-v-7c9f5c5e], ul[data-v-7c9f5c5e], li[data-v-7c9f5c5e] {
  list-style: none;
}
img[data-v-7c9f5c5e] {
  border: 0;
  vertical-align: middle;
  pointer-events: none;
}
body[data-v-7c9f5c5e] {
  color: #000;
  background: #FFF;
}
.clear[data-v-7c9f5c5e] {
  clear: both;
  height: 1px;
  width: 100%;
  overflow: hidden;
  margin-top: -1px;
}
a[data-v-7c9f5c5e] {
  color: #000;
  text-decoration: none;
  cursor: pointer;
}
a[data-v-7c9f5c5e]:hover {
  text-decoration: none;
}
input[data-v-7c9f5c5e], textarea[data-v-7c9f5c5e] {
  user-select: auto;
}
input[data-v-7c9f5c5e]:focus, input[data-v-7c9f5c5e]:active, textarea[data-v-7c9f5c5e]:focus, textarea[data-v-7c9f5c5e]:active {
  outline: none;
}
.chat-aside[data-v-7c9f5c5e] {
  position: absolute;
  top: 50px;
  right: 0;
  box-sizing: border-box;
  width: 360px !important;
  border-radius: 8px 0 0 8px;
  z-index: 9999;
  max-height: calc(100% - 50px);
}
.message-audio[data-v-7c9f5c5e] {
  flex-direction: row;
  display: flex;
  flex: 0 0 auto;
  cursor: pointer;
  overflow: hidden;
}
.message-audio .time[data-v-7c9f5c5e] {
  flex: 1 1 auto;
  max-width: 300px;
  text-align: start;
}
.message-audio audio[data-v-7c9f5c5e] {
  width: 0;
  height: 0;
}
.disable[data-v-7c9f5c5e] {
  cursor: not-allowed;
}
.audio-icon-container[data-v-7c9f5c5e] {
  flex: 0 0 auto;
  position: relative;
  margin: 0 7px 0 0;
  overflow: hidden;
}
.audio-icon-container .mask[data-v-7c9f5c5e] {
  position: absolute;
  z-index: 1;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  transform-origin: right;
  transform: scaleX(0);
  background-color: #fbfbfb;
}
.audio-icon-container .mask.play[data-v-7c9f5c5e] {
  animation: audio-play-7c9f5c5e 2s steps(1, end) infinite;
}
@keyframes audio-play-7c9f5c5e {
0% {
    transform: scaleX(0.7056);
}
50% {
    transform: scaleX(0.3953);
}
75% {
    transform: scaleX(0);
    visibility: hidden;
}
100% {
    transform: scaleX(0);
    visibility: hidden;
}
}
.message-audio.reserve[data-v-7c9f5c5e] {
  flex-direction: row-reverse;
}
.message-audio.reserve .time[data-v-7c9f5c5e] {
  text-align: end;
}
.message-audio.reserve .icon[data-v-7c9f5c5e] {
  transform: rotate(180deg);
}
.message-audio.reserve .audio-icon-container[data-v-7c9f5c5e] {
  margin: 0 0 0 7px;
}
.message-audio.reserve .audio-icon-container .mask[data-v-7c9f5c5e] {
  transform-origin: left;
  background-color: #dceafd;
}[data-v-af167129]:not(not) {
  display: flex;
  flex-direction: column;
  min-width: 0;
  box-sizing: border-box;
}
.simple-message-container[data-v-af167129] {
  flex-direction: row;
}
.simple-message-container .simple-message-avatar[data-v-af167129] {
  flex: 0 0 auto;
  margin-right: 8px;
}
.simple-message-container .simple-message-sender[data-v-af167129] {
  display: block;
  max-width: 200px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 11px;
  color: #999;
}
.simple-message-container .simple-message-body[data-v-af167129] {
  flex-direction: row;
  align-items: flex-end;
}
.simple-message-container .simple-message-content[data-v-af167129] {
  margin-top: 8px;
  background-color: #dceafd;
  border-radius: 0 10px 10px;
  padding: 10px 12px;
}
.simple-message-container .timestamp[data-v-af167129] {
  flex: 0 0 auto;
  font-size: 12px;
  color: #aaa;
  margin-left: 6px;
}
.simple-message-container .no-padding[data-v-af167129] {
  padding: 0;
  background-color: transparent;
}[data-v-b1da437a]:not(not) {
  display: flex;
  flex-direction: column;
  min-width: 0;
  box-sizing: border-box;
}
.simple-message-list-container[data-v-b1da437a] {
  flex: 1;
  position: relative;
  overflow: hidden;
  width: 40vw;
  min-width: 550px;
  height: calc(100vh - 200px);
  background-color: #fff;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  border-radius: 8px;
}
.simple-message-list-container-mobile[data-v-b1da437a] {
  width: 100vw;
  height: 100vh;
  min-width: auto;
  border-radius: 0;
}
.simple-message-list-container .header-container[data-v-b1da437a] {
  width: 100%;
  text-align: center;
  font-weight: bold;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  height: 60px;
  justify-content: center;
  align-items: center;
  padding: 0 70px;
  background-color: #fff;
}
.simple-message-list-container .header-container .back[data-v-b1da437a] {
  flex-direction: row;
  align-items: center;
  position: absolute;
  left: 10px;
  cursor: pointer;
}
.simple-message-list-container .header-container .title[data-v-b1da437a] {
  width: 100%;
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.simple-message-list-container .message-list[data-v-b1da437a] {
  padding: 60px 20px 20px;
  flex: 1 1 auto;
  overflow: hidden auto;
}
.message-item[data-v-b1da437a] {
  flex-direction: row;
  margin: 10px 0;
}
.message-text[data-v-b1da437a] {
  flex-flow: row wrap;
  display: inline;
}
.message-text-container[data-v-b1da437a] {
  display: inline;
  flex: 0 0 auto;
  flex-direction: row;
}
.message-text-container .text[data-v-b1da437a] {
  vertical-align: bottom;
  display: inline;
  word-break: break-all;
}
.message-text-container .simple-emoji[data-v-b1da437a] {
  display: inline-flex;
  width: 20px;
  height: 20px;
}
.message-image[data-v-b1da437a] {
  max-width: 180px;
  border-radius: 10px;
  overflow: hidden;
}
.message-image .image[data-v-b1da437a] {
  max-width: 180px;
}
.message-face[data-v-b1da437a] {
  max-width: 100px;
}
.message-face .image[data-v-b1da437a] {
  width: 80px;
  height: 80px;
}
.message-audio[data-v-b1da437a] {
  flex-direction: row;
}
.message-video[data-v-b1da437a] {
  position: relative;
}
.message-video .image[data-v-b1da437a] {
  max-width: 180px;
}
.message-video .video-play-icon[data-v-b1da437a] {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.message-video .video[data-v-b1da437a] {
  max-width: 150px;
  width: inherit;
  height: inherit;
  border-radius: 10px;
}
.message-combine[data-v-b1da437a] {
  max-width: 300px;
}[data-v-fed3549f]:not(not) {
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  min-width: 0;
}
.message-record-container[data-v-fed3549f] {
  padding: 10px 15px;
  border: 1px solid #ddd;
  border-radius: 10px;
  cursor: pointer;
  background-color: #fff;
  max-width: 400px;
  min-width: 180px;
  overflow: hidden;
}
.message-record-container .record-abstract-container[data-v-fed3549f] {
  color: #bbb;
  font-size: 12px;
  margin: 8px 0;
}
.message-record-container .record-footer[data-v-fed3549f] {
  color: #888;
  font-size: 11px;
  padding-top: 5px;
  border-top: 1px solid #eee;
}body[data-v-8cc5dd38], div[data-v-8cc5dd38], ul[data-v-8cc5dd38], ol[data-v-8cc5dd38], dt[data-v-8cc5dd38], dd[data-v-8cc5dd38], li[data-v-8cc5dd38], dl[data-v-8cc5dd38], h1[data-v-8cc5dd38], h2[data-v-8cc5dd38], h3[data-v-8cc5dd38], h4[data-v-8cc5dd38], p[data-v-8cc5dd38] {
  margin: 0;
  padding: 0;
  font-style: normal;
  /* font:12px/22px"\\5B8B\\4F53",Arial,Helvetica,sans-serif; */
}
ol[data-v-8cc5dd38], ul[data-v-8cc5dd38], li[data-v-8cc5dd38] {
  list-style: none;
}
img[data-v-8cc5dd38] {
  border: 0;
  vertical-align: middle;
  pointer-events: none;
}
body[data-v-8cc5dd38] {
  color: #000;
  background: #FFF;
}
.clear[data-v-8cc5dd38] {
  clear: both;
  height: 1px;
  width: 100%;
  overflow: hidden;
  margin-top: -1px;
}
a[data-v-8cc5dd38] {
  color: #000;
  text-decoration: none;
  cursor: pointer;
}
a[data-v-8cc5dd38]:hover {
  text-decoration: none;
}
input[data-v-8cc5dd38], textarea[data-v-8cc5dd38] {
  user-select: auto;
}
input[data-v-8cc5dd38]:focus, input[data-v-8cc5dd38]:active, textarea[data-v-8cc5dd38]:focus, textarea[data-v-8cc5dd38]:active {
  outline: none;
}
.chat-aside[data-v-8cc5dd38] {
  position: absolute;
  top: 50px;
  right: 0;
  box-sizing: border-box;
  width: 360px !important;
  border-radius: 8px 0 0 8px;
  z-index: 9999;
  max-height: calc(100% - 50px);
}
.file-message-montainer[data-v-8cc5dd38] {
  display: flex;
  flex-direction: row;
  cursor: pointer;
}
.file-message-montainer .file-icon[data-v-8cc5dd38] {
  margin: auto 8px;
}body[data-v-35bb4072], div[data-v-35bb4072], ul[data-v-35bb4072], ol[data-v-35bb4072], dt[data-v-35bb4072], dd[data-v-35bb4072], li[data-v-35bb4072], dl[data-v-35bb4072], h1[data-v-35bb4072], h2[data-v-35bb4072], h3[data-v-35bb4072], h4[data-v-35bb4072], p[data-v-35bb4072] {
  margin: 0;
  padding: 0;
  font-style: normal;
  /* font:12px/22px"\\5B8B\\4F53",Arial,Helvetica,sans-serif; */
}
ol[data-v-35bb4072], ul[data-v-35bb4072], li[data-v-35bb4072] {
  list-style: none;
}
img[data-v-35bb4072] {
  border: 0;
  vertical-align: middle;
  pointer-events: none;
}
body[data-v-35bb4072] {
  color: #000;
  background: #FFF;
}
.clear[data-v-35bb4072] {
  clear: both;
  height: 1px;
  width: 100%;
  overflow: hidden;
  margin-top: -1px;
}
a[data-v-35bb4072] {
  color: #000;
  text-decoration: none;
  cursor: pointer;
}
a[data-v-35bb4072]:hover {
  text-decoration: none;
}
input[data-v-35bb4072], textarea[data-v-35bb4072] {
  user-select: auto;
}
input[data-v-35bb4072]:focus, input[data-v-35bb4072]:active, textarea[data-v-35bb4072]:focus, textarea[data-v-35bb4072]:active {
  outline: none;
}
.chat-aside[data-v-35bb4072] {
  position: absolute;
  top: 50px;
  right: 0;
  box-sizing: border-box;
  width: 360px !important;
  border-radius: 8px 0 0 8px;
  z-index: 9999;
  max-height: calc(100% - 50px);
}
.message-image[data-v-35bb4072] {
  width: 80px;
  height: 80px;
}body[data-v-a34fa3a9], div[data-v-a34fa3a9], ul[data-v-a34fa3a9], ol[data-v-a34fa3a9], dt[data-v-a34fa3a9], dd[data-v-a34fa3a9], li[data-v-a34fa3a9], dl[data-v-a34fa3a9], h1[data-v-a34fa3a9], h2[data-v-a34fa3a9], h3[data-v-a34fa3a9], h4[data-v-a34fa3a9], p[data-v-a34fa3a9] {
  margin: 0;
  padding: 0;
  font-style: normal;
  /* font:12px/22px"\\5B8B\\4F53",Arial,Helvetica,sans-serif; */
}
ol[data-v-a34fa3a9], ul[data-v-a34fa3a9], li[data-v-a34fa3a9] {
  list-style: none;
}
img[data-v-a34fa3a9] {
  border: 0;
  vertical-align: middle;
  pointer-events: none;
}
body[data-v-a34fa3a9] {
  color: #000;
  background: #FFF;
}
.clear[data-v-a34fa3a9] {
  clear: both;
  height: 1px;
  width: 100%;
  overflow: hidden;
  margin-top: -1px;
}
a[data-v-a34fa3a9] {
  color: #000;
  text-decoration: none;
  cursor: pointer;
}
a[data-v-a34fa3a9]:hover {
  text-decoration: none;
}
input[data-v-a34fa3a9], textarea[data-v-a34fa3a9] {
  user-select: auto;
}
input[data-v-a34fa3a9]:focus, input[data-v-a34fa3a9]:active, textarea[data-v-a34fa3a9]:focus, textarea[data-v-a34fa3a9]:active {
  outline: none;
}
.chat-aside[data-v-a34fa3a9] {
  position: absolute;
  top: 50px;
  right: 0;
  box-sizing: border-box;
  width: 360px !important;
  border-radius: 8px 0 0 8px;
  z-index: 9999;
  max-height: calc(100% - 50px);
}
a[data-v-a34fa3a9] {
  color: #679ce1;
}
.custom[data-v-a34fa3a9] {
  font-size: 14px;
}
.custom h1[data-v-a34fa3a9] {
  font-size: 14px;
  color: #000;
}
.custom h1[data-v-a34fa3a9],
.custom a[data-v-a34fa3a9],
.custom p[data-v-a34fa3a9] {
  font-size: 14px;
}
.custom .evaluate ul[data-v-a34fa3a9] {
  display: flex;
  padding: 10px 0;
}
.custom .evaluate-list[data-v-a34fa3a9] {
  display: flex;
  flex-direction: row;
}
.custom .evaluate-list-item[data-v-a34fa3a9] {
  padding: 0 2px;
}
.custom .order[data-v-a34fa3a9] {
  display: flex;
}
.custom .order main[data-v-a34fa3a9] {
  padding-left: 5px;
}
.custom .order main p[data-v-a34fa3a9] {
  font-family: PingFangSC-Regular;
  width: 145px;
  line-height: 17px;
  font-size: 14px;
  color: #999;
  letter-spacing: 0;
  margin-bottom: 6px;
  word-break: break-word;
}
.custom .order main span[data-v-a34fa3a9] {
  font-family: PingFangSC-Regular;
  line-height: 25px;
  color: #ff7201;
}
.custom .order img[data-v-a34fa3a9] {
  width: 67px;
  height: 67px;
}body[data-v-893dcf07], div[data-v-893dcf07], ul[data-v-893dcf07], ol[data-v-893dcf07], dt[data-v-893dcf07], dd[data-v-893dcf07], li[data-v-893dcf07], dl[data-v-893dcf07], h1[data-v-893dcf07], h2[data-v-893dcf07], h3[data-v-893dcf07], h4[data-v-893dcf07], p[data-v-893dcf07] {
  margin: 0;
  padding: 0;
  font-style: normal;
  /* font:12px/22px"\\5B8B\\4F53",Arial,Helvetica,sans-serif; */
}
ol[data-v-893dcf07], ul[data-v-893dcf07], li[data-v-893dcf07] {
  list-style: none;
}
img[data-v-893dcf07] {
  border: 0;
  vertical-align: middle;
  pointer-events: none;
}
body[data-v-893dcf07] {
  color: #000;
  background: #FFF;
}
.clear[data-v-893dcf07] {
  clear: both;
  height: 1px;
  width: 100%;
  overflow: hidden;
  margin-top: -1px;
}
a[data-v-893dcf07] {
  color: #000;
  text-decoration: none;
  cursor: pointer;
}
a[data-v-893dcf07]:hover {
  text-decoration: none;
}
input[data-v-893dcf07], textarea[data-v-893dcf07] {
  user-select: auto;
}
input[data-v-893dcf07]:focus, input[data-v-893dcf07]:active, textarea[data-v-893dcf07]:focus, textarea[data-v-893dcf07]:active {
  outline: none;
}
.chat-aside[data-v-893dcf07] {
  position: absolute;
  top: 50px;
  right: 0;
  box-sizing: border-box;
  width: 360px !important;
  border-radius: 8px 0 0 8px;
  z-index: 9999;
  max-height: calc(100% - 50px);
}
.message-tip[data-v-893dcf07] {
  margin: 0 auto;
  padding: 0 20px;
  color: #999;
  font-size: 12px;
  overflow-wrap: anywhere;
  display: flex;
  place-content: center center;
  align-items: center;
  text-align: center;
  margin-bottom: 10px;
}
.message-tip-highlight[data-v-893dcf07] {
  animation: highlight-893dcf07 1000ms infinite;
}
@keyframes highlight-893dcf07 {
50% {
    color: #ff9c19;
}
}
@keyframes highlight-893dcf07 {
50% {
    color: #ff9c19;
}
}.message-label[data-v-085f4d59] {
  align-self: flex-end;
  font-size: 12px;
  color: #b6b8ba;
  word-break: keep-all;
  flex: 0 0 auto;
}
.message-label.unread[data-v-085f4d59] {
  color: #679ce1 !important;
}
.finger-point[data-v-085f4d59] {
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}body[data-v-165fcf08], div[data-v-165fcf08], ul[data-v-165fcf08], ol[data-v-165fcf08], dt[data-v-165fcf08], dd[data-v-165fcf08], li[data-v-165fcf08], dl[data-v-165fcf08], h1[data-v-165fcf08], h2[data-v-165fcf08], h3[data-v-165fcf08], h4[data-v-165fcf08], p[data-v-165fcf08] {
  margin: 0;
  padding: 0;
  font-style: normal;
  /* font:12px/22px"\\5B8B\\4F53",Arial,Helvetica,sans-serif; */
}
ol[data-v-165fcf08], ul[data-v-165fcf08], li[data-v-165fcf08] {
  list-style: none;
}
img[data-v-165fcf08] {
  border: 0;
  vertical-align: middle;
  pointer-events: none;
}
body[data-v-165fcf08] {
  color: #000;
  background: #FFF;
}
.clear[data-v-165fcf08] {
  clear: both;
  height: 1px;
  width: 100%;
  overflow: hidden;
  margin-top: -1px;
}
a[data-v-165fcf08] {
  color: #000;
  text-decoration: none;
  cursor: pointer;
}
a[data-v-165fcf08]:hover {
  text-decoration: none;
}
input[data-v-165fcf08], textarea[data-v-165fcf08] {
  user-select: auto;
}
input[data-v-165fcf08]:focus, input[data-v-165fcf08]:active, textarea[data-v-165fcf08]:focus, textarea[data-v-165fcf08]:active {
  outline: none;
}
.chat-aside[data-v-165fcf08] {
  position: absolute;
  top: 50px;
  right: 0;
  box-sizing: border-box;
  width: 360px !important;
  border-radius: 8px 0 0 8px;
  z-index: 9999;
  max-height: calc(100% - 50px);
}
.message[data-v-165fcf08] {
  position: fixed;
  left: 0;
  right: 0;
  margin: 0 auto;
  max-width: 450px;
  width: fit-content;
  justify-content: center;
  align-items: center;
}
.message p[data-v-165fcf08] {
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.2);
  border-radius: 3px;
  padding: 10px 15px;
  width: fit-content;
  word-break: break-all;
}
.message-h5[data-v-165fcf08] {
  position: absolute;
  top: 20px !important;
  margin: 0 auto;
  max-width: 80%;
  width: fit-content;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  padding: 10px 15px;
}
.message-h5 span[data-v-165fcf08] {
  font-family: PingFangSC-Regular;
  font-weight: 400;
  font-size: 14px;
  letter-spacing: 0;
  text-align: center;
  word-break: break-all;
}
.success[data-v-165fcf08] {
  border: 1px solid #e4f2da;
  background: #f2f9ec;
  color: #7ebf50;
}
.error[data-v-165fcf08] {
  border: 1px solid #fde2e2;
  background: #fef0f0;
  color: #f46c6e;
}
.normal[data-v-165fcf08] {
  border: 1px solid #e9e9eb;
  background: #f4f4f5;
  color: #909398;
}
.warning[data-v-165fcf08] {
  border: 1px solid #faf0e2;
  background: #fdf8f1;
  color: #e4b877;
}.reference-content[data-v-42086ba9] {
  max-width: 272px;
  margin-top: 4px;
  margin-left: 44px;
  padding: 12px;
  font-size: 12px;
  color: #666;
  word-wrap: break-word;
  word-break: break-all;
  background-color: #fbfbfb;
  border-radius: 8px;
  line-height: 16.8px;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}
.reverse.reference-content[data-v-42086ba9] {
  margin-right: 44px;
  margin-left: auto;
}
.revoked-text[data-v-42086ba9] {
  color: #999;
}
.max-double-line[data-v-42086ba9] {
  word-break: break-all;
  overflow: hidden;
  display: -webkit-box;
  max-height: 33px;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}.message-translation-container[data-v-2d45d33b] {
  min-height: 16px;
  min-width: 80px;
  position: relative;
  transition: width 0.15s ease-out, height 0.15s ease-out;
  font-size: 14px;
}
.message-translation-container .loading[data-v-2d45d33b] {
  position: absolute;
  top: 0;
  left: 0;
  opacity: 1;
  transition: opacity 0.3s ease-out;
}
.message-translation-container .loading.loading-end[data-v-2d45d33b] {
  opacity: 0;
}
.message-translation-container .translation-content[data-v-2d45d33b] {
  opacity: 0;
}
.message-translation-container .translation-content.occur[data-v-2d45d33b] {
  animation: occur-2d45d33b 0.3s ease-out 0.45s forwards;
}
@keyframes occur-2d45d33b {
100% {
    opacity: 1;
}
}
.message-translation-container .translation-content .text-face[data-v-2d45d33b] {
  width: 20px;
  height: 20px;
}.message-translation[data-v-05f1fa32] {
  margin-top: 4px;
  margin-left: 44px;
  padding: 10px;
  background-color: #f2f7ff;
  border-radius: 10px;
  display: flex;
  flex-direction: column !important;
  transition: background-color 0.15s ease-out;
}
.message-translation.error[data-v-05f1fa32] {
  background-color: #ffdfdf;
}
.message-translation .copyright[data-v-05f1fa32] {
  display: flex;
  align-items: center;
  margin-top: 10px;
}
.message-translation .copyright .copyright-text[data-v-05f1fa32] {
  margin-left: 2px;
  font-size: 12px;
  color: #999;
}
.message-translation.reverse[data-v-05f1fa32] {
  margin-right: 44px;
  margin-left: auto;
}.message-convert-container[data-v-83761a11] {
  min-height: 20px;
  min-width: 80px;
  position: relative;
  transition: width 0.15s ease-out, height 0.15s ease-out;
  font-size: 14px;
}
.message-convert-container .loading[data-v-83761a11] {
  position: absolute;
  top: 0;
  left: 0;
  opacity: 1;
  transition: opacity 0.3s ease-out;
}
.message-convert-container .loading.loading-end[data-v-83761a11] {
  opacity: 0;
}
.message-convert-container .convert-content[data-v-83761a11] {
  opacity: 0;
}
.message-convert-container .convert-content.occur[data-v-83761a11] {
  animation: occur-83761a11 0.3s ease-out 0.45s forwards;
}
@keyframes occur-83761a11 {
100% {
    opacity: 1;
}
}.message-convert[data-v-702f862c] {
  margin-top: 4px;
  margin-left: 44px;
  padding: 10px;
  background-color: #f2f7ff;
  border-radius: 10px;
  display: flex;
  flex-direction: column !important;
  transition: background-color 0.15s ease-out;
}
.message-convert.error[data-v-702f862c] {
  background-color: #ffdfdf;
}
.message-convert.reverse[data-v-702f862c] {
  margin-right: 44px;
  margin-left: auto;
}[data-v-fff45f1e]:not(not) {
  display: flex;
  flex-direction: column;
  min-width: 0;
  box-sizing: border-box;
}
.radio-select[data-v-fff45f1e] {
  flex: 1;
  flex-direction: column;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
  justify-content: center;
}
.radio-select .radio-no-select[data-v-fff45f1e] {
  height: 20px;
  width: 20px;
  border-radius: 50%;
  border: 2px solid #ddd;
}*[data-v-1883bd8e] {
  display: flex;
  flex-direction: column;
  min-width: 0;
  box-sizing: border-box;
}
.message-bubble[data-v-1883bd8e] {
  padding: 10px 15px;
  display: flex;
  flex-direction: row;
  user-select: none;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}
.message-bubble.multiple-selected[data-v-1883bd8e] {
  background-color: #f0f0f0;
}
.message-bubble .multiple-select-radio[data-v-1883bd8e] {
  margin-right: 12px;
  flex: 0 0 auto;
}
.message-bubble .control-reverse[data-v-1883bd8e] {
  flex: 1 1 auto;
  flex-direction: row-reverse;
}
.message-bubble .message-bubble-main-content[data-v-1883bd8e] {
  display: flex;
  flex-direction: row;
}
.message-bubble .message-bubble-main-content .message-avatar[data-v-1883bd8e] {
  display: block;
  width: 36px;
  height: 36px;
  border-radius: 5px;
  flex: 0 0 auto;
}
.message-bubble .message-bubble-main-content .message-body[data-v-1883bd8e] {
  display: flex;
  flex: 0 1 auto;
  flex-direction: column;
  align-items: flex-start;
  margin: 0 8px;
}
.message-bubble .message-bubble-main-content .message-body .message-body-nick-name[data-v-1883bd8e] {
  display: block;
  margin-bottom: 4px;
  font-size: 12px;
  color: #999;
  max-width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.message-bubble .message-bubble-main-content .message-body .message-body-main[data-v-1883bd8e] {
  max-width: 100%;
  display: flex;
  flex-direction: row;
  min-width: 0;
  box-sizing: border-box;
}
.message-bubble .message-bubble-main-content .message-body .message-body-main-reverse[data-v-1883bd8e] {
  flex-direction: row-reverse;
}
.message-bubble .message-bubble-main-content .message-body .message-body-main .audio-unplay-mark[data-v-1883bd8e] {
  flex: 0 0 auto;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background-color: #f00;
  margin: 5px;
}
.message-bubble .message-bubble-main-content .message-body .message-body-main .message-body-content[data-v-1883bd8e] {
  display: flex;
  flex-direction: column;
  min-width: 0;
  box-sizing: border-box;
  padding: 12px;
  font-size: 14px;
  color: #000;
  letter-spacing: 0;
  word-wrap: break-word;
  word-break: break-all;
  position: relative;
}
.message-bubble .message-bubble-main-content .message-body .message-body-main .message-body-content .content-main[data-v-1883bd8e] {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  align-content: flex-start;
  border: 0 solid black;
  margin: 0;
  padding: 0;
  min-width: 0;
}
.message-bubble .message-bubble-main-content .message-body .message-body-main .message-body-content .content-main .message-risk-replace[data-v-1883bd8e] {
  width: 130px;
  height: 130px;
}
.message-bubble .message-bubble-main-content .message-body .message-body-main .message-body-content .content-has-risk-tips[data-v-1883bd8e] {
  font-size: 12px;
  color: #fa5151;
  font-family: PingFangSC-Regular;
  margin-top: 5px;
  border-top: 1px solid #e5c7c7;
  padding-top: 5px;
}
.message-bubble .message-bubble-main-content .message-body .message-body-main .content-in[data-v-1883bd8e] {
  background: #fbfbfb;
  border-radius: 0 10px 10px;
}
.message-bubble .message-bubble-main-content .message-body .message-body-main .content-out[data-v-1883bd8e] {
  background: #dceafd;
  border-radius: 10px 0 10px 10px;
}
.message-bubble .message-bubble-main-content .message-body .message-body-main .content-no-padding[data-v-1883bd8e] {
  padding: 0;
  background: transparent;
  border-radius: 10px;
  overflow: hidden;
}
.message-bubble .message-bubble-main-content .message-body .message-body-main .content-no-padding.content-has-risk[data-v-1883bd8e] {
  padding: 12px;
}
.message-bubble .message-bubble-main-content .message-body .message-body-main .content-has-risk[data-v-1883bd8e] {
  background: rgba(250, 81, 81, 0.16);
}
.message-bubble .message-bubble-main-content .message-body .message-body-main .blink-shadow[data-v-1883bd8e] {
  box-shadow: rgba(255, 156, 25, 0) 0 0 10px 0;
  animation: shadow-blink-1883bd8e 1s linear 3;
}
@keyframes shadow-blink-1883bd8e {
50% {
    box-shadow: rgb(255, 156, 25) 0 0 10px 0;
}
}
.message-bubble .message-bubble-main-content .message-body .message-body-main .blink-content[data-v-1883bd8e] {
  animation: reference-blink-1883bd8e 1s linear 3;
}
@keyframes reference-blink-1883bd8e {
50% {
    background-color: #ff9c19;
}
}
.message-bubble .message-bubble-main-content .message-body .message-body-main .message-label[data-v-1883bd8e] {
  align-self: flex-end;
  font-family: PingFangSC-Regular;
  font-size: 12px;
  color: #b6b8ba;
  word-break: keep-all;
  flex: 0 0 auto;
  margin: 0 8px;
}
.message-bubble .message-bubble-main-content .message-body .message-body-main .message-label.fail[data-v-1883bd8e] {
  width: 15px;
  height: 15px;
  border-radius: 15px;
  background: red;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.message-bubble .message-bubble-main-content .message-body .message-body-main .message-label.loading-circle[data-v-1883bd8e] {
  opacity: 0;
  animation: circle-loading-1883bd8e 2s linear 1s infinite;
}
@keyframes circle-loading-1883bd8e {
0% {
    transform: rotate(0);
    opacity: 1;
}
100% {
    opacity: 1;
    transform: rotate(360deg);
}
}
.message-bubble .message-bubble-main-content .message-body .message-body-main .align-self-bottom[data-v-1883bd8e] {
  align-self: flex-end;
}
.message-bubble .reverse[data-v-1883bd8e] {
  display: flex;
  flex-direction: row-reverse;
  justify-content: flex-start;
}
.message-bubble .message-bubble-extra-content[data-v-1883bd8e] {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}body[data-v-a089c0b8], div[data-v-a089c0b8], ul[data-v-a089c0b8], ol[data-v-a089c0b8], dt[data-v-a089c0b8], dd[data-v-a089c0b8], li[data-v-a089c0b8], dl[data-v-a089c0b8], h1[data-v-a089c0b8], h2[data-v-a089c0b8], h3[data-v-a089c0b8], h4[data-v-a089c0b8], p[data-v-a089c0b8] {
  margin: 0;
  padding: 0;
  font-style: normal;
  /* font:12px/22px"\\5B8B\\4F53",Arial,Helvetica,sans-serif; */
}
ol[data-v-a089c0b8], ul[data-v-a089c0b8], li[data-v-a089c0b8] {
  list-style: none;
}
img[data-v-a089c0b8] {
  border: 0;
  vertical-align: middle;
  pointer-events: none;
}
body[data-v-a089c0b8] {
  color: #000;
  background: #FFF;
}
.clear[data-v-a089c0b8] {
  clear: both;
  height: 1px;
  width: 100%;
  overflow: hidden;
  margin-top: -1px;
}
a[data-v-a089c0b8] {
  color: #000;
  text-decoration: none;
  cursor: pointer;
}
a[data-v-a089c0b8]:hover {
  text-decoration: none;
}
input[data-v-a089c0b8], textarea[data-v-a089c0b8] {
  user-select: auto;
}
input[data-v-a089c0b8]:focus, input[data-v-a089c0b8]:active, textarea[data-v-a089c0b8]:focus, textarea[data-v-a089c0b8]:active {
  outline: none;
}
.chat-aside[data-v-a089c0b8] {
  position: absolute;
  top: 50px;
  right: 0;
  box-sizing: border-box;
  width: 360px !important;
  border-radius: 8px 0 0 8px;
  z-index: 9999;
  max-height: calc(100% - 50px);
}
.message-location[data-v-a089c0b8] {
  display: flex;
  flex-direction: column;
}body[data-v-9c0f4a26], div[data-v-9c0f4a26], ul[data-v-9c0f4a26], ol[data-v-9c0f4a26], dt[data-v-9c0f4a26], dd[data-v-9c0f4a26], li[data-v-9c0f4a26], dl[data-v-9c0f4a26], h1[data-v-9c0f4a26], h2[data-v-9c0f4a26], h3[data-v-9c0f4a26], h4[data-v-9c0f4a26], p[data-v-9c0f4a26] {
  margin: 0;
  padding: 0;
  font-style: normal;
  /* font:12px/22px"\\5B8B\\4F53",Arial,Helvetica,sans-serif; */
}
ol[data-v-9c0f4a26], ul[data-v-9c0f4a26], li[data-v-9c0f4a26] {
  list-style: none;
}
img[data-v-9c0f4a26] {
  border: 0;
  vertical-align: middle;
  pointer-events: none;
}
body[data-v-9c0f4a26] {
  color: #000;
  background: #FFF;
}
.clear[data-v-9c0f4a26] {
  clear: both;
  height: 1px;
  width: 100%;
  overflow: hidden;
  margin-top: -1px;
}
a[data-v-9c0f4a26] {
  color: #000;
  text-decoration: none;
  cursor: pointer;
}
a[data-v-9c0f4a26]:hover {
  text-decoration: none;
}
input[data-v-9c0f4a26], textarea[data-v-9c0f4a26] {
  user-select: auto;
}
input[data-v-9c0f4a26]:focus, input[data-v-9c0f4a26]:active, textarea[data-v-9c0f4a26]:focus, textarea[data-v-9c0f4a26]:active {
  outline: none;
}
.chat-aside[data-v-9c0f4a26] {
  position: absolute;
  top: 50px;
  right: 0;
  box-sizing: border-box;
  width: 360px !important;
  border-radius: 8px 0 0 8px;
  z-index: 9999;
  max-height: calc(100% - 50px);
}
.message-timestamp[data-v-9c0f4a26] {
  margin: 10px auto;
  color: #999;
  font-size: 12px;
  overflow-wrap: anywhere;
  display: flex;
  align-items: center;
  text-align: center;
}body[data-v-281f1f55], div[data-v-281f1f55], ul[data-v-281f1f55], ol[data-v-281f1f55], dt[data-v-281f1f55], dd[data-v-281f1f55], li[data-v-281f1f55], dl[data-v-281f1f55], h1[data-v-281f1f55], h2[data-v-281f1f55], h3[data-v-281f1f55], h4[data-v-281f1f55], p[data-v-281f1f55] {
  margin: 0;
  padding: 0;
  font-style: normal;
  /* font:12px/22px"\\5B8B\\4F53",Arial,Helvetica,sans-serif; */
}
ol[data-v-281f1f55], ul[data-v-281f1f55], li[data-v-281f1f55] {
  list-style: none;
}
img[data-v-281f1f55] {
  border: 0;
  vertical-align: middle;
  pointer-events: none;
}
body[data-v-281f1f55] {
  color: #000;
  background: #FFF;
}
.clear[data-v-281f1f55] {
  clear: both;
  height: 1px;
  width: 100%;
  overflow: hidden;
  margin-top: -1px;
}
a[data-v-281f1f55] {
  color: #000;
  text-decoration: none;
  cursor: pointer;
}
a[data-v-281f1f55]:hover {
  text-decoration: none;
}
input[data-v-281f1f55], textarea[data-v-281f1f55] {
  user-select: auto;
}
input[data-v-281f1f55]:focus, input[data-v-281f1f55]:active, textarea[data-v-281f1f55]:focus, textarea[data-v-281f1f55]:active {
  outline: none;
}
.chat-aside[data-v-281f1f55] {
  position: absolute;
  top: 50px;
  right: 0;
  box-sizing: border-box;
  width: 360px !important;
  border-radius: 8px 0 0 8px;
  z-index: 9999;
  max-height: calc(100% - 50px);
}
.message-video[data-v-281f1f55] {
  position: relative;
  display: flex;
  justify-content: center;
  overflow: hidden;
}
.message-video-box[data-v-281f1f55] {
  max-width: min(100vw - 180px, 300px);
  font-size: 0;
}
.message-video-box video[data-v-281f1f55] {
  max-width: min(100vw - 180px, 300px);
  max-height: min(100vw - 180px, 300px);
  width: inherit;
  height: inherit;
  border-radius: 10px;
}
.message-video-box img[data-v-281f1f55] {
  max-width: min(100vw - 180px, 300px);
  max-height: min(100vw - 180px, 300px);
  width: inherit;
  height: inherit;
  border-radius: 10px;
}
.message-video-box img[src=""][data-v-281f1f55],
.message-video-box img[data-v-281f1f55]:not([src]) {
  opacity: 0;
}
.message-video-cover[data-v-281f1f55] {
  display: inline-block;
  position: relative;
}
.message-video-cover[data-v-281f1f55]::before {
  position: absolute;
  z-index: 1;
  content: "";
  width: 0;
  height: 0;
  border: 10px solid transparent;
  border-left: 15px solid #fff;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  margin: auto;
  transform: translate(5px, 0);
}
.message-video-cover video[data-v-281f1f55] {
  max-width: min(100vw - 180px, 300px);
  max-height: min(100vw - 180px, 300px);
  width: inherit;
  height: inherit;
  border-radius: 10px;
}
.dialog-video[data-v-281f1f55] {
  position: fixed;
  z-index: 12;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.dialog-video-close[data-v-281f1f55] {
  display: flex;
  justify-content: flex-end;
  background: #000;
  width: 100%;
  box-sizing: border-box;
  padding: 10px;
}
.dialog-video-box[data-v-281f1f55] {
  display: flex;
  flex: 1;
  max-height: 100%;
  padding: 6rem;
  box-sizing: border-box;
  justify-content: center;
  align-items: center;
}
.dialog-video-box video[data-v-281f1f55] {
  max-width: 100%;
  max-height: 100%;
}
.dialog-video-h5[data-v-281f1f55] {
  width: 100%;
  height: 100%;
  background: #000;
  padding: 30px 0;
}
.is-width[data-v-281f1f55] {
  width: 100%;
}
.is-height[data-v-281f1f55] {
  height: 100%;
}body[data-v-96f7d799], div[data-v-96f7d799], ul[data-v-96f7d799], ol[data-v-96f7d799], dt[data-v-96f7d799], dd[data-v-96f7d799], li[data-v-96f7d799], dl[data-v-96f7d799], h1[data-v-96f7d799], h2[data-v-96f7d799], h3[data-v-96f7d799], h4[data-v-96f7d799], p[data-v-96f7d799] {
  margin: 0;
  padding: 0;
  font-style: normal;
  /* font:12px/22px"\\5B8B\\4F53",Arial,Helvetica,sans-serif; */
}
ol[data-v-96f7d799], ul[data-v-96f7d799], li[data-v-96f7d799] {
  list-style: none;
}
img[data-v-96f7d799] {
  border: 0;
  vertical-align: middle;
  pointer-events: none;
}
body[data-v-96f7d799] {
  color: #000;
  background: #FFF;
}
.clear[data-v-96f7d799] {
  clear: both;
  height: 1px;
  width: 100%;
  overflow: hidden;
  margin-top: -1px;
}
a[data-v-96f7d799] {
  color: #000;
  text-decoration: none;
  cursor: pointer;
}
a[data-v-96f7d799]:hover {
  text-decoration: none;
}
input[data-v-96f7d799], textarea[data-v-96f7d799] {
  user-select: auto;
}
input[data-v-96f7d799]:focus, input[data-v-96f7d799]:active, textarea[data-v-96f7d799]:focus, textarea[data-v-96f7d799]:active {
  outline: none;
}
.chat-aside[data-v-96f7d799] {
  position: absolute;
  top: 50px;
  right: 0;
  box-sizing: border-box;
  width: 360px !important;
  border-radius: 8px 0 0 8px;
  z-index: 9999;
  max-height: calc(100% - 50px);
}
.dialog-item-web[data-v-96f7d799], .dialog-item-h5[data-v-96f7d799] {
  background: #fff;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
  padding: 12px 0;
}
.dialog-item-web .dialog-item-list[data-v-96f7d799], .dialog-item-h5 .dialog-item-list[data-v-96f7d799] {
  display: flex;
  align-items: baseline;
  white-space: nowrap;
  flex-wrap: wrap;
  max-width: 280px;
}
.dialog-item-web .dialog-item-list .list-item[data-v-96f7d799], .dialog-item-h5 .dialog-item-list .list-item[data-v-96f7d799] {
  padding: 4px 12px;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.dialog-item-web .dialog-item-list .list-item .list-item-text[data-v-96f7d799], .dialog-item-h5 .dialog-item-list .list-item .list-item-text[data-v-96f7d799] {
  padding-left: 4px;
  font-size: 12px;
  line-height: 17px;
  color: #000;
}
.dialog-item-h5[data-v-96f7d799] {
  padding: 0;
}
.dialog-item-h5 .dialog-item-list[data-v-96f7d799] {
  margin: 10px;
  white-space: nowrap;
  flex-wrap: wrap;
  max-width: 280px;
}
.dialog-item-h5 .dialog-item-list .list-item[data-v-96f7d799] {
  padding: 0 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #4f4f4f;
}
.dialog-item-h5 .dialog-item-list .list-item .list-item-text[data-v-96f7d799] {
  padding-left: 0;
  color: #000;
}body[data-v-f40107e2], div[data-v-f40107e2], ul[data-v-f40107e2], ol[data-v-f40107e2], dt[data-v-f40107e2], dd[data-v-f40107e2], li[data-v-f40107e2], dl[data-v-f40107e2], h1[data-v-f40107e2], h2[data-v-f40107e2], h3[data-v-f40107e2], h4[data-v-f40107e2], p[data-v-f40107e2] {
  margin: 0;
  padding: 0;
  font-style: normal;
  /* font:12px/22px"\\5B8B\\4F53",Arial,Helvetica,sans-serif; */
}
ol[data-v-f40107e2], ul[data-v-f40107e2], li[data-v-f40107e2] {
  list-style: none;
}
img[data-v-f40107e2] {
  border: 0;
  vertical-align: middle;
  pointer-events: none;
}
body[data-v-f40107e2] {
  color: #000;
  background: #FFF;
}
.clear[data-v-f40107e2] {
  clear: both;
  height: 1px;
  width: 100%;
  overflow: hidden;
  margin-top: -1px;
}
a[data-v-f40107e2] {
  color: #000;
  text-decoration: none;
  cursor: pointer;
}
a[data-v-f40107e2]:hover {
  text-decoration: none;
}
input[data-v-f40107e2], textarea[data-v-f40107e2] {
  user-select: auto;
}
input[data-v-f40107e2]:focus, input[data-v-f40107e2]:active, textarea[data-v-f40107e2]:focus, textarea[data-v-f40107e2]:active {
  outline: none;
}
.chat-aside[data-v-f40107e2] {
  position: absolute;
  top: 50px;
  right: 0;
  box-sizing: border-box;
  width: 360px !important;
  border-radius: 8px 0 0 8px;
  z-index: 9999;
  max-height: calc(100% - 50px);
}
.revoke[data-v-f40107e2] {
  display: flex;
  flex-direction: row;
  justify-content: center;
  color: #999;
  font-size: 12px;
  margin-bottom: 10px;
  white-space: pre;
}
.revoke .edit[data-v-f40107e2] {
  padding: 0 5px;
  color: #006eff;
}.message-plugin-tip[data-v-8fd6ea50] {
  color: #999;
  font-size: 12px;
  overflow-wrap: anywhere;
  display: flex;
  place-content: center center;
  align-items: center;
  text-align: center;
  margin: 0 10px 10px;
}
.message-tip-highlight[data-v-8fd6ea50] {
  animation: highlight-8fd6ea50 1000ms infinite;
}
@keyframes highlight-8fd6ea50 {
50% {
    color: #ff9c19;
}
}
@keyframes highlight-8fd6ea50 {
50% {
    color: #ff9c19;
}
}
[data-v-8fd6ea50] .message-bubble-room .message-bubble-main-content .message-body .message-body-main .message-body-content.content-in,[data-v-8fd6ea50] .message-bubble-room .message-bubble-main-content .message-body .message-body-main .message-body-content.content-out {
  background-color: transparent;
  border-radius: 0;
  padding: 0;
}@keyframes blink-text-c8d1a674 {
50% {
    color: #ff9c19;
}
}
.blink-text[data-v-c8d1a674] {
  animation: blinkText 1s linear 3;
}.call[data-v-96c8717e] {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.call-C2C[data-v-96c8717e] {
  cursor: pointer;
}
.call-GROUP[data-v-96c8717e] {
  cursor: default;
}
.call-content[data-v-96c8717e] {
  padding-left: 5px;
}
.call .icon[data-v-96c8717e] {
  width: 20px;
  height: 20px;
}
.call-reverse[data-v-96c8717e] {
  flex-direction: row-reverse;
}
.call-reverse .icon-reverse[data-v-96c8717e] {
  transform: rotate(180deg);
}
.call-reverse .call-content[data-v-96c8717e] {
  padding-right: 5px;
  padding-left: 0;
}/* stylelint-disable-next-line no-empty-source */.room-default[data-v-3183e690] {
  padding: 12px;
  font-size: 14px;
}
.room-default-uni[data-v-3183e690] {
  padding: 0;
}
.room-default-in[data-v-3183e690] {
  background: #fbfbfb;
  border-radius: 0 10px;
}
.room-default-out[data-v-3183e690] {
  background: #dceafd;
  border-radius: 10px 0 10px 10px;
}/* stylelint-disable-next-line no-empty-source */.scroll-button[data-v-650a7132] {
  position: absolute;
  bottom: 10px;
  right: 10px;
  width: 92px;
  height: 28px;
  background: #fff;
  border: 1px solid #e0e0e0;
  box-shadow: 0 4px 12px -5px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  border-radius: 3px;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}
.scroll-button-text[data-v-650a7132] {
  font-family: PingFangSC-Regular, system-ui;
  font-size: 10px;
  color: #147aff;
  margin-left: 3px;
}.fetch-more-block[data-v-a245d20e] {
  color: #999;
}[data-v-767e085a]:not(not) {
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  min-width: 0;
}
.read-receipt-panel[data-v-767e085a], .read-receipt-panel-mobile[data-v-767e085a] {
  background-color: #fff;
  box-shadow: 0 7px 20px rgba(0, 0, 0, 0.1);
  width: 368px;
  height: 510px;
  padding: 30px 20px;
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  overflow: hidden;
}
.read-receipt-panel .header[data-v-767e085a], .read-receipt-panel-mobile .header[data-v-767e085a] {
  flex-direction: row;
  justify-content: center;
  align-items: center;
  position: relative;
}
.read-receipt-panel .header .header-text[data-v-767e085a], .read-receipt-panel-mobile .header .header-text[data-v-767e085a] {
  font-weight: bold;
  font-size: 16px;
  line-height: 30px;
  color: #333;
}
.read-receipt-panel .header .header-close-icon[data-v-767e085a], .read-receipt-panel-mobile .header .header-close-icon[data-v-767e085a] {
  position: absolute;
  right: 0;
  margin-right: 10px;
}
.read-receipt-panel .read-status-counter-container[data-v-767e085a], .read-receipt-panel-mobile .read-status-counter-container[data-v-767e085a] {
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  min-height: 59px;
  margin: 20px 40px 17.5px;
}
.read-receipt-panel .read-status-counter-container .read-status-counter[data-v-767e085a], .read-receipt-panel-mobile .read-status-counter-container .read-status-counter[data-v-767e085a] {
  justify-content: flex-start;
  align-items: center;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}
.read-receipt-panel .read-status-counter-container .read-status-counter .status-text[data-v-767e085a], .read-receipt-panel-mobile .read-status-counter-container .read-status-counter .status-text[data-v-767e085a] {
  font-size: 14px;
  line-height: 20px;
}
.read-receipt-panel .read-status-counter-container .read-status-counter .status-count[data-v-767e085a], .read-receipt-panel-mobile .read-status-counter-container .read-status-counter .status-count[data-v-767e085a] {
  margin-top: 2px;
  font-size: 30px;
  font-weight: bolder;
  line-height: 37px;
}
.read-receipt-panel .read-status-counter-container .read-status-counter.active[data-v-767e085a], .read-receipt-panel-mobile .read-status-counter-container .read-status-counter.active[data-v-767e085a] {
  color: #679ce1;
}
.read-receipt-panel .read-status-member-list[data-v-767e085a], .read-receipt-panel-mobile .read-status-member-list[data-v-767e085a] {
  flex: 1 1 auto;
  overflow: hidden auto;
  padding: 20px 0 0;
  border-top: 0.5px solid #e8e8e9;
  font-size: 14px;
}
.read-receipt-panel .read-status-member-list .empty-list-tip[data-v-767e085a], .read-receipt-panel-mobile .read-status-member-list .empty-list-tip[data-v-767e085a] {
  align-self: center;
  color: #b3b3b3;
}
.read-receipt-panel .read-status-member-list .read-status-member-container[data-v-767e085a], .read-receipt-panel-mobile .read-status-member-list .read-status-member-container[data-v-767e085a] {
  flex-direction: row;
  align-items: center;
}
.read-receipt-panel .read-status-member-list .read-status-member-container .read-status-avatar[data-v-767e085a], .read-receipt-panel-mobile .read-status-member-list .read-status-member-container .read-status-avatar[data-v-767e085a] {
  flex: 0 0 auto;
}
.read-receipt-panel .read-status-member-list .read-status-member-container .username[data-v-767e085a], .read-receipt-panel-mobile .read-status-member-list .read-status-member-container .username[data-v-767e085a] {
  margin-left: 8px;
  line-height: 20px;
  flex: 0 1 auto;
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
  white-space: nowrap;
}
.read-receipt-panel .read-status-member-list .read-status-member-container + .read-status-member-container[data-v-767e085a], .read-receipt-panel-mobile .read-status-member-list .read-status-member-container + .read-status-member-container[data-v-767e085a] {
  margin-top: 20px;
}
.read-receipt-panel .read-status-member-list .fetch-more-container[data-v-767e085a], .read-receipt-panel-mobile .read-status-member-list .fetch-more-container[data-v-767e085a] {
  justify-content: center;
  align-items: center;
  margin-top: auto;
}
.read-receipt-panel-mobile[data-v-767e085a] {
  box-shadow: none;
  width: 100%;
  height: 100%;
  border-radius: 0;
  animation: slide-in-from-right-767e085a 0.3s ease-out;
  transition: transform 0.2s ease-out;
}
@keyframes slide-in-from-right-767e085a {
from {
    transform: translateX(100%);
}
}
.read-receipt-panel-uni[data-v-767e085a] {
  width: 100vw;
  height: 100vh;
}
.read-receipt-panel-close-mobile[data-v-767e085a] {
  transform: translateX(100%);
}body[data-v-9ac9ce3c], div[data-v-9ac9ce3c], ul[data-v-9ac9ce3c], ol[data-v-9ac9ce3c], dt[data-v-9ac9ce3c], dd[data-v-9ac9ce3c], li[data-v-9ac9ce3c], dl[data-v-9ac9ce3c], h1[data-v-9ac9ce3c], h2[data-v-9ac9ce3c], h3[data-v-9ac9ce3c], h4[data-v-9ac9ce3c], p[data-v-9ac9ce3c] {
  margin: 0;
  padding: 0;
  font-style: normal;
  /* font:12px/22px"\\5B8B\\4F53",Arial,Helvetica,sans-serif; */
}
ol[data-v-9ac9ce3c], ul[data-v-9ac9ce3c], li[data-v-9ac9ce3c] {
  list-style: none;
}
img[data-v-9ac9ce3c] {
  border: 0;
  vertical-align: middle;
  pointer-events: none;
}
body[data-v-9ac9ce3c] {
  color: #000;
  background: #FFF;
}
.clear[data-v-9ac9ce3c] {
  clear: both;
  height: 1px;
  width: 100%;
  overflow: hidden;
  margin-top: -1px;
}
a[data-v-9ac9ce3c] {
  color: #000;
  text-decoration: none;
  cursor: pointer;
}
a[data-v-9ac9ce3c]:hover {
  text-decoration: none;
}
input[data-v-9ac9ce3c], textarea[data-v-9ac9ce3c] {
  user-select: auto;
}
input[data-v-9ac9ce3c]:focus, input[data-v-9ac9ce3c]:active, textarea[data-v-9ac9ce3c]:focus, textarea[data-v-9ac9ce3c]:active {
  outline: none;
}
.chat-aside[data-v-9ac9ce3c] {
  position: absolute;
  top: 50px;
  right: 0;
  box-sizing: border-box;
  width: 360px !important;
  border-radius: 8px 0 0 8px;
  z-index: 9999;
  max-height: calc(100% - 50px);
}
.dialog[data-v-9ac9ce3c] {
  background: rgba(0, 0, 0, 0.3);
}
.dialog-main[data-v-9ac9ce3c] {
  background: #FFF;
}
.dialog-main-header[data-v-9ac9ce3c] {
  font-weight: 500;
  color: #333;
}
.dialog-main-title[data-v-9ac9ce3c] {
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: #333;
}
.dialog-main-back[data-v-9ac9ce3c] {
  background: none;
}
.dialog-main-content[data-v-9ac9ce3c] {
  font-weight: 400;
  color: #333;
}
.btn[data-v-9ac9ce3c] {
  font-weight: 400;
  color: #FFF;
  letter-spacing: 0;
}
.btn-cancel[data-v-9ac9ce3c] {
  border: 1px solid #ddd;
  color: #666;
}
.btn-default[data-v-9ac9ce3c] {
  background: #006EFF;
  border: 1px solid #006EFF;
}
.dialog[data-v-9ac9ce3c] {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  z-index: 6;
  display: flex;
  justify-content: center;
  align-items: center;
}
.dialog-main[data-v-9ac9ce3c] {
  min-width: 368px;
  border-radius: 10px;
  padding: 20px 30px;
}
.dialog-main-header[data-v-9ac9ce3c] {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 16px;
  line-height: 30px;
}
.dialog-main-title[data-v-9ac9ce3c] {
  font-size: 16px;
  line-height: 30px;
}
.dialog-main-content[data-v-9ac9ce3c] {
  font-size: 14px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
}
.dialog-main-footer[data-v-9ac9ce3c] {
  display: flex;
  justify-content: flex-end;
}
.btn[data-v-9ac9ce3c] {
  padding: 8px 20px;
  margin: 0 6px;
  border-radius: 4px;
  border: none;
  font-size: 14px;
  text-align: center;
  line-height: 20px;
}
.btn[data-v-9ac9ce3c]:disabled {
  opacity: 0.3;
}
.btn[data-v-9ac9ce3c]:last-child {
  margin-right: 0;
}
.dialog-h5[data-v-9ac9ce3c] {
  height: 100%;
  top: 0;
  align-items: inherit;
}
.dialog-h5 .dialog-main[data-v-9ac9ce3c] {
  border-radius: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  width: 100%;
  min-height: 80px;
  min-width: 120px;
}
.dialog-h5 .dialog-main-content[data-v-9ac9ce3c] {
  flex: 1;
  min-width: 0;
  min-height: 0;
  overflow: hidden;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 0;
}
.dialog-h5 .dialog-main-content-uniapp[data-v-9ac9ce3c] {
  padding: 40px 0;
}
.dialog-h5 .dialog-main-footer[data-v-9ac9ce3c] {
  border-top: 1px solid #DDD;
}
.dialog-h5 .dialog-main-footer .btn[data-v-9ac9ce3c] {
  flex: 1;
  margin: 0;
  background: none;
  border-right: 1px solid #DDD;
}
.dialog-h5 .dialog-main-footer .btn-default[data-v-9ac9ce3c] {
  color: #FF584C;
  border: none;
}
.center[data-v-9ac9ce3c] {
  align-items: center;
  padding: 20px;
  box-sizing: border-box;
}.image-item {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
.image-preview {
  max-width: 100%;
  max-height: 100%;
  transition: transform 0.1s ease 0s;
  pointer-events: auto;
}body[data-v-7614e4b7], div[data-v-7614e4b7], ul[data-v-7614e4b7], ol[data-v-7614e4b7], dt[data-v-7614e4b7], dd[data-v-7614e4b7], li[data-v-7614e4b7], dl[data-v-7614e4b7], h1[data-v-7614e4b7], h2[data-v-7614e4b7], h3[data-v-7614e4b7], h4[data-v-7614e4b7], p[data-v-7614e4b7] {
  margin: 0;
  padding: 0;
  font-style: normal;
  /* font:12px/22px"\\5B8B\\4F53",Arial,Helvetica,sans-serif; */
}
ol[data-v-7614e4b7], ul[data-v-7614e4b7], li[data-v-7614e4b7] {
  list-style: none;
}
img[data-v-7614e4b7] {
  border: 0;
  vertical-align: middle;
  pointer-events: none;
}
body[data-v-7614e4b7] {
  color: #000;
  background: #FFF;
}
.clear[data-v-7614e4b7] {
  clear: both;
  height: 1px;
  width: 100%;
  overflow: hidden;
  margin-top: -1px;
}
a[data-v-7614e4b7] {
  color: #000;
  text-decoration: none;
  cursor: pointer;
}
a[data-v-7614e4b7]:hover {
  text-decoration: none;
}
input[data-v-7614e4b7], textarea[data-v-7614e4b7] {
  user-select: auto;
}
input[data-v-7614e4b7]:focus, input[data-v-7614e4b7]:active, textarea[data-v-7614e4b7]:focus, textarea[data-v-7614e4b7]:active {
  outline: none;
}
.chat-aside[data-v-7614e4b7] {
  position: absolute;
  top: 50px;
  right: 0;
  box-sizing: border-box;
  width: 360px !important;
  border-radius: 8px 0 0 8px;
  z-index: 9999;
  max-height: calc(100% - 50px);
}
.actions-bar[data-v-7614e4b7] {
  display: flex;
  justify-content: space-around;
  align-items: center;
  position: absolute;
  bottom: 5%;
  padding: 12px;
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.8);
}
.actions-bar-h5[data-v-7614e4b7] {
  padding: 6px;
}
.actions-bar .icon[data-v-7614e4b7] {
  position: static;
  font-size: 24px;
  cursor: pointer;
  width: 27px;
  height: 27px;
  margin: 5px;
}
.actions-bar .icon-zoom-in[data-v-7614e4b7],
.actions-bar .icon-zoom-out[data-v-7614e4b7],
.actions-bar .icon-refresh-left[data-v-7614e4b7],
.actions-bar .icon-refresh-right[data-v-7614e4b7] {
  cursor: pointer;
  user-select: none;
  padding: 5px;
}
.image-previewer[data-v-7614e4b7] {
  position: fixed;
  z-index: 101;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  top: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  user-select: none;
}
.image-previewer .image-wrapper[data-v-7614e4b7] {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}
.image-previewer .image-list[data-v-7614e4b7] {
  position: absolute;
  height: 100%;
  left: 0;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: row;
  place-content: center center;
}
.image-previewer .image-list .image-item[data-v-7614e4b7] {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
.image-previewer .image-preview[data-v-7614e4b7] {
  max-width: 100%;
  max-height: 100%;
  transition: transform 0.1s ease 0s;
  pointer-events: auto;
}
.image-previewer .image-button[data-v-7614e4b7] {
  display: flex;
  flex-direction: column;
  min-width: auto;
  justify-content: center;
  align-items: center;
  position: absolute;
  cursor: pointer;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  top: calc(50% - 20px);
  background: rgba(255, 255, 255, 0.8);
}
.image-previewer .image-button-left[data-v-7614e4b7] {
  left: 10px;
}
.image-previewer .image-button-right[data-v-7614e4b7] {
  right: 10px;
  transform: rotate(180deg);
}
.image-previewer .image-button .icon[data-v-7614e4b7] {
  position: absolute;
  bottom: 0;
  top: 0;
  left: 0;
  right: 0;
  margin: auto;
  line-height: 40px;
  display: flex;
  flex-direction: column;
  min-width: auto;
  justify-content: center;
  align-items: center;
}
.image-previewer .icon-close[data-v-7614e4b7] {
  position: absolute;
  cursor: pointer;
  border-radius: 50%;
  top: 3%;
  right: 3%;
  padding: 10px;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
}
.image-previewer .icon-close[data-v-7614e4b7]::before, .image-previewer .icon-close[data-v-7614e4b7]::after {
  background-color: #444;
}
.image-previewer-h5[data-v-7614e4b7] {
  width: 100%;
  height: 100%;
  background: #000;
  display: flex;
  flex-direction: column;
}
.save[data-v-7614e4b7] {
  cursor: pointer;
  display: flex;
  justify-content: space-around;
  align-items: center;
  position: absolute;
  bottom: 5%;
  right: 5%;
  padding: 12px;
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.8);
}
.image-counter[data-v-7614e4b7] {
  background: rgba(20, 18, 20, 0.53);
  padding: 3px 5px;
  margin: 5px;
  border-radius: 3px;
  color: #fff;
}.progress-message[data-v-8e1c1325] {
  overflow: hidden;
}
.progress-message .progress-container[data-v-8e1c1325] {
  position: absolute;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  padding: 0 15%;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
}
.progress-message .progress-container .progress-common[data-v-8e1c1325], .progress-message .progress-container .progress[data-v-8e1c1325] {
  appearance: none;
  width: 100%;
  height: 0.5rem;
}
.progress-message .progress-container .progress[data-v-8e1c1325] {
  color: #006eff;
  border-radius: 0.25rem;
  background: #fff;
}
.progress-message .progress-container .progress[data-v-8e1c1325]::-webkit-progress-value {
  background-color: #006eff;
  border-radius: 0.25rem;
}
.progress-message .progress-container .progress[data-v-8e1c1325]::-webkit-progress-bar {
  border-radius: 0.25rem;
  background: #fff;
}
.progress-message .progress-container .progress[data-v-8e1c1325]::-moz-progress-bar {
  color: #006eff;
  background: #006eff;
  border-radius: 0.25rem;
}body[data-v-82829db6], div[data-v-82829db6], ul[data-v-82829db6], ol[data-v-82829db6], dt[data-v-82829db6], dd[data-v-82829db6], li[data-v-82829db6], dl[data-v-82829db6], h1[data-v-82829db6], h2[data-v-82829db6], h3[data-v-82829db6], h4[data-v-82829db6], p[data-v-82829db6] {
  margin: 0;
  padding: 0;
  font-style: normal;
  /* font:12px/22px"\\5B8B\\4F53",Arial,Helvetica,sans-serif; */
}
ol[data-v-82829db6], ul[data-v-82829db6], li[data-v-82829db6] {
  list-style: none;
}
img[data-v-82829db6] {
  border: 0;
  vertical-align: middle;
  pointer-events: none;
}
body[data-v-82829db6] {
  color: #000;
  background: #FFF;
}
.clear[data-v-82829db6] {
  clear: both;
  height: 1px;
  width: 100%;
  overflow: hidden;
  margin-top: -1px;
}
a[data-v-82829db6] {
  color: #000;
  text-decoration: none;
  cursor: pointer;
}
a[data-v-82829db6]:hover {
  text-decoration: none;
}
input[data-v-82829db6], textarea[data-v-82829db6] {
  user-select: auto;
}
input[data-v-82829db6]:focus, input[data-v-82829db6]:active, textarea[data-v-82829db6]:focus, textarea[data-v-82829db6]:active {
  outline: none;
}
.chat-aside[data-v-82829db6] {
  position: absolute;
  top: 50px;
  right: 0;
  box-sizing: border-box;
  width: 360px !important;
  border-radius: 8px 0 0 8px;
  z-index: 9999;
  max-height: calc(100% - 50px);
}
.tui-chat .tui-message-list .message-more[data-v-82829db6] {
  color: #999;
  cursor: pointer;
}
.tui-chat .image-dialog[data-v-82829db6] {
  background: rgba(0, 0, 0, 0.3);
}
.tui-chat .image-dialog header[data-v-82829db6] {
  background: rgba(0, 0, 0, 0.49);
}
.tui-chat-h5 .tui-chat-header[data-v-82829db6] {
  background: #FFF;
}
.tui-chat-h5 .tui-chat-footer[data-v-82829db6] {
  background: #FFF;
}
.tui-chat-h5 .tui-chat-footer .input input[data-v-82829db6] {
  background: #F4F5F9;
}
.tui-chat[data-v-82829db6] {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.tui-chat-main[data-v-82829db6] {
  min-height: 0;
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  position: relative;
}
.tui-chat-main .tui-chat-safe-tips[data-v-82829db6] {
  padding: 12px 20px;
  background-color: rgba(255, 149, 0, 0.1);
  color: #ff8c39;
  line-height: 18px;
  font-family: PingFangSC-Regular;
  font-style: normal;
  font-weight: 400;
  text-align: justify;
  font-size: 12px;
}
.tui-chat-main .tui-chat-safe-tips a[data-v-82829db6] {
  color: #006eff;
  float: right;
}
.tui-chat-main .tui-chat-application-tips[data-v-82829db6] {
  text-align: center;
  width: 100%;
  background: #fce4d3;
  padding: 2px;
  font-size: 12px;
}
.tui-chat-main .application-tips-btn[data-v-82829db6] {
  color: #006eff;
  padding-left: 10px;
}
.tui-chat-main .tui-message-list[data-v-82829db6] {
  flex: 1;
  height: 100%;
  overflow: hidden auto;
}
.tui-chat-main .tui-message-list .message-more[data-v-82829db6] {
  font-size: 14px;
  padding: 5px;
  text-align: center;
}
.tui-chat-main .tui-message-list .to-bottom-tip[data-v-82829db6] {
  position: sticky;
  bottom: 10px;
  left: 100%;
  margin-right: 15px;
  width: 92px;
  height: 28px;
  padding: 0 5px;
  background: #fff;
  border: 1px solid #e0e0e0;
  box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.06);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  border-radius: 3px;
  cursor: pointer;
}
.tui-chat-main .tui-message-list .to-bottom-tip-text[data-v-82829db6] {
  font-family: PingFangSC-Regular;
  font-weight: 400;
  font-size: 10px;
  color: #147aff;
  letter-spacing: 0;
  text-align: center;
  padding-left: 3px;
}
.tui-chat-main .tui-message-list .message-li[data-v-82829db6] {
  display: flex;
  flex-direction: column;
}
.tui-chat-main .tui-message-list .message-li[data-v-82829db6]:first-child {
  margin-top: 5px;
}
.tui-chat-main .tui-message-list .message-li .message-item[data-v-82829db6] {
  display: flex;
  position: relative;
  flex-direction: column;
}
.tui-chat-main .tui-message-list .message-li .message-item .message-tool[data-v-82829db6] {
  z-index: 5;
  position: absolute;
  cursor: pointer;
  transform: translateY(-100%);
}
.tui-chat-main .tui-message-list .message-li .message-item .message-tool-out[data-v-82829db6] {
  right: 30px;
  left: auto;
}
.tui-chat-main .tui-message-list .message-li .message-item .message-tool-in[data-v-82829db6] {
  left: 30px;
  right: auto;
}
.tui-chat-main .tui-message-list .message-li .message-item .message-tool-bottom[data-v-82829db6] {
  z-index: 5;
  bottom: 0;
  transform: translateY(100%);
}
.tui-chat-main .tui-message-list .message-li .message-label[data-v-82829db6] {
  max-width: 50px;
}
.tui-chat-main .tui-message-list .right[data-v-82829db6] {
  flex-direction: row-reverse;
  justify-content: flex-start;
}
.tui-chat .disabled[data-v-82829db6] {
  position: relative;
}
.tui-chat .disabled[data-v-82829db6]::before {
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
}
.image-dialog[data-v-82829db6] {
  position: fixed;
  z-index: 5;
  width: 100vw;
  height: calc(100vh - 63px);
  top: 63px;
  left: 0;
}
.image-dialog header[data-v-82829db6] {
  display: flex;
  justify-content: flex-end;
  width: 100%;
  box-sizing: border-box;
  padding: 10px;
}
[data-v-82829db6]::-webkit-scrollbar {
  width: 6px;
  height: 140px;
  background-color: transparent;
}
[data-v-82829db6]::-webkit-scrollbar-track {
  border-radius: 10px;
}
[data-v-82829db6]::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-color: #9a999c;
}
.tui-chat-h5[data-v-82829db6] {
  flex: 1;
  position: static;
}
.tui-chat-h5 .tui-chat-main .tui-message-list[data-v-82829db6] {
  height: 100%;
}
.tui-chat-h5 .tui-chat-main .message-more[data-v-82829db6] {
  color: #999;
  cursor: pointer;
  font-size: 14px;
}
[data-v-82829db6]:not(not) {
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  min-width: 0;
}
.row-reverse {
  flex-direction: row-reverse;
}
body[data-v-704cb70e], div[data-v-704cb70e], ul[data-v-704cb70e], ol[data-v-704cb70e], dt[data-v-704cb70e], dd[data-v-704cb70e], li[data-v-704cb70e], dl[data-v-704cb70e], h1[data-v-704cb70e], h2[data-v-704cb70e], h3[data-v-704cb70e], h4[data-v-704cb70e], p[data-v-704cb70e] {
  margin: 0;
  padding: 0;
  font-style: normal;
  /* font:12px/22px"\\5B8B\\4F53",Arial,Helvetica,sans-serif; */
}
ol[data-v-704cb70e], ul[data-v-704cb70e], li[data-v-704cb70e] {
  list-style: none;
}
img[data-v-704cb70e] {
  border: 0;
  vertical-align: middle;
  pointer-events: none;
}
body[data-v-704cb70e] {
  color: #000;
  background: #FFF;
}
.clear[data-v-704cb70e] {
  clear: both;
  height: 1px;
  width: 100%;
  overflow: hidden;
  margin-top: -1px;
}
a[data-v-704cb70e] {
  color: #000;
  text-decoration: none;
  cursor: pointer;
}
a[data-v-704cb70e]:hover {
  text-decoration: none;
}
input[data-v-704cb70e], textarea[data-v-704cb70e] {
  user-select: auto;
}
input[data-v-704cb70e]:focus, input[data-v-704cb70e]:active, textarea[data-v-704cb70e]:focus, textarea[data-v-704cb70e]:active {
  outline: none;
}
.chat-aside[data-v-704cb70e] {
  position: absolute;
  top: 50px;
  right: 0;
  box-sizing: border-box;
  width: 360px !important;
  border-radius: 8px 0 0 8px;
  z-index: 9999;
  max-height: calc(100% - 50px);
}
.message-input-editor-container[data-v-704cb70e] {
  box-sizing: border-box;
  height: 100%;
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 3px 10px 10px;
}
.message-input-editor-area[data-v-704cb70e] {
  box-sizing: border-box;
  height: 100%;
  flex: 1;
  display: flex;
  overflow-y: auto;
  border: none;
  outline: none;
}
.message-input-editor-mute[data-v-704cb70e] {
  box-sizing: border-box;
  flex: 1;
  display: flex;
  color: #999;
  font-size: 14px;
  justify-content: center;
  align-items: center;
}
.message-input-editor-container-h5[data-v-704cb70e] {
  box-sizing: border-box;
  flex: 1;
  height: auto;
  background: #f4f5f9;
  border-radius: 9.4px;
  padding: 8px 0 8px 10px;
  font-size: 16px !important;
  max-height: 86px;
  margin-right: 7px;
  overflow: hidden;
}
.message-input-editor-container-h5 .message-input-editor-area[data-v-704cb70e] {
  overflow: auto;
  user-select: text;
  hyphens: auto;
  word-wrap: break-word;
  word-break: break-word;
  flex-wrap: wrap;
}
.message-input-editor-container-h5 .message-input-editor-area .custom-image[data-v-704cb70e],
.message-input-editor-container-h5 .message-input-editor-area .custom-image-emoji[data-v-704cb70e] {
  display: inline;
}/* stylelint-disable-next-line selector-class-pattern */
.ProseMirror {
  min-height: 100%;
  height: fit-content;
  flex: 1;
  font-size: 14px;
  word-wrap: break-word;
  word-break: break-all;
  white-space: pre-wrap;
  user-select: text;
  /* stylelint-disable-next-line selector-class-pattern */
}
.ProseMirror div,
.ProseMirror ul,
.ProseMirror ol,
.ProseMirror dt,
.ProseMirror dd,
.ProseMirror li,
.ProseMirror dl,
.ProseMirror h1,
.ProseMirror h2,
.ProseMirror h3,
.ProseMirror h4,
.ProseMirror p {
  margin: 0;
  padding: 0;
  font-style: normal;
}
.ProseMirror p * {
  vertical-align: bottom;
}
.ProseMirror-focused {
  border: none;
  outline: none;
}
.ProseMirror img {
  /* stylelint-disable-next-line selector-class-pattern */
}
.ProseMirror img.ProseMirror-selectednode {
  outline: 2px solid #68cef8;
}
.ProseMirror .custom-image-normal {
  max-height: 120px;
  max-width: 200px;
}
.ProseMirror .custom-image-file {
  height: 50px;
  width: 160px;
  border: 1px solid #e8e8e9;
  border-radius: 5px;
}
.ProseMirror .custom-image-emoji {
  height: 20px;
  width: 20px;
}
.ProseMirror .custom-image-image {
  display: none;
}
.ProseMirror .ProseMirror-selectednode {
  outline: 2px solid #68cef8;
  cursor: none;
}
.ProseMirror p,
.ProseMirror [contenteditable] {
  user-select: text;
}
.ProseMirror p.is-editor-empty:first-child::before {
  color: #adb5bd;
  content: attr(data-placeholder);
  float: left;
  height: 0;
  pointer-events: none;
}body[data-v-bd66b7e1], div[data-v-bd66b7e1], ul[data-v-bd66b7e1], ol[data-v-bd66b7e1], dt[data-v-bd66b7e1], dd[data-v-bd66b7e1], li[data-v-bd66b7e1], dl[data-v-bd66b7e1], h1[data-v-bd66b7e1], h2[data-v-bd66b7e1], h3[data-v-bd66b7e1], h4[data-v-bd66b7e1], p[data-v-bd66b7e1] {
  margin: 0;
  padding: 0;
  font-style: normal;
  /* font:12px/22px"\\5B8B\\4F53",Arial,Helvetica,sans-serif; */
}
ol[data-v-bd66b7e1], ul[data-v-bd66b7e1], li[data-v-bd66b7e1] {
  list-style: none;
}
img[data-v-bd66b7e1] {
  border: 0;
  vertical-align: middle;
  pointer-events: none;
}
body[data-v-bd66b7e1] {
  color: #000;
  background: #FFF;
}
.clear[data-v-bd66b7e1] {
  clear: both;
  height: 1px;
  width: 100%;
  overflow: hidden;
  margin-top: -1px;
}
a[data-v-bd66b7e1] {
  color: #000;
  text-decoration: none;
  cursor: pointer;
}
a[data-v-bd66b7e1]:hover {
  text-decoration: none;
}
input[data-v-bd66b7e1], textarea[data-v-bd66b7e1] {
  user-select: auto;
}
input[data-v-bd66b7e1]:focus, input[data-v-bd66b7e1]:active, textarea[data-v-bd66b7e1]:focus, textarea[data-v-bd66b7e1]:active {
  outline: none;
}
.chat-aside[data-v-bd66b7e1] {
  position: absolute;
  top: 50px;
  right: 0;
  box-sizing: border-box;
  width: 360px !important;
  border-radius: 8px 0 0 8px;
  z-index: 9999;
  max-height: calc(100% - 50px);
}
.bottom-popup-h5[data-v-bd66b7e1] {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: stretch;
  margin: 0;
  padding: 0;
  z-index: 10;
  border-radius: 5px 5px 0 0;
}
.bottom-popup-h5-main[data-v-bd66b7e1] {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: stretch;
  height: fit-content;
  background-color: #fff;
}
.bottom-popup-h5-main .header[data-v-bd66b7e1] {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 20px;
  font-size: 16px;
}
.bottom-popup-h5-main .header .header-close[data-v-bd66b7e1] {
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: #006eff;
  font-size: 18px;
}
.bottom-popup-h5-main .footer[data-v-bd66b7e1] {
  padding: 20px;
}
.bottom-popup-h5-main .footer .footer-submit[data-v-bd66b7e1] {
  color: #fff;
  padding: 12px 0;
  width: 100%;
  background: #006eff;
  text-align: center;
  border-radius: 5px;
  font-size: 16px;
}
.bottom-popup-uni[data-v-bd66b7e1] {
  padding-bottom: var(--window-bottom);
  width: 100vw;
  height: 100vh;
}
.bottom-popup-modal[data-v-bd66b7e1] {
  background: rgba(0, 0, 0, 0.5);
}body[data-v-15902586], div[data-v-15902586], ul[data-v-15902586], ol[data-v-15902586], dt[data-v-15902586], dd[data-v-15902586], li[data-v-15902586], dl[data-v-15902586], h1[data-v-15902586], h2[data-v-15902586], h3[data-v-15902586], h4[data-v-15902586], p[data-v-15902586] {
  margin: 0;
  padding: 0;
  font-style: normal;
  /* font:12px/22px"\\5B8B\\4F53",Arial,Helvetica,sans-serif; */
}
ol[data-v-15902586], ul[data-v-15902586], li[data-v-15902586] {
  list-style: none;
}
img[data-v-15902586] {
  border: 0;
  vertical-align: middle;
  pointer-events: none;
}
body[data-v-15902586] {
  color: #000;
  background: #FFF;
}
.clear[data-v-15902586] {
  clear: both;
  height: 1px;
  width: 100%;
  overflow: hidden;
  margin-top: -1px;
}
a[data-v-15902586] {
  color: #000;
  text-decoration: none;
  cursor: pointer;
}
a[data-v-15902586]:hover {
  text-decoration: none;
}
input[data-v-15902586], textarea[data-v-15902586] {
  user-select: auto;
}
input[data-v-15902586]:focus, input[data-v-15902586]:active, textarea[data-v-15902586]:focus, textarea[data-v-15902586]:active {
  outline: none;
}
.chat-aside[data-v-15902586] {
  position: absolute;
  top: 50px;
  right: 0;
  box-sizing: border-box;
  width: 360px !important;
  border-radius: 8px 0 0 8px;
  z-index: 9999;
  max-height: calc(100% - 50px);
}
.message-input-at[data-v-15902586] {
  position: fixed;
  max-width: 15rem;
  max-height: 10rem;
  overflow: hidden auto;
  background: #fff;
  box-shadow: 0 0.06rem 0.63rem 0 rgba(2, 16, 43, 0.15);
  border-radius: 0.13rem;
}
.member-list-box-header[data-v-15902586] {
  height: 2.5rem;
  padding-top: 5px;
  cursor: pointer;
}
.member-list-box-header[data-v-15902586]:hover {
  background: rgba(0, 110, 255, 0.1);
}
.member-list-box span[data-v-15902586] {
  font-family: PingFangSC-Regular;
  font-weight: 400;
  font-size: 12px;
  color: #000;
  letter-spacing: 0;
  padding: 5px;
}
.member-list-box-body[data-v-15902586] {
  height: 30px;
  cursor: pointer;
  display: flex;
  align-items: center;
}
.member-list-box-body .selected[data-v-15902586], .member-list-box-body[data-v-15902586]:hover {
  background: rgba(0, 110, 255, 0.1);
}
.member-list-box-body-name[data-v-15902586] {
  overflow: hidden;
  white-space: nowrap;
  word-wrap: break-word;
  word-break: break-all;
  text-overflow: ellipsis;
}
.member-list-box-body-avatar[data-v-15902586] {
  width: 20px;
  height: 20px;
  padding-left: 10px;
}
.member-list-box .selected[data-v-15902586] {
  background: rgba(0, 110, 255, 0.1);
}
.message-input-at-h5 .member-list[data-v-15902586] {
  height: auto;
  max-height: 500px;
  width: 100%;
  max-width: 100%;
  background: white;
  border-radius: 12px 12px 0 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.message-input-at-h5 .member-list-title[data-v-15902586] {
  height: fit-content;
  width: calc(100% - 30px);
  text-align: center;
  vertical-align: middle;
  padding: 15px;
}
.message-input-at-h5 .member-list-title .title[data-v-15902586] {
  vertical-align: middle;
  display: inline-block;
  font-size: 16px;
}
.message-input-at-h5 .member-list-title .close[data-v-15902586] {
  vertical-align: middle;
  position: absolute;
  right: 10px;
  display: inline-block;
}
.message-input-at-h5 .member-list-box[data-v-15902586] {
  flex: 1;
  overflow-y: scroll;
}
.message-input-at-h5 .member-list-box-body[data-v-15902586] {
  padding: 10px;
}
.message-input-at-h5 .member-list-box-body img[data-v-15902586] {
  width: 26px;
  height: 26px;
}
.message-input-at-h5 .member-list-box-body span[data-v-15902586] {
  font-size: 14px;
}body[data-v-6684de24], div[data-v-6684de24], ul[data-v-6684de24], ol[data-v-6684de24], dt[data-v-6684de24], dd[data-v-6684de24], li[data-v-6684de24], dl[data-v-6684de24], h1[data-v-6684de24], h2[data-v-6684de24], h3[data-v-6684de24], h4[data-v-6684de24], p[data-v-6684de24] {
  margin: 0;
  padding: 0;
  font-style: normal;
  /* font:12px/22px"\\5B8B\\4F53",Arial,Helvetica,sans-serif; */
}
ol[data-v-6684de24], ul[data-v-6684de24], li[data-v-6684de24] {
  list-style: none;
}
img[data-v-6684de24] {
  border: 0;
  vertical-align: middle;
  pointer-events: none;
}
body[data-v-6684de24] {
  color: #000;
  background: #FFF;
}
.clear[data-v-6684de24] {
  clear: both;
  height: 1px;
  width: 100%;
  overflow: hidden;
  margin-top: -1px;
}
a[data-v-6684de24] {
  color: #000;
  text-decoration: none;
  cursor: pointer;
}
a[data-v-6684de24]:hover {
  text-decoration: none;
}
input[data-v-6684de24], textarea[data-v-6684de24] {
  user-select: auto;
}
input[data-v-6684de24]:focus, input[data-v-6684de24]:active, textarea[data-v-6684de24]:focus, textarea[data-v-6684de24]:active {
  outline: none;
}
.chat-aside[data-v-6684de24] {
  position: absolute;
  top: 50px;
  right: 0;
  box-sizing: border-box;
  width: 360px !important;
  border-radius: 8px 0 0 8px;
  z-index: 9999;
  max-height: calc(100% - 50px);
}
.message-input-button[data-v-6684de24] {
  position: absolute;
  bottom: 20px;
  right: 20px;
}
.message-input-button-h5[data-v-6684de24] {
  position: static;
}
.message-input-button-cont[data-v-6684de24] {
  padding: 8px 20px;
  border-radius: 4px;
  border: none;
  font-size: 14px;
  text-align: center;
  line-height: 20px;
  font-weight: 400;
  background: #006eff;
  color: #fff;
  letter-spacing: 0;
  cursor: pointer;
}
.message-input-button-hover[data-v-6684de24] {
  display: none;
  justify-content: center;
  align-items: center;
  position: absolute;
  right: 120%;
  word-break: keep-all;
  height: 30px;
  white-space: nowrap;
  top: 0;
  bottom: 0;
  margin: auto 0;
  padding: 5px 10px;
  border-radius: 3px;
  background: #000;
  color: #fff;
  opacity: 0.3;
}
.message-input-button-hover[data-v-6684de24]::before {
  content: "";
  position: absolute;
  width: 0;
  height: 0;
  right: -20px;
  border: 10px solid transparent;
  border-left: 10px solid #000;
}
.message-input-button:hover .message-input-button-hover[data-v-6684de24] {
  display: flex;
}.input-quote-container-h5[data-v-0495652d], .input-quote-container-uni[data-v-0495652d], .input-quote-container[data-v-0495652d] {
  margin: 5px 100px 5px 8px;
  display: flex;
  flex: 0 1 auto;
}
.input-quote-container-h5 .input-quote-content[data-v-0495652d], .input-quote-container-uni .input-quote-content[data-v-0495652d], .input-quote-container .input-quote-content[data-v-0495652d] {
  display: flex;
  flex: 0 1 auto;
  background-color: #fafafa;
  border-radius: 8px;
  padding: 12px;
  font-size: 12px;
  align-items: center;
  line-height: 16px;
  max-width: 100%;
  box-sizing: border-box;
  min-width: 0;
}
.input-quote-container-h5 .input-quote-content .max-one-line[data-v-0495652d], .input-quote-container-uni .input-quote-content .max-one-line[data-v-0495652d], .input-quote-container .input-quote-content .max-one-line[data-v-0495652d] {
  flex: 0 1 auto;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.input-quote-container-h5 .input-quote-close-icon[data-v-0495652d], .input-quote-container-uni .input-quote-close-icon[data-v-0495652d], .input-quote-container .input-quote-close-icon[data-v-0495652d] {
  margin-left: 5px;
  padding: 5px;
}
.input-quote-container-uni[data-v-0495652d] {
  margin: 5px 60px 0 30px;
}
.input-quote-container-h5[data-v-0495652d] {
  margin: 5px 0 0;
}body[data-v-bf6a3af8], div[data-v-bf6a3af8], ul[data-v-bf6a3af8], ol[data-v-bf6a3af8], dt[data-v-bf6a3af8], dd[data-v-bf6a3af8], li[data-v-bf6a3af8], dl[data-v-bf6a3af8], h1[data-v-bf6a3af8], h2[data-v-bf6a3af8], h3[data-v-bf6a3af8], h4[data-v-bf6a3af8], p[data-v-bf6a3af8] {
  margin: 0;
  padding: 0;
  font-style: normal;
  /* font:12px/22px"\\5B8B\\4F53",Arial,Helvetica,sans-serif; */
}
ol[data-v-bf6a3af8], ul[data-v-bf6a3af8], li[data-v-bf6a3af8] {
  list-style: none;
}
img[data-v-bf6a3af8] {
  border: 0;
  vertical-align: middle;
  pointer-events: none;
}
body[data-v-bf6a3af8] {
  color: #000;
  background: #FFF;
}
.clear[data-v-bf6a3af8] {
  clear: both;
  height: 1px;
  width: 100%;
  overflow: hidden;
  margin-top: -1px;
}
a[data-v-bf6a3af8] {
  color: #000;
  text-decoration: none;
  cursor: pointer;
}
a[data-v-bf6a3af8]:hover {
  text-decoration: none;
}
input[data-v-bf6a3af8], textarea[data-v-bf6a3af8] {
  user-select: auto;
}
input[data-v-bf6a3af8]:focus, input[data-v-bf6a3af8]:active, textarea[data-v-bf6a3af8]:focus, textarea[data-v-bf6a3af8]:active {
  outline: none;
}
.chat-aside[data-v-bf6a3af8] {
  position: absolute;
  top: 50px;
  right: 0;
  box-sizing: border-box;
  width: 360px !important;
  border-radius: 8px 0 0 8px;
  z-index: 9999;
  max-height: calc(100% - 50px);
}
.message-input-wrapper[data-v-bf6a3af8] {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}
.message-input-container[data-v-bf6a3af8] {
  box-sizing: border-box;
  flex: 1;
  display: flex;
  flex-direction: column;
  border: none;
  overflow: hidden;
}
.message-input-container-h5[data-v-bf6a3af8] {
  display: flex;
  flex-flow: row nowrap;
  align-items: flex-end;
}[data-v-d2fa341d]:not(not) {
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  min-width: 0;
}
.mulitple-select-panel[data-v-d2fa341d] {
  height: 196px;
  border-top: 1px solid #ebebeb;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  background-color: #EBF0F6;
}
.mulitple-select-panel-mobile[data-v-d2fa341d] {
  height: 64px;
  padding-bottom: 15px;
  flex-direction: row;
  align-items: flex-end;
}
.forward-button[data-v-d2fa341d] {
  justify-content: center;
  align-items: center;
}
.forward-button-text[data-v-d2fa341d] {
  margin-top: 8px;
  font-size: 12px;
}
.forward-button-text-mobile[data-v-d2fa341d] {
  margin-top: 2px;
}
.forward-button .cancel-button-icon[data-v-d2fa341d] {
  transform: rotate(45deg);
}body[data-v-6b1d6fb4], div[data-v-6b1d6fb4], ul[data-v-6b1d6fb4], ol[data-v-6b1d6fb4], dt[data-v-6b1d6fb4], dd[data-v-6b1d6fb4], li[data-v-6b1d6fb4], dl[data-v-6b1d6fb4], h1[data-v-6b1d6fb4], h2[data-v-6b1d6fb4], h3[data-v-6b1d6fb4], h4[data-v-6b1d6fb4], p[data-v-6b1d6fb4] {
  margin: 0;
  padding: 0;
  font-style: normal;
  /* font:12px/22px"\\5B8B\\4F53",Arial,Helvetica,sans-serif; */
}
ol[data-v-6b1d6fb4], ul[data-v-6b1d6fb4], li[data-v-6b1d6fb4] {
  list-style: none;
}
img[data-v-6b1d6fb4] {
  border: 0;
  vertical-align: middle;
  pointer-events: none;
}
body[data-v-6b1d6fb4] {
  color: #000;
  background: #FFF;
}
.clear[data-v-6b1d6fb4] {
  clear: both;
  height: 1px;
  width: 100%;
  overflow: hidden;
  margin-top: -1px;
}
a[data-v-6b1d6fb4] {
  color: #000;
  text-decoration: none;
  cursor: pointer;
}
a[data-v-6b1d6fb4]:hover {
  text-decoration: none;
}
input[data-v-6b1d6fb4], textarea[data-v-6b1d6fb4] {
  user-select: auto;
}
input[data-v-6b1d6fb4]:focus, input[data-v-6b1d6fb4]:active, textarea[data-v-6b1d6fb4]:focus, textarea[data-v-6b1d6fb4]:active {
  outline: none;
}
.chat-aside[data-v-6b1d6fb4] {
  position: absolute;
  top: 50px;
  right: 0;
  box-sizing: border-box;
  width: 360px !important;
  border-radius: 8px 0 0 8px;
  z-index: 9999;
  max-height: calc(100% - 50px);
}
.main[data-v-6b1d6fb4] {
  background: #FFF;
  border: 1px solid #E0E0E0;
  box-shadow: 0 -4px 12px 0 rgba(0, 0, 0, 0.06);
}
.main .left[data-v-6b1d6fb4] {
  border-right: 1px solid #E8E8E9;
}
.main .transfer-header[data-v-6b1d6fb4] {
  font-weight: 500;
  color: #000;
  letter-spacing: 0;
}
.main .transfer-header input[data-v-6b1d6fb4] {
  background: #FFF;
  border: 1px solid #DEE0E3;
  font-weight: 500;
  color: #8F959E;
  letter-spacing: 0;
}
.main .transfer-list .transfer-text[data-v-6b1d6fb4] {
  font-weight: 500;
  color: #8F959E;
  letter-spacing: 0;
}
.main .transfer-list-item .disabled[data-v-6b1d6fb4] {
  background: #eee;
}
.btn[data-v-6b1d6fb4] {
  background: #3370FF;
  border: 0 solid #2F80ED;
  font-weight: 400;
  color: #FFF;
}
.btn-cancel[data-v-6b1d6fb4] {
  background: #FFF;
  border: 1px solid #DDD;
  color: #828282;
}
.btn-no[data-v-6b1d6fb4] {
  background: #e8e8e9;
  border: 1px solid #DDD;
  font-weight: 400;
  color: #FFF;
}
.transfer-h5-header[data-v-6b1d6fb4] {
  background: #FFF;
}
.transfer-h5-header .title[data-v-6b1d6fb4] {
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: #000;
  letter-spacing: 0;
}
.avatar[data-v-6b1d6fb4] {
  width: 36px;
  height: 36px;
  border-radius: 5px;
  font-size: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.main[data-v-6b1d6fb4] {
  box-sizing: border-box;
  width: 620px;
  height: 394px;
  display: flex;
  border-radius: 8px;
  padding: 20px 0;
}
.main .transfer-header[data-v-6b1d6fb4] {
  font-size: 14px;
  line-height: 14px;
  padding-bottom: 20px;
}
.main .transfer-header input[data-v-6b1d6fb4] {
  box-sizing: border-box;
  width: 100%;
  border-radius: 30px;
  font-size: 10px;
  line-height: 14px;
  padding: 9px 12px;
}
.main .transfer-list[data-v-6b1d6fb4] {
  flex: 1;
  display: flex;
  flex-direction: column;
}
.main .transfer-list .transfer-text[data-v-6b1d6fb4] {
  font-size: 10px;
  line-height: 14px;
}
.main .transfer-list-item[data-v-6b1d6fb4] {
  padding: 6px 0;
  display: flex;
  align-items: center;
  font-size: 14px;
  text-align: left;
}
.main .transfer-list-item-content[data-v-6b1d6fb4] {
  flex: 1;
  display: flex;
  align-items: center;
}
.main .transfer-list-item .avatar[data-v-6b1d6fb4] {
  margin: 0 5px 0 8px;
  border-radius: 50%;
}
.main .transfer-list-item .name[data-v-6b1d6fb4] {
  width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1;
}
.main .right[data-v-6b1d6fb4] {
  padding: 0 20px;
  flex: 1;
  display: flex;
  flex-direction: column;
}
.main .right .transfer-right-footer[data-v-6b1d6fb4] {
  align-self: flex-end;
}
.main .right .transfer-right-footer .btn-cancel[data-v-6b1d6fb4] {
  margin-right: 12px;
}
.main .right .transfer-list[data-v-6b1d6fb4] {
  padding-right: 20px;
  overflow-y: auto;
}
.main .left[data-v-6b1d6fb4] {
  flex: 1;
  overflow-y: hidden;
  display: flex;
  flex-direction: column;
}
.main .left .transfer-header[data-v-6b1d6fb4] {
  padding: 0 20px;
}
.main .left .transfer-left-main[data-v-6b1d6fb4] {
  flex: 1;
  overflow-y: auto;
  padding: 0 13px;
}
.btn[data-v-6b1d6fb4] {
  padding: 4px 28px;
  font-size: 12px;
  line-height: 24px;
  border-radius: 4px;
}
.btn-no[data-v-6b1d6fb4] {
  padding: 4px 28px;
  font-size: 12px;
  line-height: 24px;
  border-radius: 4px;
}
.space-between[data-v-6b1d6fb4] {
  justify-content: space-between;
}
.select-all[data-v-6b1d6fb4] {
  padding-left: 8px;
  font-size: 14px;
}
.more[data-v-6b1d6fb4] {
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  font-size: 14px;
}
.transfer-h5[data-v-6b1d6fb4] {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.transfer-h5-wechat[data-v-6b1d6fb4] {
  width: 100vw;
  height: 100vh;
}
.transfer-h5-header[data-v-6b1d6fb4] {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 18px;
  padding: 16px 18px;
}
.transfer-h5-header .space[data-v-6b1d6fb4], .transfer-h5-header .icon[data-v-6b1d6fb4] {
  width: 18px;
  height: 18px;
}
.transfer-h5 .main[data-v-6b1d6fb4] {
  flex: 1;
  flex-direction: column;
  width: auto;
  height: auto;
  border-radius: 0;
  border: none;
  box-shadow: none;
  max-height: calc(100% - 50px);
  padding: 0;
}
.transfer-h5 .main .avatar[data-v-6b1d6fb4] {
  border-radius: 5px;
}
.transfer-h5 .main .left[data-v-6b1d6fb4] {
  padding: 0;
  flex: 1;
  border: none;
  display: flex;
  flex-direction: column;
}
.transfer-h5 .main .left .transfer-header[data-v-6b1d6fb4] {
  position: sticky;
  top: 0;
  padding: 0 18px;
}
.transfer-h5 .main .left .transfer-header input[data-v-6b1d6fb4] {
  border-radius: 5px;
  font-size: 14px;
}
.transfer-h5 .main .left-uniapp-input[data-v-6b1d6fb4] {
  height: 36px;
}
.transfer-h5 .main .right[data-v-6b1d6fb4] {
  flex: 0;
  flex-direction: row;
  align-items: center;
  box-shadow: inset 0 1px 0 0 #EEE;
  padding: 8px 18px;
}
.transfer-h5 .main .right .transfer-list[data-v-6b1d6fb4] {
  flex-direction: row;
  width: 0;
}
.transfer-h5 .main .right .transfer-list-item-content[data-v-6b1d6fb4] {
  flex: none;
}
.transfer-h5 .main .right .transfer-right-footer[data-v-6b1d6fb4] {
  padding: 6px 0;
  display: flex;
  align-items: center;
}
.transfer-h5 .main .right .transfer-right-footer .btn[data-v-6b1d6fb4] {
  font-size: 14px;
}
.icon-unselected[data-v-6b1d6fb4] {
  width: 18px;
  height: 18px;
  background: #FFF;
  border: 1px solid #DDD;
  border-radius: 11px;
  box-sizing: border-box;
}body[data-v-c2998cf0], div[data-v-c2998cf0], ul[data-v-c2998cf0], ol[data-v-c2998cf0], dt[data-v-c2998cf0], dd[data-v-c2998cf0], li[data-v-c2998cf0], dl[data-v-c2998cf0], h1[data-v-c2998cf0], h2[data-v-c2998cf0], h3[data-v-c2998cf0], h4[data-v-c2998cf0], p[data-v-c2998cf0] {
  margin: 0;
  padding: 0;
  font-style: normal;
  /* font:12px/22px"\\5B8B\\4F53",Arial,Helvetica,sans-serif; */
}
ol[data-v-c2998cf0], ul[data-v-c2998cf0], li[data-v-c2998cf0] {
  list-style: none;
}
img[data-v-c2998cf0] {
  border: 0;
  vertical-align: middle;
  pointer-events: none;
}
body[data-v-c2998cf0] {
  color: #000;
  background: #FFF;
}
.clear[data-v-c2998cf0] {
  clear: both;
  height: 1px;
  width: 100%;
  overflow: hidden;
  margin-top: -1px;
}
a[data-v-c2998cf0] {
  color: #000;
  text-decoration: none;
  cursor: pointer;
}
a[data-v-c2998cf0]:hover {
  text-decoration: none;
}
input[data-v-c2998cf0], textarea[data-v-c2998cf0] {
  user-select: auto;
}
input[data-v-c2998cf0]:focus, input[data-v-c2998cf0]:active, textarea[data-v-c2998cf0]:focus, textarea[data-v-c2998cf0]:active {
  outline: none;
}
.chat-aside[data-v-c2998cf0] {
  position: absolute;
  top: 50px;
  right: 0;
  box-sizing: border-box;
  width: 360px !important;
  border-radius: 8px 0 0 8px;
  z-index: 9999;
  max-height: calc(100% - 50px);
}
.emoji-picker[data-v-c2998cf0] {
  width: 405px;
  height: 300px;
  display: flex;
  flex-direction: column;
}
.emoji-picker-list[data-v-c2998cf0] {
  flex: 1;
  display: flex;
  flex-wrap: wrap;
  overflow-y: auto;
  margin: 2px;
}
.emoji-picker-list[data-v-c2998cf0]::-webkit-scrollbar {
  display: none;
}
.emoji-picker-list-item[data-v-c2998cf0] {
  cursor: pointer;
  padding: 5px;
}
.emoji-picker-list-item .emoji[data-v-c2998cf0] {
  width: 30px;
  height: 30px;
}
.emoji-picker-list-item .emoji-big[data-v-c2998cf0] {
  width: 70px;
  height: 70px;
}
.emoji-picker-tab[data-v-c2998cf0] {
  display: flex;
  align-items: center;
}
.emoji-picker-tab-item[data-v-c2998cf0] {
  padding: 0 10px;
  cursor: pointer;
}
.emoji-picker-tab-item .icon[data-v-c2998cf0] {
  margin: 10px;
  width: 20px;
  height: 20px;
}
.emoji-picker-tab-item .icon-big[data-v-c2998cf0] {
  margin: 2px 0;
  width: 30px;
  height: 30px;
}
.emoji-picker-h5[data-v-c2998cf0] {
  width: 100%;
}
.emoji-picker-h5-list[data-v-c2998cf0] {
  justify-content: space-between;
}
.emoji-picker-h5-list[data-v-c2998cf0]::after {
  content: "";
  display: block;
  flex: 1 1 auto;
}
.emoji-picker-h5 .send-btn[data-v-c2998cf0] {
  width: 50px;
  height: 30px;
  background-color: #55C06A;
  position: absolute;
  right: 10px;
  font-size: 16px;
  color: #fff;
  text-align: center;
  line-height: 30px;
}body[data-v-c89673ca], div[data-v-c89673ca], ul[data-v-c89673ca], ol[data-v-c89673ca], dt[data-v-c89673ca], dd[data-v-c89673ca], li[data-v-c89673ca], dl[data-v-c89673ca], h1[data-v-c89673ca], h2[data-v-c89673ca], h3[data-v-c89673ca], h4[data-v-c89673ca], p[data-v-c89673ca] {
  margin: 0;
  padding: 0;
  font-style: normal;
  /* font:12px/22px"\\5B8B\\4F53",Arial,Helvetica,sans-serif; */
}
ol[data-v-c89673ca], ul[data-v-c89673ca], li[data-v-c89673ca] {
  list-style: none;
}
img[data-v-c89673ca] {
  border: 0;
  vertical-align: middle;
  pointer-events: none;
}
body[data-v-c89673ca] {
  color: #000;
  background: #FFF;
}
.clear[data-v-c89673ca] {
  clear: both;
  height: 1px;
  width: 100%;
  overflow: hidden;
  margin-top: -1px;
}
a[data-v-c89673ca] {
  color: #000;
  text-decoration: none;
  cursor: pointer;
}
a[data-v-c89673ca]:hover {
  text-decoration: none;
}
input[data-v-c89673ca], textarea[data-v-c89673ca] {
  user-select: auto;
}
input[data-v-c89673ca]:focus, input[data-v-c89673ca]:active, textarea[data-v-c89673ca]:focus, textarea[data-v-c89673ca]:active {
  outline: none;
}
.chat-aside[data-v-c89673ca] {
  position: absolute;
  top: 50px;
  right: 0;
  box-sizing: border-box;
  width: 360px !important;
  border-radius: 8px 0 0 8px;
  z-index: 9999;
  max-height: calc(100% - 50px);
}
.toolbar-item-container-dialog[data-v-c89673ca] {
  background: #fff;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
.toolbar-item-container[data-v-c89673ca] {
  position: relative;
}
.toolbar-item-container-icon[data-v-c89673ca] {
  padding: 8px;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}
.toolbar-item-container-dialog[data-v-c89673ca] {
  z-index: 5;
  position: absolute;
  background: #fff;
  box-shadow: 0 2px 4px -3px rgba(32, 77, 141, 0.03), 0 6px 10px 1px rgba(32, 77, 141, 0.06), 0 3px 14px 2px rgba(32, 77, 141, 0.05);
  width: fit-content;
  height: fit-content;
  bottom: 35px;
}
.toolbar-item-container-dialog-dark[data-v-c89673ca] {
  background: #22262E;
  box-shadow: 0 8px 40px 0 rgba(23, 25, 31, 0.6), 0 4px 12px 0 rgba(23, 25, 31, 0.8);
}
.toolbar-item-container-h5-dialog[data-v-c89673ca] {
  position: static !important;
  width: 100%;
  box-shadow: none;
}
.toolbar-item-container-uni[data-v-c89673ca] {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: static;
}
.toolbar-item-container-uni-icon[data-v-c89673ca] {
  background: #fff;
  border-radius: 15px;
  width: 60px;
  height: 60px;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
.toolbar-item-container-uni-title[data-v-c89673ca] {
  font-size: 14px;
  color: #8F959D;
}
.toolbar-item-container-uni-dialog[data-v-c89673ca] {
  position: absolute !important;
  background: transparent;
  left: -10px;
  bottom: -5px;
}
.toolbar-item-container-uni-dialog .toolbar-bottom-popup[data-v-c89673ca] {
  position: sticky;
}body[data-v-eddc124e], div[data-v-eddc124e], ul[data-v-eddc124e], ol[data-v-eddc124e], dt[data-v-eddc124e], dd[data-v-eddc124e], li[data-v-eddc124e], dl[data-v-eddc124e], h1[data-v-eddc124e], h2[data-v-eddc124e], h3[data-v-eddc124e], h4[data-v-eddc124e], p[data-v-eddc124e] {
  margin: 0;
  padding: 0;
  font-style: normal;
  /* font:12px/22px"\\5B8B\\4F53",Arial,Helvetica,sans-serif; */
}
ol[data-v-eddc124e], ul[data-v-eddc124e], li[data-v-eddc124e] {
  list-style: none;
}
img[data-v-eddc124e] {
  border: 0;
  vertical-align: middle;
  pointer-events: none;
}
body[data-v-eddc124e] {
  color: #000;
  background: #FFF;
}
.clear[data-v-eddc124e] {
  clear: both;
  height: 1px;
  width: 100%;
  overflow: hidden;
  margin-top: -1px;
}
a[data-v-eddc124e] {
  color: #000;
  text-decoration: none;
  cursor: pointer;
}
a[data-v-eddc124e]:hover {
  text-decoration: none;
}
input[data-v-eddc124e], textarea[data-v-eddc124e] {
  user-select: auto;
}
input[data-v-eddc124e]:focus, input[data-v-eddc124e]:active, textarea[data-v-eddc124e]:focus, textarea[data-v-eddc124e]:active {
  outline: none;
}
.chat-aside[data-v-eddc124e] {
  position: absolute;
  top: 50px;
  right: 0;
  box-sizing: border-box;
  width: 360px !important;
  border-radius: 8px 0 0 8px;
  z-index: 9999;
  max-height: calc(100% - 50px);
}
.emoji-picker[data-v-eddc124e] {
  width: 405px;
  height: 300px;
  display: flex;
  flex-direction: column;
}
.emoji-picker-list[data-v-eddc124e] {
  flex: 1;
  display: flex;
  flex-wrap: wrap;
  overflow-y: auto;
  margin: 2px;
}
.emoji-picker-list[data-v-eddc124e]::-webkit-scrollbar {
  display: none;
}
.emoji-picker-list-item[data-v-eddc124e] {
  cursor: pointer;
  padding: 5px;
}
.emoji-picker-list-item .emoji[data-v-eddc124e] {
  width: 30px;
  height: 30px;
}
.emoji-picker-list-item .emoji-big[data-v-eddc124e] {
  width: 70px;
  height: 70px;
}
.emoji-picker-tab[data-v-eddc124e] {
  display: flex;
  align-items: center;
}
.emoji-picker-tab-item[data-v-eddc124e] {
  padding: 0 10px;
  cursor: pointer;
}
.emoji-picker-tab-item .icon[data-v-eddc124e] {
  margin: 10px;
  width: 20px;
  height: 20px;
}
.emoji-picker-tab-item .icon-big[data-v-eddc124e] {
  margin: 2px 0;
  width: 30px;
  height: 30px;
}
.emoji-picker-h5[data-v-eddc124e] {
  width: 100%;
}
.emoji-picker-h5-list[data-v-eddc124e] {
  justify-content: space-between;
}
.emoji-picker-h5-list[data-v-eddc124e]::after {
  content: "";
  display: block;
  flex: 1 1 auto;
}
.emoji-picker-h5 .send-btn[data-v-eddc124e] {
  width: 50px;
  height: 30px;
  background-color: #55C06A;
  position: absolute;
  right: 10px;
  font-size: 16px;
  color: #fff;
  text-align: center;
  line-height: 30px;
}body[data-v-f41fc267], div[data-v-f41fc267], ul[data-v-f41fc267], ol[data-v-f41fc267], dt[data-v-f41fc267], dd[data-v-f41fc267], li[data-v-f41fc267], dl[data-v-f41fc267], h1[data-v-f41fc267], h2[data-v-f41fc267], h3[data-v-f41fc267], h4[data-v-f41fc267], p[data-v-f41fc267] {
  margin: 0;
  padding: 0;
  font-style: normal;
  /* font:12px/22px"\\5B8B\\4F53",Arial,Helvetica,sans-serif; */
}
ol[data-v-f41fc267], ul[data-v-f41fc267], li[data-v-f41fc267] {
  list-style: none;
}
img[data-v-f41fc267] {
  border: 0;
  vertical-align: middle;
  pointer-events: none;
}
body[data-v-f41fc267] {
  color: #000;
  background: #FFF;
}
.clear[data-v-f41fc267] {
  clear: both;
  height: 1px;
  width: 100%;
  overflow: hidden;
  margin-top: -1px;
}
a[data-v-f41fc267] {
  color: #000;
  text-decoration: none;
  cursor: pointer;
}
a[data-v-f41fc267]:hover {
  text-decoration: none;
}
input[data-v-f41fc267], textarea[data-v-f41fc267] {
  user-select: auto;
}
input[data-v-f41fc267]:focus, input[data-v-f41fc267]:active, textarea[data-v-f41fc267]:focus, textarea[data-v-f41fc267]:active {
  outline: none;
}
.chat-aside[data-v-f41fc267] {
  position: absolute;
  top: 50px;
  right: 0;
  box-sizing: border-box;
  width: 360px !important;
  border-radius: 8px 0 0 8px;
  z-index: 9999;
  max-height: calc(100% - 50px);
}body[data-v-efb1fc25], div[data-v-efb1fc25], ul[data-v-efb1fc25], ol[data-v-efb1fc25], dt[data-v-efb1fc25], dd[data-v-efb1fc25], li[data-v-efb1fc25], dl[data-v-efb1fc25], h1[data-v-efb1fc25], h2[data-v-efb1fc25], h3[data-v-efb1fc25], h4[data-v-efb1fc25], p[data-v-efb1fc25] {
  margin: 0;
  padding: 0;
  font-style: normal;
  /* font:12px/22px"\\5B8B\\4F53",Arial,Helvetica,sans-serif; */
}
ol[data-v-efb1fc25], ul[data-v-efb1fc25], li[data-v-efb1fc25] {
  list-style: none;
}
img[data-v-efb1fc25] {
  border: 0;
  vertical-align: middle;
  pointer-events: none;
}
body[data-v-efb1fc25] {
  color: #000;
  background: #FFF;
}
.clear[data-v-efb1fc25] {
  clear: both;
  height: 1px;
  width: 100%;
  overflow: hidden;
  margin-top: -1px;
}
a[data-v-efb1fc25] {
  color: #000;
  text-decoration: none;
  cursor: pointer;
}
a[data-v-efb1fc25]:hover {
  text-decoration: none;
}
input[data-v-efb1fc25], textarea[data-v-efb1fc25] {
  user-select: auto;
}
input[data-v-efb1fc25]:focus, input[data-v-efb1fc25]:active, textarea[data-v-efb1fc25]:focus, textarea[data-v-efb1fc25]:active {
  outline: none;
}
.chat-aside[data-v-efb1fc25] {
  position: absolute;
  top: 50px;
  right: 0;
  box-sizing: border-box;
  width: 360px !important;
  border-radius: 8px 0 0 8px;
  z-index: 9999;
  max-height: calc(100% - 50px);
}body[data-v-69ead8fb], div[data-v-69ead8fb], ul[data-v-69ead8fb], ol[data-v-69ead8fb], dt[data-v-69ead8fb], dd[data-v-69ead8fb], li[data-v-69ead8fb], dl[data-v-69ead8fb], h1[data-v-69ead8fb], h2[data-v-69ead8fb], h3[data-v-69ead8fb], h4[data-v-69ead8fb], p[data-v-69ead8fb] {
  margin: 0;
  padding: 0;
  font-style: normal;
  /* font:12px/22px"\\5B8B\\4F53",Arial,Helvetica,sans-serif; */
}
ol[data-v-69ead8fb], ul[data-v-69ead8fb], li[data-v-69ead8fb] {
  list-style: none;
}
img[data-v-69ead8fb] {
  border: 0;
  vertical-align: middle;
  pointer-events: none;
}
body[data-v-69ead8fb] {
  color: #000;
  background: #FFF;
}
.clear[data-v-69ead8fb] {
  clear: both;
  height: 1px;
  width: 100%;
  overflow: hidden;
  margin-top: -1px;
}
a[data-v-69ead8fb] {
  color: #000;
  text-decoration: none;
  cursor: pointer;
}
a[data-v-69ead8fb]:hover {
  text-decoration: none;
}
input[data-v-69ead8fb], textarea[data-v-69ead8fb] {
  user-select: auto;
}
input[data-v-69ead8fb]:focus, input[data-v-69ead8fb]:active, textarea[data-v-69ead8fb]:focus, textarea[data-v-69ead8fb]:active {
  outline: none;
}
.chat-aside[data-v-69ead8fb] {
  position: absolute;
  top: 50px;
  right: 0;
  box-sizing: border-box;
  width: 360px !important;
  border-radius: 8px 0 0 8px;
  z-index: 9999;
  max-height: calc(100% - 50px);
}.evaluate[data-v-db4cc488] {
  background: #fff;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
.evaluate-header-content[data-v-db4cc488] {
  font-weight: 500;
  color: #1c1c1c;
}
.evaluate-adv[data-v-db4cc488] {
  font-weight: 500;
  color: #999;
}
.evaluate-adv a[data-v-db4cc488] {
  color: #006eff;
}
.evaluate-content-text[data-v-db4cc488] {
  background: #f8f8f8;
  border: 1px solid #ececec;
}
.evaluate-content-list-item[data-v-db4cc488] {
  font-weight: 400;
  color: #50545c;
}
.evaluate-H5-main[data-v-db4cc488] {
  background: rgba(0, 0, 0, 0.5);
}
.evaluate-H5-main .evaluate-main-content[data-v-db4cc488] {
  background: #fff;
}
.evaluate-H5-main .evaluate-main-content p a[data-v-db4cc488] {
  color: #3370ff;
}
.evaluate-H5-main .evaluate-main-content .close[data-v-db4cc488] {
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: #3370ff;
  letter-spacing: 0;
}
.evaluate[data-v-db4cc488] {
  position: absolute;
  z-index: 5;
  width: 315px;
  top: -255px;
  padding: 12px;
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  background: url("https://web.sdk.qcloud.com/im/assets/images/login-background.png") no-repeat;
  background-color: #fff;
  background-size: cover;
  background-position-x: 128px;
  background-position-y: 77px;
  user-select: none;
}
.evaluate-header-content[data-v-db4cc488] {
  font-style: normal;
  font-size: 12px;
  line-height: 17px;
  text-align: center;
}
.evaluate-content[data-v-db4cc488] {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 12px 0;
}
.evaluate-content-list[data-v-db4cc488] {
  flex: 1;
  display: flex;
}
.evaluate-content-list-item[data-v-db4cc488] {
  width: 24px;
  height: 24px;
  text-align: center;
  cursor: pointer;
  padding: 4px 0;
  font-size: 12px;
  padding-right: 15px;
}
.evaluate-content-list-item[data-v-db4cc488]:last-child {
  padding-right: 0 !important;
}
.evaluate-content-text[data-v-db4cc488] {
  box-sizing: border-box;
  width: 288px;
  height: 90px;
  margin: 12px 0;
  padding: 12px;
  border-radius: 2px;
  resize: none;
}
.evaluate-content-button .btn[data-v-db4cc488] {
  border: none;
  border-radius: 5px;
  font-size: 12px;
  text-align: center;
  line-height: 24px;
  padding: 2px 46px;
  font-weight: 400;
  color: #fff;
}
.evaluate-content-button .btn-valid[data-v-db4cc488] {
  background-color: #3370ff;
  cursor: pointer;
}
.evaluate-content-button .btn-invalid[data-v-db4cc488] {
  background-color: rgb(160, 207, 255);
  cursor: not-allowed;
}
.evaluate-adv[data-v-db4cc488] {
  font-size: 12px;
  text-align: center;
}
.evaluate-adv a[data-v-db4cc488] {
  display: inline-block;
}
.evaluate-h5[data-v-db4cc488] {
  position: static;
  width: 100%;
  height: fit-content;
  border-radius: 0;
  background: #fff;
  padding: 23px !important;
  box-sizing: border-box;
}
.evaluate-h5-header[data-v-db4cc488] {
  display: flex;
  justify-content: space-between;
}
.evaluate-h5-header-content[data-v-db4cc488] {
  font-size: 18px;
}
.evaluate-h5-header-close[data-v-db4cc488] {
  font-size: 18px;
  line-height: 27px;
  font-weight: 400;
  color: #3370ff;
}
.evaluate-h5-content[data-v-db4cc488] {
  order: 1;
}
.evaluate-h5-content-list-item[data-v-db4cc488] {
  width: 40px;
  height: 24px;
  text-align: center;
  cursor: auto;
  font-size: 12px;
}
.evaluate-h5-content-text[data-v-db4cc488] {
  font-size: 16px;
  width: 100%;
}
.evaluate-h5-content-button[data-v-db4cc488] {
  width: 100%;
  display: flex;
}
.evaluate-h5-content-button .btn[data-v-db4cc488] {
  flex: 1;
  padding: 14px 0;
  font-size: 18px;
  cursor: auto;
}
.evaluate-h5-adv[data-v-db4cc488] {
  font-size: 14px;
  font-weight: normal;
  text-align: left;
  color: #000;
}
body[data-v-db4cc488], div[data-v-db4cc488], ul[data-v-db4cc488], ol[data-v-db4cc488], dt[data-v-db4cc488], dd[data-v-db4cc488], li[data-v-db4cc488], dl[data-v-db4cc488], h1[data-v-db4cc488], h2[data-v-db4cc488], h3[data-v-db4cc488], h4[data-v-db4cc488], p[data-v-db4cc488] {
  margin: 0;
  padding: 0;
  font-style: normal;
  /* font:12px/22px"\\5B8B\\4F53",Arial,Helvetica,sans-serif; */
}
ol[data-v-db4cc488], ul[data-v-db4cc488], li[data-v-db4cc488] {
  list-style: none;
}
img[data-v-db4cc488] {
  border: 0;
  vertical-align: middle;
  pointer-events: none;
}
body[data-v-db4cc488] {
  color: #000;
  background: #FFF;
}
.clear[data-v-db4cc488] {
  clear: both;
  height: 1px;
  width: 100%;
  overflow: hidden;
  margin-top: -1px;
}
a[data-v-db4cc488] {
  color: #000;
  text-decoration: none;
  cursor: pointer;
}
a[data-v-db4cc488]:hover {
  text-decoration: none;
}
input[data-v-db4cc488], textarea[data-v-db4cc488] {
  user-select: auto;
}
input[data-v-db4cc488]:focus, input[data-v-db4cc488]:active, textarea[data-v-db4cc488]:focus, textarea[data-v-db4cc488]:active {
  outline: none;
}
.chat-aside[data-v-db4cc488] {
  position: absolute;
  top: 50px;
  right: 0;
  box-sizing: border-box;
  width: 360px !important;
  border-radius: 8px 0 0 8px;
  z-index: 9999;
  max-height: calc(100% - 50px);
}body[data-v-53dcf031], div[data-v-53dcf031], ul[data-v-53dcf031], ol[data-v-53dcf031], dt[data-v-53dcf031], dd[data-v-53dcf031], li[data-v-53dcf031], dl[data-v-53dcf031], h1[data-v-53dcf031], h2[data-v-53dcf031], h3[data-v-53dcf031], h4[data-v-53dcf031], p[data-v-53dcf031] {
  margin: 0;
  padding: 0;
  font-style: normal;
  /* font:12px/22px"\\5B8B\\4F53",Arial,Helvetica,sans-serif; */
}
ol[data-v-53dcf031], ul[data-v-53dcf031], li[data-v-53dcf031] {
  list-style: none;
}
img[data-v-53dcf031] {
  border: 0;
  vertical-align: middle;
  pointer-events: none;
}
body[data-v-53dcf031] {
  color: #000;
  background: #FFF;
}
.clear[data-v-53dcf031] {
  clear: both;
  height: 1px;
  width: 100%;
  overflow: hidden;
  margin-top: -1px;
}
a[data-v-53dcf031] {
  color: #000;
  text-decoration: none;
  cursor: pointer;
}
a[data-v-53dcf031]:hover {
  text-decoration: none;
}
input[data-v-53dcf031], textarea[data-v-53dcf031] {
  user-select: auto;
}
input[data-v-53dcf031]:focus, input[data-v-53dcf031]:active, textarea[data-v-53dcf031]:focus, textarea[data-v-53dcf031]:active {
  outline: none;
}
.chat-aside[data-v-53dcf031] {
  position: absolute;
  top: 50px;
  right: 0;
  box-sizing: border-box;
  width: 360px !important;
  border-radius: 8px 0 0 8px;
  z-index: 9999;
  max-height: calc(100% - 50px);
}
.words[data-v-53dcf031] {
  background-color: #ffffff;
}
.words-header-close[data-v-53dcf031] {
  color: #3370ff;
}
.words[data-v-53dcf031] {
  z-index: 5;
  width: 315px;
  padding: 12px;
  display: flex;
  flex-direction: column;
  width: 19.13rem;
  height: 12.44rem;
  overflow-y: auto;
}
.words-header[data-v-53dcf031] {
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  font-weight: 500;
}
.words-list[data-v-53dcf031] {
  flex: 1;
  display: flex;
  flex-direction: column;
  cursor: pointer;
}
.words-list-item[data-v-53dcf031] {
  cursor: pointer;
  padding: 4px 0;
  font-size: 14px;
  color: #50545c;
  line-height: 18px;
}
.words-list-item[data-v-53dcf031]:hover {
  color: #006eff;
}
.words-h5[data-v-53dcf031] {
  width: 100%;
  box-sizing: border-box;
  max-height: 80vh;
  height: fit-content;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.words-h5-header-title[data-v-53dcf031] {
  font-size: 18px;
  line-height: 40px;
}
.words-h5-list[data-v-53dcf031] {
  flex: 1;
  overflow-y: scroll;
}
.words-h5-list-item[data-v-53dcf031] {
  cursor: none;
  -webkit-tap-highlight-color: transparent;
  -moz-tap-highlight-color: transparent;
  padding: 12px 0;
  font-size: 16px;
  color: #50545c;
  line-height: 18px;
  border-bottom: 1px solid #eeeeee;
}body[data-v-fe51a5a7], div[data-v-fe51a5a7], ul[data-v-fe51a5a7], ol[data-v-fe51a5a7], dt[data-v-fe51a5a7], dd[data-v-fe51a5a7], li[data-v-fe51a5a7], dl[data-v-fe51a5a7], h1[data-v-fe51a5a7], h2[data-v-fe51a5a7], h3[data-v-fe51a5a7], h4[data-v-fe51a5a7], p[data-v-fe51a5a7] {
  margin: 0;
  padding: 0;
  font-style: normal;
  /* font:12px/22px"\\5B8B\\4F53",Arial,Helvetica,sans-serif; */
}
ol[data-v-fe51a5a7], ul[data-v-fe51a5a7], li[data-v-fe51a5a7] {
  list-style: none;
}
img[data-v-fe51a5a7] {
  border: 0;
  vertical-align: middle;
  pointer-events: none;
}
body[data-v-fe51a5a7] {
  color: #000;
  background: #FFF;
}
.clear[data-v-fe51a5a7] {
  clear: both;
  height: 1px;
  width: 100%;
  overflow: hidden;
  margin-top: -1px;
}
a[data-v-fe51a5a7] {
  color: #000;
  text-decoration: none;
  cursor: pointer;
}
a[data-v-fe51a5a7]:hover {
  text-decoration: none;
}
input[data-v-fe51a5a7], textarea[data-v-fe51a5a7] {
  user-select: auto;
}
input[data-v-fe51a5a7]:focus, input[data-v-fe51a5a7]:active, textarea[data-v-fe51a5a7]:focus, textarea[data-v-fe51a5a7]:active {
  outline: none;
}
.chat-aside[data-v-fe51a5a7] {
  position: absolute;
  top: 50px;
  right: 0;
  box-sizing: border-box;
  width: 360px !important;
  border-radius: 8px 0 0 8px;
  z-index: 9999;
  max-height: calc(100% - 50px);
}
.message-input-toolbar[data-v-fe51a5a7] {
  border-top: 1px solid #f4f5f9;
  width: 100%;
  max-width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  user-select: none;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}
.message-input-toolbar-list[data-v-fe51a5a7] {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.message-input-toolbar-list .extension-list[data-v-fe51a5a7] {
  list-style: none;
  display: flex;
}
.message-input-toolbar-list .extension-list-item[data-v-fe51a5a7] {
  width: 20px;
  height: 20px;
  padding: 12px 10px 1px;
  cursor: pointer;
}
.message-input-toolbar-h5[data-v-fe51a5a7] {
  padding: 5px 10px;
  box-sizing: border-box;
  flex-direction: column;
}
.message-input-toolbar-uni[data-v-fe51a5a7] {
  background-color: #ebf0f6;
  flex-direction: column;
}
.message-input-toolbar-uni-list[data-v-fe51a5a7] {
  flex: 1;
  display: grid;
  grid-template-columns: repeat(4, 25%);
  grid-template-rows: repeat(2, 100px);
}body[data-v-5c1ad570], div[data-v-5c1ad570], ul[data-v-5c1ad570], ol[data-v-5c1ad570], dt[data-v-5c1ad570], dd[data-v-5c1ad570], li[data-v-5c1ad570], dl[data-v-5c1ad570], h1[data-v-5c1ad570], h2[data-v-5c1ad570], h3[data-v-5c1ad570], h4[data-v-5c1ad570], p[data-v-5c1ad570] {
  margin: 0;
  padding: 0;
  font-style: normal;
  /* font:12px/22px"\\5B8B\\4F53",Arial,Helvetica,sans-serif; */
}
ol[data-v-5c1ad570], ul[data-v-5c1ad570], li[data-v-5c1ad570] {
  list-style: none;
}
img[data-v-5c1ad570] {
  border: 0;
  vertical-align: middle;
  pointer-events: none;
}
body[data-v-5c1ad570] {
  color: #000;
  background: #FFF;
}
.clear[data-v-5c1ad570] {
  clear: both;
  height: 1px;
  width: 100%;
  overflow: hidden;
  margin-top: -1px;
}
a[data-v-5c1ad570] {
  color: #000;
  text-decoration: none;
  cursor: pointer;
}
a[data-v-5c1ad570]:hover {
  text-decoration: none;
}
input[data-v-5c1ad570], textarea[data-v-5c1ad570] {
  user-select: auto;
}
input[data-v-5c1ad570]:focus, input[data-v-5c1ad570]:active, textarea[data-v-5c1ad570]:focus, textarea[data-v-5c1ad570]:active {
  outline: none;
}
.chat-aside[data-v-5c1ad570] {
  position: absolute;
  top: 50px;
  right: 0;
  box-sizing: border-box;
  width: 360px !important;
  border-radius: 8px 0 0 8px;
  z-index: 9999;
  max-height: calc(100% - 50px);
}
.tui-chat[data-v-5c1ad570] {
  width: 100%;
  height: 100%;
  max-width: 100%;
  overflow: hidden;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  position: relative;
}
.tui-chat-default[data-v-5c1ad570] {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  display: flex;
}
.tui-chat-header[data-v-5c1ad570] {
  padding: 10px;
  box-sizing: border-box;
  display: flex;
}
.tui-chat-message-list[data-v-5c1ad570] {
  flex: 1;
  overflow: hidden;
  display: flex;
}
.tui-chat-leave-group[data-v-5c1ad570] {
  font-size: 14px;
  height: 160px;
  border-top: 1px solid #efefef;
  justify-content: center;
  align-items: center;
}
.tui-chat-leave-group-mobile[data-v-5c1ad570] {
  height: 50px;
}
.tui-chat-message-input[data-v-5c1ad570] {
  height: 160px;
  display: flex;
}
.chat[data-v-5c1ad570] {
  display: block;
  height: 100%;
  overflow: hidden;
}
.tui-chat-h5-message-list[data-v-5c1ad570] {
  flex: 1;
  overflow: hidden;
  display: flex;
}
.tui-chat-h5-message-input[data-v-5c1ad570] {
  height: auto;
  padding: 10px 10px 0;
  border-top: 1px solid #eee;
}
.tui-chat-h5-message-input-toolbar[data-v-5c1ad570] {
  order: 1;
  border: none;
}
.tui-chat-uniapp-header[data-v-5c1ad570] {
  display: none;
}
.group-profile[data-v-5c1ad570] {
  position: absolute;
  top: 14%;
  right: 0;
  width: 50px;
  height: 30px;
  line-height: 30px;
  color: #000;
  font-size: 10px;
  border-top-left-radius: 20px;
  border-bottom-left-radius: 20px;
  padding-left: 15px;
  z-index: 100;
  background-color: #ccc;
  opacity: 0.5;
}
.tui-chat-uni-message-input[data-v-5c1ad570] {
  max-height: 370px;
  padding: 10px;
}
.tui-chat-uni-message-input-toolbar[data-v-5c1ad570] {
  z-index: 100;
}
.tui-chat-wx-message-input[data-v-5c1ad570] {
  padding: 0;
}
[data-v-5c1ad570]:not(not) {
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  min-width: 0;
}`));
      document.head.appendChild(elementStyle);
    }
  } catch (e) {
    console.error("vite-plugin-css-injected-by-js", e);
  }
})();
import ConferenceMainView from "./conference.vue.mjs";
import { default as default2 } from "./preConference.vue.mjs";
import { default as default3 } from "./components/Whiteboard/index.vue.mjs";
export * from "@tencentcloud/tuiroom-engine-js";
import { default as default4 } from "@tencentcloud/tuiroom-engine-js";
import { FeatureButton, RoomEvent, conference } from "./conference.mjs";
import { default as default5 } from "./extension/RoomMessageCard/RoomMessageCard.vue.mjs";
import { chatExtension } from "./extension/chatExtension.mjs";
import "./extension/utils/common.mjs";
import "./services/main.mjs";
import { roomService } from "./services/roomService.mjs";
import { ConfigManager } from "./services/manager/configManager.mjs";
import "./utils/environment.mjs";
import { combineComparators, createComparator } from "./utils/utils.mjs";
import "mitt";
import "./services/manager/roomActionManager.mjs";
import { ScheduleConferenceManager } from "./services/manager/scheduleConferenceManager.mjs";
import "@tencentcloud/tui-core";
import { default as default6 } from "./components/common/base/Dialog/index.mjs";
import { default as default7 } from "./components/common/base/Message/Message.mjs";
import { default as default8 } from "./components/common/base/MessageBox/index.mjs";
import { default as default9 } from "./components/common/base/Notification/index.mjs";
import { default as default10 } from "./components/common/base/Badge.vue.mjs";
import { default as default11 } from "./components/common/base/Button.vue.mjs";
import { default as default12 } from "./components/common/base/Drawer.vue.mjs";
import { default as default13 } from "./components/common/base/IconButton.vue.mjs";
import { default as default14 } from "./components/common/base/Input/index.mjs";
import { default as default15 } from "./components/common/base/Option/index.mjs";
import { default as default16 } from "./components/common/base/PopUpH5.vue.mjs";
import { default as default17 } from "./components/common/base/Select/index.mjs";
import { default as default18 } from "./components/common/base/SvgIcon.vue.mjs";
import { default as default19 } from "./components/common/base/TuiSwitch.vue.mjs";
ConferenceMainView.install = (app) => {
  app.component("ConferenceView", ConferenceMainView);
};
export {
  ConferenceMainView,
  ConfigManager,
  FeatureButton,
  default13 as IconButton,
  default2 as PreConferenceView,
  RoomEvent,
  default5 as RoomMessageCard,
  ScheduleConferenceManager,
  default18 as SvgIcon,
  default4 as TUIRoomEngine,
  default10 as TuiBadge,
  default11 as TuiButton,
  default6 as TuiDialog,
  default12 as TuiDrawer,
  default14 as TuiInput,
  default7 as TuiMessage,
  default8 as TuiMessageBox,
  default9 as TuiNotification,
  default15 as TuiOption,
  default16 as TuiPopUpH5,
  default17 as TuiSelect,
  default19 as TuiSwitch,
  default3 as WhiteboardView,
  chatExtension,
  combineComparators,
  conference,
  createComparator,
  ConferenceMainView as default,
  roomService
};
